// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("fonts/icomoon.eot", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_1___ = new URL("fonts/icomoon.ttf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_2___ = new URL("fonts/icomoon.woff", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_3___ = new URL("fonts/icomoon.svg", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
var ___CSS_LOADER_URL_REPLACEMENT_1___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_1___);
var ___CSS_LOADER_URL_REPLACEMENT_2___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_2___);
var ___CSS_LOADER_URL_REPLACEMENT_3___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_3___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@font-face {
  font-family: 'icomoon';
  src:  url(${___CSS_LOADER_URL_REPLACEMENT_0___});
  src:  url(${___CSS_LOADER_URL_REPLACEMENT_0___}) format('embedded-opentype'),
    url(${___CSS_LOADER_URL_REPLACEMENT_1___}) format('truetype'),
    url(${___CSS_LOADER_URL_REPLACEMENT_2___}) format('woff'),
    url(${___CSS_LOADER_URL_REPLACEMENT_3___}) format('svg');
  font-weight: normal;
  font-style: normal;
  font-display: block;
}
[class^="icon-"], [class*=" icon-"] {
  /* use !important to prevent issues with browser extensions that change fonts */
  /* font-family: 'icomoon' !important; */
  speak: never;
  font-style: normal;
  font-weight: normal;
  font-variant: normal;
  text-transform: none;
  line-height: 1;

  /* Better Font Rendering =========== */
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
}
.icon-Angle-Grinder .path1:before {
  content: "\\e900";
  
  opacity: 0.3;
}
.icon-Angle-Grinder .path2:before {
  content: "\\e901";
  margin-left: -1em;
  
  opacity: 0.3;
}
.icon-Angle-Grinder .path3:before {
  content: "\\e902";
  margin-left: -1em;
  
}
.icon-Axe .path1:before {
  content: "\\e903";
  
  opacity: 0.3;
}
.icon-Axe .path2:before {
  content: "\\e904";
  margin-left: -1em;
  
}
.icon-Brush .path1:before {
  content: "\\e905";
  
  opacity: 0.3;
}
.icon-Brush .path2:before {
  content: "\\e906";
  margin-left: -1em;
  
}
.icon-Compass .path1:before {
  content: "\\e907";
  
  opacity: 0.3;
}
.icon-Compass .path2:before {
  content: "\\e908";
  margin-left: -1em;
  
}
.icon-Hummer .path1:before {
  content: "\\e909";
  
  opacity: 0.3;
}
.icon-Hummer .path2:before {
  content: "\\e90a";
  margin-left: -1em;
  
}
.icon-Hummer .path3:before {
  content: "\\e90b";
  margin-left: -1em;
  
  opacity: 0.3;
}
.icon-Hummer1 .path1:before {
  content: "\\e90c";
  
  opacity: 0.3;
}
.icon-Hummer1 .path2:before {
  content: "\\e90d";
  margin-left: -1em;
  
}
.icon-Pantone .path1:before {
  content: "\\e90e";
  
  opacity: 0.3;
}
.icon-Pantone .path2:before {
  content: "\\e90f";
  margin-left: -1em;
  
  opacity: 0.3;
}
.icon-Pantone .path3:before {
  content: "\\e910";
  margin-left: -1em;
  
}
.icon-Road-Cone .path1:before {
  content: "\\e911";
  
}
.icon-Road-Cone .path2:before {
  content: "\\e912";
  margin-left: -1em;
  
  opacity: 0.3;
}
.icon-Roller .path1:before {
  content: "\\e913";
  
}
.icon-Roller .path2:before {
  content: "\\e914";
  margin-left: -1em;
  
}
.icon-Roller .path3:before {
  content: "\\e915";
  margin-left: -1em;
  
  opacity: 0.3;
}
.icon-Roulette .path1:before {
  content: "\\e916";
  
}
.icon-Roulette .path2:before {
  content: "\\e917";
  margin-left: -1em;
  
  opacity: 0.3;
}
.icon-Screwdriver .path1:before {
  content: "\\e918";
  
  opacity: 0.3;
}
.icon-Screwdriver .path2:before {
  content: "\\e919";
  margin-left: -1em;
  
}
.icon-Shovel1 .path1:before {
  content: "\\e91a";
  
  opacity: 0.3;
}
.icon-Shovel1 .path2:before {
  content: "\\e91b";
  margin-left: -1em;
  
}
.icon-Spatula .path1:before {
  content: "\\e91c";
  
  opacity: 0.3;
}
.icon-Spatula .path2:before {
  content: "\\e91d";
  margin-left: -1em;
  
}
.icon-Swiss-knife .path1:before {
  content: "\\e91e";
  
  opacity: 0.3;
}
.icon-Swiss-knife .path2:before {
  content: "\\e91f";
  margin-left: -1em;
  
}
.icon-Tools .path1:before {
  content: "\\e920";
  
}
.icon-Tools .path2:before {
  content: "\\e921";
  margin-left: -1em;
  
  opacity: 0.3;
}
.icon-Align-auto .path1:before {
  content: "\\e922";
  
  opacity: 0.3;
}
.icon-Align-auto .path2:before {
  content: "\\e923";
  margin-left: -1em;
  
}
.icon-Align-center .path1:before {
  content: "\\e924";
  
  opacity: 0.3;
}
.icon-Align-center .path2:before {
  content: "\\e925";
  margin-left: -1em;
  
}
.icon-Align-justify .path1:before {
  content: "\\e926";
  
  opacity: 0.3;
}
.icon-Align-justify .path2:before {
  content: "\\e927";
  margin-left: -1em;
  
}
.icon-Align-left .path1:before {
  content: "\\e928";
  
  opacity: 0.3;
}
.icon-Align-left .path2:before {
  content: "\\e929";
  margin-left: -1em;
  
  opacity: 0.3;
}
.icon-Align-left .path3:before {
  content: "\\e92a";
  margin-left: -1em;
  
}
.icon-Align-right .path1:before {
  content: "\\e92b";
  
  opacity: 0.3;
}
.icon-Align-right .path2:before {
  content: "\\e92c";
  margin-left: -1em;
  
}
.icon-Article .path1:before {
  content: "\\e92d";
  
}
.icon-Article .path2:before {
  content: "\\e92e";
  margin-left: -1em;
  
  opacity: 0.3;
}
.icon-Bold:before {
  content: "\\e92f";
}
.icon-Bullet-list .path1:before {
  content: "\\e930";
  
}
.icon-Bullet-list .path2:before {
  content: "\\e931";
  margin-left: -1em;
  
  opacity: 0.3;
}
.icon-Code:before {
  content: "\\e932";
}
.icon-Edit-text .path1:before {
  content: "\\e933";
  
  opacity: 0.3;
}
.icon-Edit-text .path2:before {
  content: "\\e934";
  margin-left: -1em;
  
}
.icon-Filter:before {
  content: "\\e935";
}
.icon-Font .path1:before {
  content: "\\e936";
  
}
.icon-Font .path2:before {
  content: "\\e937";
  margin-left: -1em;
  
  opacity: 0.3;
}
.icon-H1 .path1:before {
  content: "\\e938";
  
}
.icon-H1 .path2:before {
  content: "\\e939";
  margin-left: -1em;
  
  opacity: 0.3;
}
.icon-H2 .path1:before {
  content: "\\e93a";
  
}
.icon-H2 .path2:before {
  content: "\\e93b";
  margin-left: -1em;
  
  opacity: 0.3;
}
.icon-Itallic:before {
  content: "\\e93c";
}
.icon-Menu .path1:before {
  content: "\\e93d";
  
}
.icon-Menu .path2:before {
  content: "\\e93e";
  margin-left: -1em;
  
  opacity: 0.3;
}
.icon-Paragraph:before {
  content: "\\e93f";
}
.icon-Quote .path1:before {
  content: "\\e940";
  
}
.icon-Quote .path2:before {
  content: "\\e941";
  margin-left: -1em;
  
  opacity: 0.3;
}
.icon-Quote1 .path1:before {
  content: "\\e942";
  
}
.icon-Quote1 .path2:before {
  content: "\\e943";
  margin-left: -1em;
  
  opacity: 0.3;
}
.icon-Redo:before {
  content: "\\e944";
}
.icon-Strikethrough .path1:before {
  content: "\\e945";
  
  opacity: 0.3;
}
.icon-Strikethrough .path2:before {
  content: "\\e946";
  margin-left: -1em;
  
}
.icon-Text:before {
  content: "\\e947";
}
.icon-Text-height .path1:before {
  content: "\\e948";
  
  opacity: 0.3;
}
.icon-Text-height .path2:before {
  content: "\\e949";
  margin-left: -1em;
  
}
.icon-Text-width .path1:before {
  content: "\\e94a";
  
  opacity: 0.3;
}
.icon-Text-width .path2:before {
  content: "\\e94b";
  margin-left: -1em;
  
}
.icon-Underline .path1:before {
  content: "\\e94c";
  
}
.icon-Underline .path2:before {
  content: "\\e94d";
  margin-left: -1em;
  
  opacity: 0.3;
}
.icon-Undo:before {
  content: "\\e94e";
}
.icon-ATM .path1:before {
  content: "\\e94f";
  
  opacity: 0.3;
}
.icon-ATM .path2:before {
  content: "\\e950";
  margin-left: -1em;
  
}
.icon-Bag .path1:before {
  content: "\\e951";
  
  opacity: 0.3;
}
.icon-Bag .path2:before {
  content: "\\e952";
  margin-left: -1em;
  
}
.icon-Bag1 .path1:before {
  content: "\\e953";
  
  opacity: 0.3;
}
.icon-Bag1 .path2:before {
  content: "\\e954";
  margin-left: -1em;
  
}
.icon-Barcode .path1:before {
  content: "\\e955";
  
}
.icon-Barcode .path2:before {
  content: "\\e956";
  margin-left: -1em;
  
  opacity: 0.3;
}
.icon-Barcode-read .path1:before {
  content: "\\e957";
  
  opacity: 0.3;
}
.icon-Barcode-read .path2:before {
  content: "\\e958";
  margin-left: -1em;
  
}
.icon-Barcode-scan .path1:before {
  content: "\\e959";
  
}
.icon-Barcode-scan .path2:before {
  content: "\\e95a";
  margin-left: -1em;
  
  opacity: 0.3;
}
.icon-Barcode-scan .path3:before {
  content: "\\e95b";
  margin-left: -1em;
  
  opacity: 0.3;
}
.icon-Bitcoin .path1:before {
  content: "\\e95c";
  
  opacity: 0.3;
}
.icon-Bitcoin .path2:before {
  content: "\\e95d";
  margin-left: -1em;
  
  opacity: 0.3;
}
.icon-Bitcoin .path3:before {
  content: "\\e95e";
  margin-left: -1em;
  
}
.icon-Box1 .path1:before {
  content: "\\e95f";
  
  opacity: 0.3;
}
.icon-Box1 .path2:before {
  content: "\\e960";
  margin-left: -1em;
  
}
.icon-Box2 .path1:before {
  content: "\\e961";
  
}
.icon-Box2 .path2:before {
  content: "\\e962";
  margin-left: -1em;
  
  opacity: 0.3;
}
.icon-Box3 .path1:before {
  content: "\\e963";
  
  opacity: 0.3;
}
.icon-Box3 .path2:before {
  content: "\\e964";
  margin-left: -1em;
  
}
.icon-Calculator .path1:before {
  content: "\\e965";
  
  opacity: 0.3;
}
.icon-Calculator .path2:before {
  content: "\\e966";
  margin-left: -1em;
  
}
.icon-Cart1 .path1:before {
  content: "\\e967";
  
  opacity: 0.3;
}
.icon-Cart1 .path2:before {
  content: "\\e968";
  margin-left: -1em;
  
}
.icon-Cart2 .path1:before {
  content: "\\e969";
  
  opacity: 0.3;
}
.icon-Cart2 .path2:before {
  content: "\\e96a";
  margin-left: -1em;
  
}
.icon-Cart .path1:before {
  content: "\\e96b";
  
  opacity: 0.3;
}
.icon-Cart .path2:before {
  content: "\\e96c";
  margin-left: -1em;
  
}
.icon-Chart-bar .path1:before {
  content: "\\e96d";
  
  opacity: 0.3;
}
.icon-Chart-bar .path2:before {
  content: "\\e96e";
  margin-left: -1em;
  
  opacity: 0.3;
}
.icon-Chart-bar .path3:before {
  content: "\\e96f";
  margin-left: -1em;
  
}
.icon-Chart-bar .path4:before {
  content: "\\e970";
  margin-left: -1em;
  
  opacity: 0.3;
}
.icon-Chart-bar1 .path1:before {
  content: "\\e971";
  
  opacity: 0.3;
}
.icon-Chart-bar1 .path2:before {
  content: "\\e972";
  margin-left: -1em;
  
  opacity: 0.3;
}
.icon-Chart-bar1 .path3:before {
  content: "\\e973";
  margin-left: -1em;
  
}
.icon-Chart-bar1 .path4:before {
  content: "\\e974";
  margin-left: -1em;
  
  opacity: 0.3;
}
.icon-Chart-bar2 .path1:before {
  content: "\\e975";
  
  opacity: 0.3;
}
.icon-Chart-bar2 .path2:before {
  content: "\\e976";
  margin-left: -1em;
  
  opacity: 0.3;
}
.icon-Chart-bar2 .path3:before {
  content: "\\e977";
  margin-left: -1em;
  
}
.icon-Chart-bar2 .path4:before {
  content: "\\e978";
  margin-left: -1em;
  
  opacity: 0.3;
}
.icon-Chart-line .path1:before {
  content: "\\e979";
  
}
.icon-Chart-line .path2:before {
  content: "\\e97a";
  margin-left: -1em;
  
  opacity: 0.3;
}
.icon-Chart-line1 .path1:before {
  content: "\\e97b";
  
}
.icon-Chart-line1 .path2:before {
  content: "\\e97c";
  margin-left: -1em;
  
  opacity: 0.3;
}
.icon-Chart-pie .path1:before {
  content: "\\e97d";
  
  opacity: 0.3;
}
.icon-Chart-pie .path2:before {
  content: "\\e97e";
  margin-left: -1em;
  
}
.icon-Credit-card .path1:before {
  content: "\\e97f";
  
  opacity: 0.3;
}
.icon-Credit-card .path2:before {
  content: "\\e980";
  margin-left: -1em;
  
}
.icon-Credit-card .path3:before {
  content: "\\e981";
  margin-left: -1em;
  
  opacity: 0.3;
}
.icon-Dollar .path1:before {
  content: "\\e982";
  
  opacity: 0.3;
}
.icon-Dollar .path2:before {
  content: "\\e983";
  margin-left: -1em;
  
  opacity: 0.3;
}
.icon-Dollar .path3:before {
  content: "\\e984";
  margin-left: -1em;
  
}
.icon-Euro .path1:before {
  content: "\\e985";
  
  opacity: 0.3;
}
.icon-Euro .path2:before {
  content: "\\e986";
  margin-left: -1em;
  
}
.icon-Gift .path1:before {
  content: "\\e987";
  
}
.icon-Gift .path2:before {
  content: "\\e988";
  margin-left: -1em;
  
  opacity: 0.3;
}
.icon-Loader .path1:before {
  content: "\\e989";
  
  opacity: 0.3;
}
.icon-Loader .path2:before {
  content: "\\e98a";
  margin-left: -1em;
  
  opacity: 0.3;
}
.icon-Loader .path3:before {
  content: "\\e98b";
  margin-left: -1em;
  
}
.icon-MC .path1:before {
  content: "\\e98c";
  
  opacity: 0.3;
}
.icon-MC .path2:before {
  content: "\\e98d";
  margin-left: -1em;
  
}
.icon-Money .path1:before {
  content: "\\e98e";
  
  opacity: 0.3;
}
.icon-Money .path2:before {
  content: "\\e98f";
  margin-left: -1em;
  
}
.icon-Pound .path1:before {
  content: "\\e990";
  
}
.icon-Pound .path2:before {
  content: "\\e991";
  margin-left: -1em;
  
  opacity: 0.3;
}
.icon-Price:before {
  content: "\\e992";
}
.icon-145:before {
  content: "\\e992";
}
.icon-Price1:before {
  content: "\\e993";
}
.icon-245:before {
  content: "\\e993";
}
.icon-Rouble .path1:before {
  content: "\\e994";
  
  opacity: 0.3;
}
.icon-Rouble .path2:before {
  content: "\\e995";
  margin-left: -1em;
  
}
.icon-Safe .path1:before {
  content: "\\e996";
  
  opacity: 0.3;
}
.icon-Safe .path2:before {
  content: "\\e997";
  margin-left: -1em;
  
}
.icon-Sale .path1:before {
  content: "\\e998";
  
}
.icon-Sale .path2:before {
  content: "\\e999";
  margin-left: -1em;
  
  opacity: 0.3;
}
.icon-Sale1 .path1:before {
  content: "\\e99a";
  
  opacity: 0.3;
}
.icon-Sale1 .path2:before {
  content: "\\e99b";
  margin-left: -1em;
  
}
.icon-Sale1 .path3:before {
  content: "\\e99c";
  margin-left: -1em;
  
  opacity: 0.3;
}
.icon-Sale1 .path4:before {
  content: "\\e99d";
  margin-left: -1em;
  
  opacity: 0.3;
}
.icon-Settings .path1:before {
  content: "\\e99e";
  
  opacity: 0.3;
}
.icon-Settings .path2:before {
  content: "\\e99f";
  margin-left: -1em;
  
}
.icon-Sort .path1:before {
  content: "\\e9a0";
  
}
.icon-Sort .path2:before {
  content: "\\e9a1";
  margin-left: -1em;
  
  opacity: 0.3;
}
.icon-Sort1:before {
  content: "\\e9a2";
}
.icon-25:before {
  content: "\\e9a2";
}
.icon-Sort2:before {
  content: "\\e9a3";
}
.icon-32:before {
  content: "\\e9a3";
}
.icon-Ticket:before {
  content: "\\e9a4";
}
.icon-Wallet .path1:before {
  content: "\\e9a5";
  
  opacity: 0.3;
}
.icon-Wallet .path2:before {
  content: "\\e9a6";
  margin-left: -1em;
  
}
.icon-Wallet1 .path1:before {
  content: "\\e9a7";
  
  opacity: 0.3;
}
.icon-Wallet1 .path2:before {
  content: "\\e9a8";
  margin-left: -1em;
  
}
.icon-Wallet1 .path3:before {
  content: "\\e9a9";
  margin-left: -1em;
  
}
.icon-Wallet2 .path1:before {
  content: "\\e9aa";
  
  opacity: 0.3;
}
.icon-Wallet2 .path2:before {
  content: "\\e9ab";
  margin-left: -1em;
  
  opacity: 0.3;
}
.icon-Wallet2 .path3:before {
  content: "\\e9ac";
  margin-left: -1em;
  
}
.icon-Angle-up:before {
  content: "\\e9ad";
}
.icon-Angle-double-down .path1:before {
  content: "\\e9ae";
  
}
.icon-Angle-double-down .path2:before {
  content: "\\e9af";
  margin-left: -1em;
  
  opacity: 0.3;
}
.icon-Angle-double-left .path1:before {
  content: "\\e9b0";
  
}
.icon-Angle-double-left .path2:before {
  content: "\\e9b1";
  margin-left: -1em;
  
  opacity: 0.3;
}
.icon-Angle-double-right .path1:before {
  content: "\\e9b2";
  
}
.icon-Angle-double-right .path2:before {
  content: "\\e9b3";
  margin-left: -1em;
  
  opacity: 0.3;
}
.icon-Angle-double-up .path1:before {
  content: "\\e9b4";
  
}
.icon-Angle-double-up .path2:before {
  content: "\\e9b5";
  margin-left: -1em;
  
  opacity: 0.3;
}
.icon-Angle-down:before {
  content: "\\e9b6";
}
.icon-Angle-left:before {
  content: "\\e9b7";
}
.icon-Angle-right:before {
  content: "\\e9b8";
}
.icon-Arrow-down .path1:before {
  content: "\\e9b9";
  
  opacity: 0.3;
}
.icon-Arrow-down .path2:before {
  content: "\\e9ba";
  margin-left: -1em;
  
}
.icon-Arrow-from-bottom .path1:before {
  content: "\\e9bb";
  
  opacity: 0.3;
}
.icon-Arrow-from-bottom .path2:before {
  content: "\\e9bc";
  margin-left: -1em;
  
}
.icon-Arrow-from-bottom .path3:before {
  content: "\\e9bd";
  margin-left: -1em;
  
  opacity: 0.3;
}
.icon-Arrow-from-left .path1:before {
  content: "\\e9be";
  
  opacity: 0.3;
}
.icon-Arrow-from-left .path2:before {
  content: "\\e9bf";
  margin-left: -1em;
  
  opacity: 0.3;
}
.icon-Arrow-from-left .path3:before {
  content: "\\e9c0";
  margin-left: -1em;
  
}
.icon-Arrow-from-right .path1:before {
  content: "\\e9c1";
  
  opacity: 0.3;
}
.icon-Arrow-from-right .path2:before {
  content: "\\e9c2";
  margin-left: -1em;
  
  opacity: 0.3;
}
.icon-Arrow-from-right .path3:before {
  content: "\\e9c3";
  margin-left: -1em;
  
}
.icon-Arrow-from-top .path1:before {
  content: "\\e9c4";
  
  opacity: 0.3;
}
.icon-Arrow-from-top .path2:before {
  content: "\\e9c5";
  margin-left: -1em;
  
}
.icon-Arrow-from-top .path3:before {
  content: "\\e9c6";
  margin-left: -1em;
  
  opacity: 0.3;
}
.icon-Arrow-left .path1:before {
  content: "\\e9c7";
  
  opacity: 0.3;
}
.icon-Arrow-left .path2:before {
  content: "\\e9c8";
  margin-left: -1em;
  
}
.icon-Arrow-right .path1:before {
  content: "\\e9c9";
  
  opacity: 0.3;
}
.icon-Arrow-right .path2:before {
  content: "\\e9ca";
  margin-left: -1em;
  
}
.icon-Arrows-h .path1:before {
  content: "\\e9cb";
  
  opacity: 0.3;
}
.icon-Arrows-h .path2:before {
  content: "\\e9cc";
  margin-left: -1em;
  
}
.icon-Arrows-h .path3:before {
  content: "\\e9cd";
  margin-left: -1em;
  
}
.icon-Arrows-v .path1:before {
  content: "\\e9ce";
  
  opacity: 0.3;
}
.icon-Arrows-v .path2:before {
  content: "\\e9cf";
  margin-left: -1em;
  
}
.icon-Arrows-v .path3:before {
  content: "\\e9d0";
  margin-left: -1em;
  
}
.icon-Arrow-to-bottom .path1:before {
  content: "\\e9d1";
  
  opacity: 0.3;
}
.icon-Arrow-to-bottom .path2:before {
  content: "\\e9d2";
  margin-left: -1em;
  
}
.icon-Arrow-to-bottom .path3:before {
  content: "\\e9d3";
  margin-left: -1em;
  
  opacity: 0.3;
}
.icon-Arrow-to-left .path1:before {
  content: "\\e9d4";
  
  opacity: 0.3;
}
.icon-Arrow-to-left .path2:before {
  content: "\\e9d5";
  margin-left: -1em;
  
  opacity: 0.3;
}
.icon-Arrow-to-left .path3:before {
  content: "\\e9d6";
  margin-left: -1em;
  
}
.icon-Arrow-to-right .path1:before {
  content: "\\e9d7";
  
  opacity: 0.3;
}
.icon-Arrow-to-right .path2:before {
  content: "\\e9d8";
  margin-left: -1em;
  
  opacity: 0.3;
}
.icon-Arrow-to-right .path3:before {
  content: "\\e9d9";
  margin-left: -1em;
  
}
.icon-Arrow-to-up .path1:before {
  content: "\\e9da";
  
  opacity: 0.3;
}
.icon-Arrow-to-up .path2:before {
  content: "\\e9db";
  margin-left: -1em;
  
}
.icon-Arrow-to-up .path3:before {
  content: "\\e9dc";
  margin-left: -1em;
  
  opacity: 0.3;
}
.icon-Arrow-up .path1:before {
  content: "\\e9dd";
  
  opacity: 0.3;
}
.icon-Arrow-up .path2:before {
  content: "\\e9de";
  margin-left: -1em;
  
}
.icon-Check:before {
  content: "\\e9df";
}
.icon-Close .path1:before {
  content: "\\e9e0";
  
}
.icon-Close .path2:before {
  content: "\\e9e1";
  margin-left: -1em;
  
  opacity: 0.3;
}
.icon-Double-check .path1:before {
  content: "\\e9e2";
  
  opacity: 0.3;
}
.icon-Double-check .path2:before {
  content: "\\e9e3";
  margin-left: -1em;
  
}
.icon-Down-2 .path1:before {
  content: "\\e9e4";
  
  opacity: 0.3;
}
.icon-Down-2 .path2:before {
  content: "\\e9e5";
  margin-left: -1em;
  
}
.icon-Down-left .path1:before {
  content: "\\e9e6";
  
  opacity: 0.3;
}
.icon-Down-left .path2:before {
  content: "\\e9e7";
  margin-left: -1em;
  
}
.icon-Down-right .path1:before {
  content: "\\e9e8";
  
  opacity: 0.3;
}
.icon-Down-right .path2:before {
  content: "\\e9e9";
  margin-left: -1em;
  
}
.icon-Exchange .path1:before {
  content: "\\e9ea";
  
  opacity: 0.3;
}
.icon-Exchange .path2:before {
  content: "\\e9eb";
  margin-left: -1em;
  
}
.icon-Exchange .path3:before {
  content: "\\e9ec";
  margin-left: -1em;
  
  opacity: 0.3;
}
.icon-Exchange .path4:before {
  content: "\\e9ed";
  margin-left: -1em;
  
}
.icon-Left-3 .path1:before {
  content: "\\e9ee";
  
}
.icon-Left-3 .path2:before {
  content: "\\e9ef";
  margin-left: -1em;
  
  opacity: 0.3;
}
.icon-Left-2 .path1:before {
  content: "\\e9f0";
  
  opacity: 0.3;
}
.icon-Left-2 .path2:before {
  content: "\\e9f1";
  margin-left: -1em;
  
}
.icon-Minus1:before {
  content: "\\e9f2";
}
.icon-Plus1 .path1:before {
  content: "\\e9f3";
  
}
.icon-Plus1 .path2:before {
  content: "\\e9f4";
  margin-left: -1em;
  
  opacity: 0.3;
}
.icon-Right-3 .path1:before {
  content: "\\e9f5";
  
}
.icon-Right-3 .path2:before {
  content: "\\e9f6";
  margin-left: -1em;
  
  opacity: 0.3;
}
.icon-Right-2 .path1:before {
  content: "\\e9f7";
  
  opacity: 0.3;
}
.icon-Right-2 .path2:before {
  content: "\\e9f8";
  margin-left: -1em;
  
}
.icon-Route .path1:before {
  content: "\\e9f9";
  
  opacity: 0.3;
}
.icon-Route .path2:before {
  content: "\\e9fa";
  margin-left: -1em;
  
}
.icon-Route .path3:before {
  content: "\\e9fb";
  margin-left: -1em;
  
}
.icon-Sign-in .path1:before {
  content: "\\e9fc";
  
  opacity: 0.3;
}
.icon-Sign-in .path2:before {
  content: "\\e9fd";
  margin-left: -1em;
  
  opacity: 0.3;
}
.icon-Sign-in .path3:before {
  content: "\\e9fe";
  margin-left: -1em;
  
}
.icon-Sign-out .path1:before {
  content: "\\e9ff";
  
  opacity: 0.3;
}
.icon-Sign-out .path2:before {
  content: "\\ea00";
  margin-left: -1em;
  
  opacity: 0.3;
}
.icon-Sign-out .path3:before {
  content: "\\ea01";
  margin-left: -1em;
  
}
.icon-Up-2 .path1:before {
  content: "\\ea02";
  
  opacity: 0.3;
}
.icon-Up-2 .path2:before {
  content: "\\ea03";
  margin-left: -1em;
  
}
.icon-Up-down .path1:before {
  content: "\\ea04";
  
  opacity: 0.3;
}
.icon-Up-down .path2:before {
  content: "\\ea05";
  margin-left: -1em;
  
}
.icon-Up-down .path3:before {
  content: "\\ea06";
  margin-left: -1em;
  
  opacity: 0.3;
}
.icon-Up-down .path4:before {
  content: "\\ea07";
  margin-left: -1em;
  
}
.icon-Up-left .path1:before {
  content: "\\ea08";
  
  opacity: 0.3;
}
.icon-Up-left .path2:before {
  content: "\\ea09";
  margin-left: -1em;
  
}
.icon-Up-right .path1:before {
  content: "\\ea0a";
  
  opacity: 0.3;
}
.icon-Up-right .path2:before {
  content: "\\ea0b";
  margin-left: -1em;
  
}
.icon-Waiting:before {
  content: "\\ea0c";
}
.icon-Add-music .path1:before {
  content: "\\ea0d";
  
}
.icon-Add-music .path2:before {
  content: "\\ea0e";
  margin-left: -1em;
  
  opacity: 0.3;
}
.icon-Airplay .path1:before {
  content: "\\ea0f";
  
  opacity: 0.3;
}
.icon-Airplay .path2:before {
  content: "\\ea10";
  margin-left: -1em;
  
}
.icon-Airplay-video .path1:before {
  content: "\\ea11";
  
}
.icon-Airplay-video .path2:before {
  content: "\\ea12";
  margin-left: -1em;
  
  opacity: 0.3;
}
.icon-Back .path1:before {
  content: "\\ea13";
  
}
.icon-Back .path2:before {
  content: "\\ea14";
  margin-left: -1em;
  
  opacity: 0.3;
}
.icon-Backward .path1:before {
  content: "\\ea15";
  
  opacity: 0.3;
}
.icon-Backward .path2:before {
  content: "\\ea16";
  margin-left: -1em;
  
}
.icon-CD .path1:before {
  content: "\\ea17";
  
}
.icon-CD .path2:before {
  content: "\\ea18";
  margin-left: -1em;
  
  opacity: 0.3;
}
.icon-DVD .path1:before {
  content: "\\ea19";
  
  opacity: 0.3;
}
.icon-DVD .path2:before {
  content: "\\ea1a";
  margin-left: -1em;
  
}
.icon-Eject .path1:before {
  content: "\\ea1b";
  
}
.icon-Eject .path2:before {
  content: "\\ea1c";
  margin-left: -1em;
  
  opacity: 0.3;
}
.icon-Equalizer .path1:before {
  content: "\\ea1d";
  
  opacity: 0.3;
}
.icon-Equalizer .path2:before {
  content: "\\ea1e";
  margin-left: -1em;
  
}
.icon-Equalizer .path3:before {
  content: "\\ea1f";
  margin-left: -1em;
  
}
.icon-Equalizer .path4:before {
  content: "\\ea20";
  margin-left: -1em;
  
}
.icon-Forward .path1:before {
  content: "\\ea21";
  
  opacity: 0.3;
}
.icon-Forward .path2:before {
  content: "\\ea22";
  margin-left: -1em;
  
}
.icon-Media-library .path1:before {
  content: "\\ea23";
  
  opacity: 0.3;
}
.icon-Media-library .path2:before {
  content: "\\ea24";
  margin-left: -1em;
  
  opacity: 0.3;
}
.icon-Media-library .path3:before {
  content: "\\ea25";
  margin-left: -1em;
  
  opacity: 0.3;
}
.icon-Media-library .path4:before {
  content: "\\ea26";
  margin-left: -1em;
  
}
.icon-Media-library1 .path1:before {
  content: "\\ea27";
  
  opacity: 0.3;
}
.icon-Media-library1 .path2:before {
  content: "\\ea28";
  margin-left: -1em;
  
}
.icon-Media-library2 .path1:before {
  content: "\\ea29";
  
  opacity: 0.0900;
}
.icon-Media-library2 .path2:before {
  content: "\\ea2a";
  margin-left: -1em;
  
}
.icon-Movie-Lane .path1:before {
  content: "\\ea2b";
  
  opacity: 0.3;
}
.icon-Movie-Lane .path2:before {
  content: "\\ea2c";
  margin-left: -1em;
  
}
.icon-Movie-lane .path1:before {
  content: "\\ea2d";
  
  opacity: 0.3;
}
.icon-Movie-lane .path2:before {
  content: "\\ea2e";
  margin-left: -1em;
  
}
.icon-Music1:before {
  content: "\\ea2f";
}
.icon-Music-cloud .path1:before {
  content: "\\ea30";
  
  opacity: 0.3;
}
.icon-Music-cloud .path2:before {
  content: "\\ea31";
  margin-left: -1em;
  
}
.icon-Music-note:before {
  content: "\\ea32";
}
.icon-Mute .path1:before {
  content: "\\ea33";
  
  opacity: 0.3;
}
.icon-Mute .path2:before {
  content: "\\ea34";
  margin-left: -1em;
  
}
.icon-Next .path1:before {
  content: "\\ea35";
  
}
.icon-Next .path2:before {
  content: "\\ea36";
  margin-left: -1em;
  
  opacity: 0.3;
}
.icon-Pause:before {
  content: "\\ea37";
}
.icon-Play:before {
  content: "\\ea38";
}
.icon-Playlist .path1:before {
  content: "\\ea39";
  
}
.icon-Playlist .path2:before {
  content: "\\ea3a";
  margin-left: -1em;
  
  opacity: 0.3;
}
.icon-Playlist1 .path1:before {
  content: "\\ea3b";
  
  opacity: 0.3;
}
.icon-Playlist1 .path2:before {
  content: "\\ea3c";
  margin-left: -1em;
  
}
.icon-Rec:before {
  content: "\\ea3d";
}
.icon-Repeat .path1:before {
  content: "\\ea3e";
  
}
.icon-Repeat .path2:before {
  content: "\\ea3f";
  margin-left: -1em;
  
  opacity: 0.3;
}
.icon-Repeat-one .path1:before {
  content: "\\ea40";
  
  opacity: 0.3;
}
.icon-Repeat-one .path2:before {
  content: "\\ea41";
  margin-left: -1em;
  
}
.icon-Shuffle .path1:before {
  content: "\\ea42";
  
  opacity: 0.3;
}
.icon-Shuffle .path2:before {
  content: "\\ea43";
  margin-left: -1em;
  
}
.icon-Volume-down .path1:before {
  content: "\\ea44";
  
  opacity: 0.3;
}
.icon-Volume-down .path2:before {
  content: "\\ea45";
  margin-left: -1em;
  
}
.icon-Volume-full .path1:before {
  content: "\\ea46";
  
  opacity: 0.3;
}
.icon-Volume-full .path2:before {
  content: "\\ea47";
  margin-left: -1em;
  
}
.icon-Volume-half .path1:before {
  content: "\\ea48";
  
  opacity: 0.3;
}
.icon-Volume-half .path2:before {
  content: "\\ea49";
  margin-left: -1em;
  
}
.icon-Volume-up .path1:before {
  content: "\\ea4a";
  
  opacity: 0.3;
}
.icon-Volume-up .path2:before {
  content: "\\ea4b";
  margin-left: -1em;
  
}
.icon-Vynil .path1:before {
  content: "\\ea4c";
  
}
.icon-Vynil .path2:before {
  content: "\\ea4d";
  margin-left: -1em;
  
  opacity: 0.3;
}
.icon-Youtube .path1:before {
  content: "\\ea4e";
  
  opacity: 0.3;
}
.icon-Youtube .path2:before {
  content: "\\ea4f";
  margin-left: -1em;
  
}
.icon-Compass1:before {
  content: "\\ea50";
}
.icon-Direction1:before {
  content: "\\ea51";
}
.icon-136:before {
  content: "\\ea51";
}
.icon-Direction:before {
  content: "\\ea52";
}
.icon-228:before {
  content: "\\ea52";
}
.icon-Location-arrow:before {
  content: "\\ea53";
}
.icon-Marker:before {
  content: "\\ea54";
}
.icon-128:before {
  content: "\\ea54";
}
.icon-Marker1:before {
  content: "\\ea55";
}
.icon-229:before {
  content: "\\ea55";
}
.icon-Position1 .path1:before {
  content: "\\ea56";
  
  opacity: 0.3;
}
.icon-Position1 .path2:before {
  content: "\\ea57";
  margin-left: -1em;
  
  opacity: 0.3;
}
.icon-Position1 .path3:before {
  content: "\\ea58";
  margin-left: -1em;
  
}
.icon-Layout-3d .path1:before {
  content: "\\ea59";
  
}
.icon-Layout-3d .path2:before {
  content: "\\ea5a";
  margin-left: -1em;
  
  opacity: 0.3;
}
.icon-Layout-4-blocks .path1:before {
  content: "\\ea5b";
  
}
.icon-Layout-4-blocks .path2:before {
  content: "\\ea5c";
  margin-left: -1em;
  
  opacity: 0.3;
}
.icon-Layout-arrange .path1:before {
  content: "\\ea5d";
  
}
.icon-Layout-arrange .path2:before {
  content: "\\ea5e";
  margin-left: -1em;
  
  opacity: 0.3;
}
.icon-Layout-grid .path1:before {
  content: "\\ea5f";
  
  opacity: 0.3;
}
.icon-Layout-grid .path2:before {
  content: "\\ea60";
  margin-left: -1em;
  
}
.icon-Layout-horizontal .path1:before {
  content: "\\ea61";
  
  opacity: 0.3;
}
.icon-Layout-horizontal .path2:before {
  content: "\\ea62";
  margin-left: -1em;
  
}
.icon-Layout-left-panel-1 .path1:before {
  content: "\\ea63";
  
}
.icon-Layout-left-panel-1 .path2:before {
  content: "\\ea64";
  margin-left: -1em;
  
  opacity: 0.3;
}
.icon-Layout-left-panel-2 .path1:before {
  content: "\\ea65";
  
}
.icon-Layout-left-panel-2 .path2:before {
  content: "\\ea66";
  margin-left: -1em;
  
  opacity: 0.3;
}
.icon-Layout-right-panel-1 .path1:before {
  content: "\\ea67";
  
}
.icon-Layout-right-panel-1 .path2:before {
  content: "\\ea68";
  margin-left: -1em;
  
  opacity: 0.3;
}
.icon-Layout-right-panel-2 .path1:before {
  content: "\\ea69";
  
}
.icon-Layout-right-panel-2 .path2:before {
  content: "\\ea6a";
  margin-left: -1em;
  
  opacity: 0.3;
}
.icon-Layout-top-panel-1 .path1:before {
  content: "\\ea6b";
  
}
.icon-Layout-top-panel-1 .path2:before {
  content: "\\ea6c";
  margin-left: -1em;
  
  opacity: 0.3;
}
.icon-Layout-top-panel-2 .path1:before {
  content: "\\ea6d";
  
}
.icon-Layout-top-panel-2 .path2:before {
  content: "\\ea6e";
  margin-left: -1em;
  
  opacity: 0.3;
}
.icon-Layout-top-panel-3 .path1:before {
  content: "\\ea6f";
  
}
.icon-Layout-top-panel-3 .path2:before {
  content: "\\ea70";
  margin-left: -1em;
  
  opacity: 0.3;
}
.icon-Layout-top-panel-4 .path1:before {
  content: "\\ea71";
  
}
.icon-Layout-top-panel-4 .path2:before {
  content: "\\ea72";
  margin-left: -1em;
  
  opacity: 0.3;
}
.icon-Layout-top-panel-5 .path1:before {
  content: "\\ea73";
  
}
.icon-Layout-top-panel-5 .path2:before {
  content: "\\ea74";
  margin-left: -1em;
  
  opacity: 0.3;
}
.icon-Layout-top-panel-6 .path1:before {
  content: "\\ea75";
  
}
.icon-Layout-top-panel-6 .path2:before {
  content: "\\ea76";
  margin-left: -1em;
  
  opacity: 0.3;
}
.icon-Layout-vertical .path1:before {
  content: "\\ea77";
  
}
.icon-Layout-vertical .path2:before {
  content: "\\ea78";
  margin-left: -1em;
  
  opacity: 0.3;
}
.icon-Air-ballon .path1:before {
  content: "\\ea79";
  
}
.icon-Air-ballon .path2:before {
  content: "\\ea7a";
  margin-left: -1em;
  
  opacity: 0.3;
}
.icon-Alarm-clock .path1:before {
  content: "\\ea7b";
  
}
.icon-Alarm-clock .path2:before {
  content: "\\ea7c";
  margin-left: -1em;
  
  opacity: 0.3;
}
.icon-Alarm-clock .path3:before {
  content: "\\ea7d";
  margin-left: -1em;
  
}
.icon-Armchair .path1:before {
  content: "\\ea7e";
  
  opacity: 0.3;
}
.icon-Armchair .path2:before {
  content: "\\ea7f";
  margin-left: -1em;
  
  opacity: 0.3;
}
.icon-Armchair .path3:before {
  content: "\\ea80";
  margin-left: -1em;
  
}
.icon-Bag-chair:before {
  content: "\\ea81";
}
.icon-Bath .path1:before {
  content: "\\ea82";
  
  opacity: 0.3;
}
.icon-Bath .path2:before {
  content: "\\ea83";
  margin-left: -1em;
  
  opacity: 0.3;
}
.icon-Bath .path3:before {
  content: "\\ea84";
  margin-left: -1em;
  
}
.icon-Bed .path1:before {
  content: "\\ea85";
  
  opacity: 0.3;
}
.icon-Bed .path2:before {
  content: "\\ea86";
  margin-left: -1em;
  
}
.icon-Bed .path3:before {
  content: "\\ea87";
  margin-left: -1em;
  
  opacity: 0.3;
}
.icon-Book:before {
  content: "\\ea88";
}
.icon-Book-open .path1:before {
  content: "\\ea89";
  
}
.icon-Book-open .path2:before {
  content: "\\ea8a";
  margin-left: -1em;
  
  opacity: 0.3;
}
.icon-Box .path1:before {
  content: "\\ea8b";
  
}
.icon-Box .path2:before {
  content: "\\ea8c";
  margin-left: -1em;
  
  opacity: 0.3;
}
.icon-Broom .path1:before {
  content: "\\ea8d";
  
  opacity: 0.3;
}
.icon-Broom .path2:before {
  content: "\\ea8e";
  margin-left: -1em;
  
}
.icon-Building .path1:before {
  content: "\\ea8f";
  
}
.icon-Building .path2:before {
  content: "\\ea90";
  margin-left: -1em;
  color: rgb(255, 255, 255);
}
.icon-Building .path3:before {
  content: "\\ea91";
  margin-left: -1em;
  
  opacity: 0.3;
}
.icon-Bulb .path1:before {
  content: "\\ea92";
  
  opacity: 0.3;
}
.icon-Bulb .path2:before {
  content: "\\ea93";
  margin-left: -1em;
  
  opacity: 0.3;
}
.icon-Bulb .path3:before {
  content: "\\ea94";
  margin-left: -1em;
  
  opacity: 0.3;
}
.icon-Bulb .path4:before {
  content: "\\ea95";
  margin-left: -1em;
  
}
.icon-Bulb1 .path1:before {
  content: "\\ea96";
  
  opacity: 0.3;
}
.icon-Bulb1 .path2:before {
  content: "\\ea97";
  margin-left: -1em;
  
  opacity: 0.3;
}
.icon-Bulb1 .path3:before {
  content: "\\ea98";
  margin-left: -1em;
  
  opacity: 0.3;
}
.icon-Bulb1 .path4:before {
  content: "\\ea99";
  margin-left: -1em;
  
}
.icon-Chair .path1:before {
  content: "\\ea9a";
  
}
.icon-Chair .path2:before {
  content: "\\ea9b";
  margin-left: -1em;
  
  opacity: 0.3;
}
.icon-Chair1 .path1:before {
  content: "\\ea9c";
  
  opacity: 0.3;
}
.icon-Chair1 .path2:before {
  content: "\\ea9d";
  margin-left: -1em;
  
}
.icon-Clock .path1:before {
  content: "\\ea9e";
  
  opacity: 0.3;
}
.icon-Clock .path2:before {
  content: "\\ea9f";
  margin-left: -1em;
  
}
.icon-Commode .path1:before {
  content: "\\eaa0";
  
  opacity: 0.3;
}
.icon-Commode .path2:before {
  content: "\\eaa1";
  margin-left: -1em;
  
}
.icon-Commode1 .path1:before {
  content: "\\eaa2";
  
  opacity: 0.3;
}
.icon-Commode1 .path2:before {
  content: "\\eaa3";
  margin-left: -1em;
  
}
.icon-Couch .path1:before {
  content: "\\eaa4";
  
  opacity: 0.3;
}
.icon-Couch .path2:before {
  content: "\\eaa5";
  margin-left: -1em;
  
  opacity: 0.3;
}
.icon-Couch .path3:before {
  content: "\\eaa6";
  margin-left: -1em;
  
}
.icon-Cupboard .path1:before {
  content: "\\eaa7";
  
  opacity: 0.3;
}
.icon-Cupboard .path2:before {
  content: "\\eaa8";
  margin-left: -1em;
  
}
.icon-Curtains .path1:before {
  content: "\\eaa9";
  
  opacity: 0.3;
}
.icon-Curtains .path2:before {
  content: "\\eaaa";
  margin-left: -1em;
  
}
.icon-Deer .path1:before {
  content: "\\eaab";
  
  opacity: 0.3;
}
.icon-Deer .path2:before {
  content: "\\eaac";
  margin-left: -1em;
  
}
.icon-Door-open .path1:before {
  content: "\\eaad";
  
  opacity: 0.3;
}
.icon-Door-open .path2:before {
  content: "\\eaae";
  margin-left: -1em;
  
}
.icon-Earth:before {
  content: "\\eaaf";
}
.icon-Fireplace .path1:before {
  content: "\\eab0";
  
  opacity: 0.3;
}
.icon-Fireplace .path2:before {
  content: "\\eab1";
  margin-left: -1em;
  
}
.icon-Flashlight .path1:before {
  content: "\\eab2";
  
}
.icon-Flashlight .path2:before {
  content: "\\eab3";
  margin-left: -1em;
  
  opacity: 0.3;
}
.icon-Flower .path1:before {
  content: "\\eab4";
  
  opacity: 0.3;
}
.icon-Flower .path2:before {
  content: "\\eab5";
  margin-left: -1em;
  
  opacity: 0.3;
}
.icon-Flower .path3:before {
  content: "\\eab6";
  margin-left: -1em;
  
  opacity: 0.3;
}
.icon-Flower .path4:before {
  content: "\\eab7";
  margin-left: -1em;
  
}
.icon-Flower1:before {
  content: "\\eab8";
}
.icon-239:before {
  content: "\\eab8";
}
.icon-Flower2:before {
  content: "\\eab9";
}
.icon-38:before {
  content: "\\eab9";
}
.icon-Globe .path1:before {
  content: "\\eaba";
  
}
.icon-Globe .path2:before {
  content: "\\eabb";
  margin-left: -1em;
  
  opacity: 0.3;
}
.icon-Home:before {
  content: "\\eabc";
}
.icon-Home-heart:before {
  content: "\\eabd";
}
.icon-Key .path1:before {
  content: "\\eabe";
  
  opacity: 0.3;
}
.icon-Key .path2:before {
  content: "\\eabf";
  margin-left: -1em;
  
}
.icon-Ladder .path1:before {
  content: "\\eac0";
  
  opacity: 0.3;
}
.icon-Ladder .path2:before {
  content: "\\eac1";
  margin-left: -1em;
  
}
.icon-Lamp .path1:before {
  content: "\\eac2";
  
}
.icon-Lamp .path2:before {
  content: "\\eac3";
  margin-left: -1em;
  
  opacity: 0.3;
}
.icon-Lamp .path3:before {
  content: "\\eac4";
  margin-left: -1em;
  color: rgb(255, 255, 255);
}
.icon-Lamp .path4:before {
  content: "\\eac5";
  margin-left: -1em;
  
}
.icon-Lamp1 .path1:before {
  content: "\\eac6";
  
  opacity: 0.3;
}
.icon-Lamp1 .path2:before {
  content: "\\eac7";
  margin-left: -1em;
  
  opacity: 0.3;
}
.icon-Lamp1 .path3:before {
  content: "\\eac8";
  margin-left: -1em;
  
}
.icon-Library .path1:before {
  content: "\\eac9";
  
}
.icon-Library .path2:before {
  content: "\\eaca";
  margin-left: -1em;
  
  opacity: 0.3;
}
.icon-Mailbox .path1:before {
  content: "\\eacb";
  
}
.icon-Mailbox .path2:before {
  content: "\\eacc";
  margin-left: -1em;
  
  opacity: 0.3;
}
.icon-Mirror .path1:before {
  content: "\\eacd";
  
}
.icon-Mirror .path2:before {
  content: "\\eace";
  margin-left: -1em;
  
  opacity: 0.3;
}
.icon-Picture .path1:before {
  content: "\\eacf";
  
  opacity: 0.3;
}
.icon-Picture .path2:before {
  content: "\\ead0";
  margin-left: -1em;
  
  opacity: 0.3;
}
.icon-Picture .path3:before {
  content: "\\ead1";
  margin-left: -1em;
  
}
.icon-Picture .path4:before {
  content: "\\ead2";
  margin-left: -1em;
  
  opacity: 0.3;
}
.icon-Ruller:before {
  content: "\\ead3";
}
.icon-Stairs:before {
  content: "\\ead4";
}
.icon-Timer .path1:before {
  content: "\\ead5";
  
  opacity: 0.3;
}
.icon-Timer .path2:before {
  content: "\\ead6";
  margin-left: -1em;
  
}
.icon-Timer .path3:before {
  content: "\\ead7";
  margin-left: -1em;
  
}
.icon-Timer .path4:before {
  content: "\\ead8";
  margin-left: -1em;
  
}
.icon-Toilet .path1:before {
  content: "\\ead9";
  
  opacity: 0.3;
}
.icon-Toilet .path2:before {
  content: "\\eada";
  margin-left: -1em;
  
}
.icon-Toilet .path3:before {
  content: "\\eadb";
  margin-left: -1em;
  
  opacity: 0.3;
}
.icon-Towel:before {
  content: "\\eadc";
}
.icon-Trash1 .path1:before {
  content: "\\eadd";
  
}
.icon-Trash1 .path2:before {
  content: "\\eade";
  margin-left: -1em;
  
  opacity: 0.3;
}
.icon-Water-mixer .path1:before {
  content: "\\eadf";
  
  opacity: 0.3;
}
.icon-Water-mixer .path2:before {
  content: "\\eae0";
  margin-left: -1em;
  
}
.icon-Water-mixer .path3:before {
  content: "\\eae1";
  margin-left: -1em;
  
  opacity: 0.3;
}
.icon-Weight .path1:before {
  content: "\\eae2";
  
}
.icon-Weight .path2:before {
  content: "\\eae3";
  margin-left: -1em;
  
  opacity: 0.3;
}
.icon-Weight1 .path1:before {
  content: "\\eae4";
  
  opacity: 0.3;
}
.icon-Weight1 .path2:before {
  content: "\\eae5";
  margin-left: -1em;
  
}
.icon-Wood .path1:before {
  content: "\\eae6";
  
  opacity: 0.3;
}
.icon-Wood .path2:before {
  content: "\\eae7";
  margin-left: -1em;
  
}
.icon-Wood1 .path1:before {
  content: "\\eae8";
  
  opacity: 0.3;
}
.icon-Wood1 .path2:before {
  content: "\\eae9";
  margin-left: -1em;
  
}
.icon-Wood-horse:before {
  content: "\\eaea";
}
.icon-Attachment .path1:before {
  content: "\\eaeb";
  
  opacity: 0.3;
}
.icon-Attachment .path2:before {
  content: "\\eaec";
  margin-left: -1em;
  
}
.icon-Attachment1 .path1:before {
  content: "\\eaed";
  
  opacity: 0.3;
}
.icon-Attachment1 .path2:before {
  content: "\\eaee";
  margin-left: -1em;
  
}
.icon-Attachment1 .path3:before {
  content: "\\eaef";
  margin-left: -1em;
  
  opacity: 0.3;
}
.icon-Attachment1 .path4:before {
  content: "\\eaf0";
  margin-left: -1em;
  
  opacity: 0.3;
}
.icon-Binocular:before {
  content: "\\eaf1";
}
.icon-Bookmark:before {
  content: "\\eaf2";
}
.icon-Clip:before {
  content: "\\eaf3";
}
.icon-Clipboard .path1:before {
  content: "\\eaf4";
  
  opacity: 0.3;
}
.icon-Clipboard .path2:before {
  content: "\\eaf5";
  margin-left: -1em;
  
}
.icon-Clipboard .path3:before {
  content: "\\eaf6";
  margin-left: -1em;
  
  opacity: 0.3;
}
.icon-Clipboard .path4:before {
  content: "\\eaf7";
  margin-left: -1em;
  
  opacity: 0.3;
}
.icon-Cursor:before {
  content: "\\eaf8";
}
.icon-Dislike .path1:before {
  content: "\\eaf9";
  
}
.icon-Dislike .path2:before {
  content: "\\eafa";
  margin-left: -1em;
  
  opacity: 0.3;
}
.icon-Duplicate .path1:before {
  content: "\\eafb";
  
  opacity: 0.3;
}
.icon-Duplicate .path2:before {
  content: "\\eafc";
  margin-left: -1em;
  
}
.icon-Edit1:before {
  content: "\\eafd";
}
.icon-Expand-arrows .path1:before {
  content: "\\eafe";
  
  opacity: 0.3;
}
.icon-Expand-arrows .path2:before {
  content: "\\eaff";
  margin-left: -1em;
  
}
.icon-Fire:before {
  content: "\\eb00";
}
.icon-Folder1:before {
  content: "\\eb01";
}
.icon-Half-heart .path1:before {
  content: "\\eb02";
  
  opacity: 0.3;
}
.icon-Half-heart .path2:before {
  content: "\\eb03";
  margin-left: -1em;
  
}
.icon-Half-star .path1:before {
  content: "\\eb04";
  
  opacity: 0.3;
}
.icon-Half-star .path2:before {
  content: "\\eb05";
  margin-left: -1em;
  
}
.icon-Heart:before {
  content: "\\eb06";
}
.icon-Hidden .path1:before {
  content: "\\eb07";
  
}
.icon-Hidden .path2:before {
  content: "\\eb08";
  margin-left: -1em;
  
}
.icon-Hidden .path3:before {
  content: "\\eb09";
  margin-left: -1em;
  
  opacity: 0.3;
}
.icon-Like .path1:before {
  content: "\\eb0a";
  
}
.icon-Like .path2:before {
  content: "\\eb0b";
  margin-left: -1em;
  
  opacity: 0.3;
}
.icon-Lock:before {
  content: "\\eb0c";
}
.icon-Notification .path1:before {
  content: "\\eb0d";
  
}
.icon-Notification .path2:before {
  content: "\\eb0e";
  margin-left: -1em;
  
  opacity: 0.3;
}
.icon-Notifications .path1:before {
  content: "\\eb0f";
  
}
.icon-Notifications .path2:before {
  content: "\\eb10";
  margin-left: -1em;
  
  opacity: 0.3;
}
.icon-Other:before {
  content: "\\eb11";
}
.icon-133:before {
  content: "\\eb11";
}
.icon-Other1:before {
  content: "\\eb12";
}
.icon-234:before {
  content: "\\eb12";
}
.icon-Sad .path1:before {
  content: "\\eb13";
  
  opacity: 0.3;
}
.icon-Sad .path2:before {
  content: "\\eb14";
  margin-left: -1em;
  
}
.icon-Save .path1:before {
  content: "\\eb15";
  
}
.icon-Save .path2:before {
  content: "\\eb16";
  margin-left: -1em;
  
  opacity: 0.3;
}
.icon-Scale .path1:before {
  content: "\\eb17";
  
}
.icon-Scale .path2:before {
  content: "\\eb18";
  margin-left: -1em;
  
  opacity: 0.3;
}
.icon-Scissors .path1:before {
  content: "\\eb19";
  
  opacity: 0.3;
}
.icon-Scissors .path2:before {
  content: "\\eb1a";
  margin-left: -1em;
  
}
.icon-Search .path1:before {
  content: "\\eb1b";
  
  opacity: 0.3;
}
.icon-Search .path2:before {
  content: "\\eb1c";
  margin-left: -1em;
  
}
.icon-Settings2 .path1:before {
  content: "\\eb1d";
  
  opacity: 0.3;
}
.icon-Settings2 .path2:before {
  content: "\\eb1e";
  margin-left: -1em;
  
}
.icon-Settings-1 .path1:before {
  content: "\\eb1f";
  
}
.icon-Settings-1 .path2:before {
  content: "\\eb20";
  margin-left: -1em;
  
  opacity: 0.3;
}
.icon-Settings-2:before {
  content: "\\eb21";
}
.icon-Shield-check .path1:before {
  content: "\\eb22";
  
  opacity: 0.3;
}
.icon-Shield-check .path2:before {
  content: "\\eb23";
  margin-left: -1em;
  
}
.icon-Shield-disabled .path1:before {
  content: "\\eb24";
  
  opacity: 0.3;
}
.icon-Shield-disabled .path2:before {
  content: "\\eb25";
  margin-left: -1em;
  
}
.icon-Shield-protected .path1:before {
  content: "\\eb26";
  
  opacity: 0.3;
}
.icon-Shield-protected .path2:before {
  content: "\\eb27";
  margin-left: -1em;
  
}
.icon-Size .path1:before {
  content: "\\eb28";
  
}
.icon-Size .path2:before {
  content: "\\eb29";
  margin-left: -1em;
  
  opacity: 0.3;
}
.icon-Smile .path1:before {
  content: "\\eb2a";
  
  opacity: 0.3;
}
.icon-Smile .path2:before {
  content: "\\eb2b";
  margin-left: -1em;
  
}
.icon-Star:before {
  content: "\\eb2c";
}
.icon-Thunder1:before {
  content: "\\eb2d";
}
.icon-Thunder-move .path1:before {
  content: "\\eb2e";
  
}
.icon-Thunder-move .path2:before {
  content: "\\eb2f";
  margin-left: -1em;
  
  opacity: 0.3;
}
.icon-Trash .path1:before {
  content: "\\eb30";
  
}
.icon-Trash .path2:before {
  content: "\\eb31";
  margin-left: -1em;
  
  opacity: 0.3;
}
.icon-Unlock:before {
  content: "\\eb32";
}
.icon-Update:before {
  content: "\\eb33";
}
.icon-User .path1:before {
  content: "\\eb34";
  
  opacity: 0.3;
}
.icon-User .path2:before {
  content: "\\eb35";
  margin-left: -1em;
  
}
.icon-Visible:before {
  content: "\\eb36";
}
.icon-Beer .path1:before {
  content: "\\eb37";
  
  opacity: 0.3;
}
.icon-Beer .path2:before {
  content: "\\eb38";
  margin-left: -1em;
  
  opacity: 0.3;
}
.icon-Beer .path3:before {
  content: "\\eb39";
  margin-left: -1em;
  
  opacity: 0.3;
}
.icon-Beer .path4:before {
  content: "\\eb3a";
  margin-left: -1em;
  
  opacity: 0.3;
}
.icon-Beer .path5:before {
  content: "\\eb3b";
  margin-left: -1em;
  
}
.icon-Bottle .path1:before {
  content: "\\eb3c";
  
}
.icon-Bottle .path2:before {
  content: "\\eb3d";
  margin-left: -1em;
  
  opacity: 0.3;
}
.icon-Bottle1 .path1:before {
  content: "\\eb3e";
  
}
.icon-Bottle1 .path2:before {
  content: "\\eb3f";
  margin-left: -1em;
  
  opacity: 0.3;
}
.icon-Bread .path1:before {
  content: "\\eb40";
  
  opacity: 0.3;
}
.icon-Bread .path2:before {
  content: "\\eb41";
  margin-left: -1em;
  
}
.icon-Bucket1 .path1:before {
  content: "\\eb42";
  
  opacity: 0.3;
}
.icon-Bucket1 .path2:before {
  content: "\\eb43";
  margin-left: -1em;
  
}
.icon-Burger .path1:before {
  content: "\\eb44";
  
}
.icon-Burger .path2:before {
  content: "\\eb45";
  margin-left: -1em;
  
}
.icon-Burger .path3:before {
  content: "\\eb46";
  margin-left: -1em;
  
  opacity: 0.3;
}
.icon-Cake .path1:before {
  content: "\\eb47";
  
}
.icon-Cake .path2:before {
  content: "\\eb48";
  margin-left: -1em;
  
  opacity: 0.3;
}
.icon-Cake .path3:before {
  content: "\\eb49";
  margin-left: -1em;
  
  opacity: 0.3;
}
.icon-Carrot .path1:before {
  content: "\\eb4a";
  
  opacity: 0.3;
}
.icon-Carrot .path2:before {
  content: "\\eb4b";
  margin-left: -1em;
  
  opacity: 0.3;
}
.icon-Carrot .path3:before {
  content: "\\eb4c";
  margin-left: -1em;
  
  opacity: 0.3;
}
.icon-Carrot .path4:before {
  content: "\\eb4d";
  margin-left: -1em;
  
}
.icon-Cheese .path1:before {
  content: "\\eb4e";
  
}
.icon-Cheese .path2:before {
  content: "\\eb4f";
  margin-left: -1em;
  
  opacity: 0.3;
}
.icon-Chicken .path1:before {
  content: "\\eb50";
  
}
.icon-Chicken .path2:before {
  content: "\\eb51";
  margin-left: -1em;
  
  opacity: 0.3;
}
.icon-Coffee .path1:before {
  content: "\\eb52";
  
}
.icon-Coffee .path2:before {
  content: "\\eb53";
  margin-left: -1em;
  
  opacity: 0.3;
}
.icon-Coffee .path3:before {
  content: "\\eb54";
  margin-left: -1em;
  
  opacity: 0.3;
}
.icon-Coffee .path4:before {
  content: "\\eb55";
  margin-left: -1em;
  
  opacity: 0.3;
}
.icon-Coffee .path5:before {
  content: "\\eb56";
  margin-left: -1em;
  
  opacity: 0.3;
}
.icon-Coffee1 .path1:before {
  content: "\\eb57";
  
  opacity: 0.3;
}
.icon-Coffee1 .path2:before {
  content: "\\eb58";
  margin-left: -1em;
  
}
.icon-Coffee1 .path3:before {
  content: "\\eb59";
  margin-left: -1em;
  
  opacity: 0.3;
}
.icon-Cookie:before {
  content: "\\eb5a";
}
.icon-Dinner1 .path1:before {
  content: "\\eb5b";
  
  opacity: 0.3;
}
.icon-Dinner1 .path2:before {
  content: "\\eb5c";
  margin-left: -1em;
  
}
.icon-Fish .path1:before {
  content: "\\eb5d";
  
  opacity: 0.3;
}
.icon-Fish .path2:before {
  content: "\\eb5e";
  margin-left: -1em;
  
}
.icon-French-Bread:before {
  content: "\\eb5f";
}
.icon-Glass-martini .path1:before {
  content: "\\eb60";
  
  opacity: 0.3;
}
.icon-Glass-martini .path2:before {
  content: "\\eb61";
  margin-left: -1em;
  
}
.icon-Ice-cream1 .path1:before {
  content: "\\eb62";
  
  opacity: 0.3;
}
.icon-Ice-cream1 .path2:before {
  content: "\\eb63";
  margin-left: -1em;
  
}
.icon-Ice-cream .path1:before {
  content: "\\eb64";
  
}
.icon-Ice-cream .path2:before {
  content: "\\eb65";
  margin-left: -1em;
  
  opacity: 0.3;
}
.icon-Miso-soup .path1:before {
  content: "\\eb66";
  
}
.icon-Miso-soup .path2:before {
  content: "\\eb67";
  margin-left: -1em;
  
  opacity: 0.3;
}
.icon-Orange .path1:before {
  content: "\\eb68";
  
}
.icon-Orange .path2:before {
  content: "\\eb69";
  margin-left: -1em;
  
  opacity: 0.3;
}
.icon-Pizza:before {
  content: "\\eb6a";
}
.icon-Sushi .path1:before {
  content: "\\eb6b";
  
}
.icon-Sushi .path2:before {
  content: "\\eb6c";
  margin-left: -1em;
  
  opacity: 0.3;
}
.icon-Two-bottles .path1:before {
  content: "\\eb6d";
  
}
.icon-Two-bottles .path2:before {
  content: "\\eb6e";
  margin-left: -1em;
  
  opacity: 0.3;
}
.icon-Wine .path1:before {
  content: "\\eb6f";
  
  opacity: 0.3;
}
.icon-Wine .path2:before {
  content: "\\eb70";
  margin-left: -1em;
  
}
.icon-Cloud-download .path1:before {
  content: "\\eb71";
  
  opacity: 0.3;
}
.icon-Cloud-download .path2:before {
  content: "\\eb72";
  margin-left: -1em;
  
}
.icon-Cloud-upload .path1:before {
  content: "\\eb73";
  
  opacity: 0.3;
}
.icon-Cloud-upload .path2:before {
  content: "\\eb74";
  margin-left: -1em;
  
}
.icon-Compilation .path1:before {
  content: "\\eb75";
  
  opacity: 0.3;
}
.icon-Compilation .path2:before {
  content: "\\eb76";
  margin-left: -1em;
  
  opacity: 0.3;
}
.icon-Compilation .path3:before {
  content: "\\eb77";
  margin-left: -1em;
  
  opacity: 0.3;
}
.icon-Compilation .path4:before {
  content: "\\eb78";
  margin-left: -1em;
  
}
.icon-Compilation .path5:before {
  content: "\\eb79";
  margin-left: -1em;
  
}
.icon-Compiled-file .path1:before {
  content: "\\eb7a";
  
  opacity: 0.3;
}
.icon-Compiled-file .path2:before {
  content: "\\eb7b";
  margin-left: -1em;
  
  opacity: 0.3;
}
.icon-Compiled-file .path3:before {
  content: "\\eb7c";
  margin-left: -1em;
  
  opacity: 0.3;
}
.icon-Compiled-file .path4:before {
  content: "\\eb7d";
  margin-left: -1em;
  
}
.icon-Compiled-file .path5:before {
  content: "\\eb7e";
  margin-left: -1em;
  
}
.icon-Deleted-file .path1:before {
  content: "\\eb7f";
  
  opacity: 0.3;
}
.icon-Deleted-file .path2:before {
  content: "\\eb80";
  margin-left: -1em;
  
}
.icon-Deleted-folder .path1:before {
  content: "\\eb81";
  
  opacity: 0.3;
}
.icon-Deleted-folder .path2:before {
  content: "\\eb82";
  margin-left: -1em;
  
}
.icon-Download .path1:before {
  content: "\\eb83";
  
  opacity: 0.3;
}
.icon-Download .path2:before {
  content: "\\eb84";
  margin-left: -1em;
  
  opacity: 0.3;
}
.icon-Download .path3:before {
  content: "\\eb85";
  margin-left: -1em;
  
}
.icon-Downloaded-file .path1:before {
  content: "\\eb86";
  
  opacity: 0.3;
}
.icon-Downloaded-file .path2:before {
  content: "\\eb87";
  margin-left: -1em;
  
}
.icon-Downloads-folder .path1:before {
  content: "\\eb88";
  
  opacity: 0.3;
}
.icon-Downloads-folder .path2:before {
  content: "\\eb89";
  margin-left: -1em;
  
}
.icon-Export .path1:before {
  content: "\\eb8a";
  
  opacity: 0.3;
}
.icon-Export .path2:before {
  content: "\\eb8b";
  margin-left: -1em;
  
  opacity: 0.3;
}
.icon-Export .path3:before {
  content: "\\eb8c";
  margin-left: -1em;
  
}
.icon-File .path1:before {
  content: "\\eb8d";
  
  opacity: 0.3;
}
.icon-File .path2:before {
  content: "\\eb8e";
  margin-left: -1em;
  
}
.icon-File .path3:before {
  content: "\\eb8f";
  margin-left: -1em;
  
}
.icon-File-cloud .path1:before {
  content: "\\eb90";
  
  opacity: 0.3;
}
.icon-File-cloud .path2:before {
  content: "\\eb91";
  margin-left: -1em;
  
}
.icon-File-done .path1:before {
  content: "\\eb92";
  
  opacity: 0.3;
}
.icon-File-done .path2:before {
  content: "\\eb93";
  margin-left: -1em;
  
}
.icon-File-minus .path1:before {
  content: "\\eb94";
  
  opacity: 0.3;
}
.icon-File-minus .path2:before {
  content: "\\eb95";
  margin-left: -1em;
  
}
.icon-File-plus .path1:before {
  content: "\\eb96";
  
  opacity: 0.3;
}
.icon-File-plus .path2:before {
  content: "\\eb97";
  margin-left: -1em;
  
}
.icon-Folder:before {
  content: "\\eb98";
}
.icon-Folder-check .path1:before {
  content: "\\eb99";
  
  opacity: 0.3;
}
.icon-Folder-check .path2:before {
  content: "\\eb9a";
  margin-left: -1em;
  
}
.icon-Folder-cloud .path1:before {
  content: "\\eb9b";
  
  opacity: 0.3;
}
.icon-Folder-cloud .path2:before {
  content: "\\eb9c";
  margin-left: -1em;
  
}
.icon-Folder-error .path1:before {
  content: "\\eb9d";
  
}
.icon-Folder-error .path2:before {
  content: "\\eb9e";
  margin-left: -1em;
  
  opacity: 0.3;
}
.icon-Folder-heart:before {
  content: "\\eb9f";
}
.icon-Folder-minus .path1:before {
  content: "\\eba0";
  
  opacity: 0.3;
}
.icon-Folder-minus .path2:before {
  content: "\\eba1";
  margin-left: -1em;
  
}
.icon-Folder-plus .path1:before {
  content: "\\eba2";
  
  opacity: 0.3;
}
.icon-Folder-plus .path2:before {
  content: "\\eba3";
  margin-left: -1em;
  
}
.icon-Folder-solid:before {
  content: "\\eba4";
}
.icon-Folder-star:before {
  content: "\\eba5";
}
.icon-Folder-thunder:before {
  content: "\\eba6";
}
.icon-Group-folders .path1:before {
  content: "\\eba7";
  
  opacity: 0.3;
}
.icon-Group-folders .path2:before {
  content: "\\eba8";
  margin-left: -1em;
  
}
.icon-Import .path1:before {
  content: "\\eba9";
  
  opacity: 0.3;
}
.icon-Import .path2:before {
  content: "\\ebaa";
  margin-left: -1em;
  
  opacity: 0.3;
}
.icon-Import .path3:before {
  content: "\\ebab";
  margin-left: -1em;
  
}
.icon-Locked-folder .path1:before {
  content: "\\ebac";
  
  opacity: 0.3;
}
.icon-Locked-folder .path2:before {
  content: "\\ebad";
  margin-left: -1em;
  
}
.icon-Media .path1:before {
  content: "\\ebae";
  
  opacity: 0.3;
}
.icon-Media .path2:before {
  content: "\\ebaf";
  margin-left: -1em;
  
}
.icon-Media-folder .path1:before {
  content: "\\ebb0";
  
  opacity: 0.3;
}
.icon-Media-folder .path2:before {
  content: "\\ebb1";
  margin-left: -1em;
  
}
.icon-Music .path1:before {
  content: "\\ebb2";
  
  opacity: 0.3;
}
.icon-Music .path2:before {
  content: "\\ebb3";
  margin-left: -1em;
  
}
.icon-Pictures .path1:before {
  content: "\\ebb4";
  
  opacity: 0.3;
}
.icon-Pictures .path2:before {
  content: "\\ebb5";
  margin-left: -1em;
  
  opacity: 0.3;
}
.icon-Pictures .path3:before {
  content: "\\ebb6";
  margin-left: -1em;
  
}
.icon-Pictures .path4:before {
  content: "\\ebb7";
  margin-left: -1em;
  
  opacity: 0.3;
}
.icon-Pictures1:before {
  content: "\\ebb8";
}
.icon-221:before {
  content: "\\ebb8";
}
.icon-Protected-file .path1:before {
  content: "\\ebb9";
  
  opacity: 0.3;
}
.icon-Protected-file .path2:before {
  content: "\\ebba";
  margin-left: -1em;
  
}
.icon-Selected-file .path1:before {
  content: "\\ebbb";
  
  opacity: 0.3;
}
.icon-Selected-file .path2:before {
  content: "\\ebbc";
  margin-left: -1em;
  
}
.icon-Share1 .path1:before {
  content: "\\ebbd";
  
}
.icon-Share1 .path2:before {
  content: "\\ebbe";
  margin-left: -1em;
  
  opacity: 0.3;
}
.icon-Share1 .path3:before {
  content: "\\ebbf";
  margin-left: -1em;
  
  opacity: 0.3;
}
.icon-Share1 .path4:before {
  content: "\\ebc0";
  margin-left: -1em;
  
  opacity: 0.3;
}
.icon-Upload .path1:before {
  content: "\\ebc1";
  
  opacity: 0.3;
}
.icon-Upload .path2:before {
  content: "\\ebc2";
  margin-left: -1em;
  
  opacity: 0.3;
}
.icon-Upload .path3:before {
  content: "\\ebc3";
  margin-left: -1em;
  
}
.icon-Uploaded-file .path1:before {
  content: "\\ebc4";
  
  opacity: 0.3;
}
.icon-Uploaded-file .path2:before {
  content: "\\ebc5";
  margin-left: -1em;
  
}
.icon-Upload-folder .path1:before {
  content: "\\ebc6";
  
  opacity: 0.3;
}
.icon-Upload-folder .path2:before {
  content: "\\ebc7";
  margin-left: -1em;
  
}
.icon-User-folder:before {
  content: "\\ebc8";
}
.icon-Air-conditioning .path1:before {
  content: "\\ebc9";
  
}
.icon-Air-conditioning .path2:before {
  content: "\\ebca";
  margin-left: -1em;
  
  opacity: 0.3;
}
.icon-air-dryer .path1:before {
  content: "\\ebcb";
  
  opacity: 0.3;
}
.icon-air-dryer .path2:before {
  content: "\\ebcc";
  margin-left: -1em;
  
}
.icon-Blender .path1:before {
  content: "\\ebcd";
  
}
.icon-Blender .path2:before {
  content: "\\ebce";
  margin-left: -1em;
  
  opacity: 0.3;
}
.icon-Fan:before {
  content: "\\ebcf";
}
.icon-Fridge:before {
  content: "\\ebd0";
}
.icon-Gas-stove .path1:before {
  content: "\\ebd1";
  
}
.icon-Gas-stove .path2:before {
  content: "\\ebd2";
  margin-left: -1em;
  
  opacity: 0.3;
}
.icon-Highvoltage:before {
  content: "\\ebd3";
}
.icon-Iron .path1:before {
  content: "\\ebd4";
  
  opacity: 0.3;
}
.icon-Iron .path2:before {
  content: "\\ebd5";
  margin-left: -1em;
  
}
.icon-Kettle .path1:before {
  content: "\\ebd6";
  
}
.icon-Kettle .path2:before {
  content: "\\ebd7";
  margin-left: -1em;
  
  opacity: 0.3;
}
.icon-Mixer .path1:before {
  content: "\\ebd8";
  
}
.icon-Mixer .path2:before {
  content: "\\ebd9";
  margin-left: -1em;
  
  opacity: 0.3;
}
.icon-Outlet .path1:before {
  content: "\\ebda";
  
  opacity: 0.3;
}
.icon-Outlet .path2:before {
  content: "\\ebdb";
  margin-left: -1em;
  
}
.icon-Range-hood .path1:before {
  content: "\\ebdc";
  
}
.icon-Range-hood .path2:before {
  content: "\\ebdd";
  margin-left: -1em;
  
  opacity: 0.3;
}
.icon-Shutdown .path1:before {
  content: "\\ebde";
  
}
.icon-Shutdown .path2:before {
  content: "\\ebdf";
  margin-left: -1em;
  
  opacity: 0.3;
}
.icon-Socket-eu:before {
  content: "\\ebe0";
}
.icon-Socket-us:before {
  content: "\\ebe1";
}
.icon-Washer .path1:before {
  content: "\\ebe2";
  
}
.icon-Washer .path2:before {
  content: "\\ebe3";
  margin-left: -1em;
  
  opacity: 0.3;
}
.icon-Airpods .path1:before {
  content: "\\ebe4";
  
  opacity: 0.3;
}
.icon-Airpods .path2:before {
  content: "\\ebe5";
  margin-left: -1em;
  
  opacity: 0.3;
}
.icon-Airpods .path3:before {
  content: "\\ebe6";
  margin-left: -1em;
  
}
.icon-Airpods .path4:before {
  content: "\\ebe7";
  margin-left: -1em;
  
}
.icon-Android .path1:before {
  content: "\\ebe8";
  
}
.icon-Android .path2:before {
  content: "\\ebe9";
  margin-left: -1em;
  
  opacity: 0.3;
}
.icon-Apple-Watch .path1:before {
  content: "\\ebea";
  
  opacity: 0.3;
}
.icon-Apple-Watch .path2:before {
  content: "\\ebeb";
  margin-left: -1em;
  
}
.icon-Battery-charging .path1:before {
  content: "\\ebec";
  
}
.icon-Battery-charging .path2:before {
  content: "\\ebed";
  margin-left: -1em;
  
  opacity: 0.3;
}
.icon-Battery-charging .path3:before {
  content: "\\ebee";
  margin-left: -1em;
  
  opacity: 0.3;
}
.icon-Battery-empty .path1:before {
  content: "\\ebef";
  
}
.icon-Battery-empty .path2:before {
  content: "\\ebf0";
  margin-left: -1em;
  
  opacity: 0.3;
}
.icon-Battery-full .path1:before {
  content: "\\ebf1";
  
}
.icon-Battery-full .path2:before {
  content: "\\ebf2";
  margin-left: -1em;
  
  opacity: 0.3;
}
.icon-Battery-half .path1:before {
  content: "\\ebf3";
  
}
.icon-Battery-half .path2:before {
  content: "\\ebf4";
  margin-left: -1em;
  
  opacity: 0.3;
}
.icon-Bluetooth .path1:before {
  content: "\\ebf5";
  
  opacity: 0.3;
}
.icon-Bluetooth .path2:before {
  content: "\\ebf6";
  margin-left: -1em;
  
}
.icon-Camera .path1:before {
  content: "\\ebf7";
  
}
.icon-Camera .path2:before {
  content: "\\ebf8";
  margin-left: -1em;
  
  opacity: 0.3;
}
.icon-Camera .path3:before {
  content: "\\ebf9";
  margin-left: -1em;
  
  opacity: 0.3;
}
.icon-Cardboard-vr .path1:before {
  content: "\\ebfa";
  
  opacity: 0.3;
}
.icon-Cardboard-vr .path2:before {
  content: "\\ebfb";
  margin-left: -1em;
  
}
.icon-Cassete .path1:before {
  content: "\\ebfc";
  
  opacity: 0.3;
}
.icon-Cassete .path2:before {
  content: "\\ebfd";
  margin-left: -1em;
  
}
.icon-Cassete .path3:before {
  content: "\\ebfe";
  margin-left: -1em;
  
}
.icon-CPU .path1:before {
  content: "\\ebff";
  
  opacity: 0.3;
}
.icon-CPU .path2:before {
  content: "\\ec00";
  margin-left: -1em;
  
  opacity: 0.3;
}
.icon-CPU .path3:before {
  content: "\\ec01";
  margin-left: -1em;
  
}
.icon-CPU .path4:before {
  content: "\\ec02";
  margin-left: -1em;
  
}
.icon-CPU .path5:before {
  content: "\\ec03";
  margin-left: -1em;
  
}
.icon-CPU .path6:before {
  content: "\\ec04";
  margin-left: -1em;
  
}
.icon-CPU .path7:before {
  content: "\\ec05";
  margin-left: -1em;
  
}
.icon-CPU .path8:before {
  content: "\\ec06";
  margin-left: -1em;
  
}
.icon-CPU1:before {
  content: "\\ec07";
}
.icon-222:before {
  content: "\\ec07";
}
.icon-Diagnostics .path1:before {
  content: "\\ec08";
  
  opacity: 0.3;
}
.icon-Diagnostics .path2:before {
  content: "\\ec09";
  margin-left: -1em;
  
}
.icon-Diagnostics .path3:before {
  content: "\\ec0a";
  margin-left: -1em;
  
  opacity: 0.3;
}
.icon-Display .path1:before {
  content: "\\ec0b";
  
  opacity: 0.3;
}
.icon-Display .path2:before {
  content: "\\ec0c";
  margin-left: -1em;
  
}
.icon-Display1 .path1:before {
  content: "\\ec0d";
  
  opacity: 0.3;
}
.icon-Display1 .path2:before {
  content: "\\ec0e";
  margin-left: -1em;
  
  opacity: 0.3;
}
.icon-Display1 .path3:before {
  content: "\\ec0f";
  margin-left: -1em;
  
}
.icon-Display2 .path1:before {
  content: "\\ec10";
  
  opacity: 0.3;
}
.icon-Display2 .path2:before {
  content: "\\ec11";
  margin-left: -1em;
  
  opacity: 0.3;
}
.icon-Display2 .path3:before {
  content: "\\ec12";
  margin-left: -1em;
  
}
.icon-Gameboy .path1:before {
  content: "\\ec13";
  
  opacity: 0.3;
}
.icon-Gameboy .path2:before {
  content: "\\ec14";
  margin-left: -1em;
  
}
.icon-Gamepad .path1:before {
  content: "\\ec15";
  
  opacity: 0.3;
}
.icon-Gamepad .path2:before {
  content: "\\ec16";
  margin-left: -1em;
  
}
.icon-Gamepad1 .path1:before {
  content: "\\ec17";
  
  opacity: 0.3;
}
.icon-Gamepad1 .path2:before {
  content: "\\ec18";
  margin-left: -1em;
  
}
.icon-Generator .path1:before {
  content: "\\ec19";
  
  opacity: 0.3;
}
.icon-Generator .path2:before {
  content: "\\ec1a";
  margin-left: -1em;
  
}
.icon-Generator .path3:before {
  content: "\\ec1b";
  margin-left: -1em;
  
}
.icon-Generator .path4:before {
  content: "\\ec1c";
  margin-left: -1em;
  
}
.icon-Hard-drive .path1:before {
  content: "\\ec1d";
  
}
.icon-Hard-drive .path2:before {
  content: "\\ec1e";
  margin-left: -1em;
  
  opacity: 0.3;
}
.icon-Headphones .path1:before {
  content: "\\ec1f";
  
  opacity: 0.3;
}
.icon-Headphones .path2:before {
  content: "\\ec20";
  margin-left: -1em;
  
}
.icon-Homepod .path1:before {
  content: "\\ec21";
  
  opacity: 0.3;
}
.icon-Homepod .path2:before {
  content: "\\ec22";
  margin-left: -1em;
  
}
.icon-iMac .path1:before {
  content: "\\ec23";
  
}
.icon-iMac .path2:before {
  content: "\\ec24";
  margin-left: -1em;
  
  opacity: 0.3;
}
.icon-iMac .path3:before {
  content: "\\ec25";
  margin-left: -1em;
  
  opacity: 0.3;
}
.icon-iPhone-back:before {
  content: "\\ec26";
}
.icon-iPhone-X .path1:before {
  content: "\\ec27";
  
  opacity: 0.3;
}
.icon-iPhone-X .path2:before {
  content: "\\ec28";
  margin-left: -1em;
  
}
.icon-iPhone-x-back:before {
  content: "\\ec29";
}
.icon-Keyboard .path1:before {
  content: "\\ec2a";
  
  opacity: 0.3;
}
.icon-Keyboard .path2:before {
  content: "\\ec2b";
  margin-left: -1em;
  
}
.icon-Laptop .path1:before {
  content: "\\ec2c";
  
}
.icon-Laptop .path2:before {
  content: "\\ec2d";
  margin-left: -1em;
  
  opacity: 0.3;
}
.icon-Laptop-macbook .path1:before {
  content: "\\ec2e";
  
}
.icon-Laptop-macbook .path2:before {
  content: "\\ec2f";
  margin-left: -1em;
  
  opacity: 0.3;
}
.icon-LTE .path1:before {
  content: "\\ec30";
  
  opacity: 0.3;
}
.icon-LTE .path2:before {
  content: "\\ec31";
  margin-left: -1em;
  
}
.icon-LTE1 .path1:before {
  content: "\\ec32";
  
  opacity: 0.3;
}
.icon-LTE1 .path2:before {
  content: "\\ec33";
  margin-left: -1em;
  
}
.icon-Mic .path1:before {
  content: "\\ec34";
  
}
.icon-Mic .path2:before {
  content: "\\ec35";
  margin-left: -1em;
  
  opacity: 0.3;
}
.icon-Midi .path1:before {
  content: "\\ec36";
  
  opacity: 0.3;
}
.icon-Midi .path2:before {
  content: "\\ec37";
  margin-left: -1em;
  
  opacity: 0.3;
}
.icon-Midi .path3:before {
  content: "\\ec38";
  margin-left: -1em;
  
  opacity: 0.3;
}
.icon-Midi .path4:before {
  content: "\\ec39";
  margin-left: -1em;
  
  opacity: 0.3;
}
.icon-Midi .path5:before {
  content: "\\ec3a";
  margin-left: -1em;
  
}
.icon-Midi .path6:before {
  content: "\\ec3b";
  margin-left: -1em;
  
}
.icon-Midi .path7:before {
  content: "\\ec3c";
  margin-left: -1em;
  
}
.icon-Mouse .path1:before {
  content: "\\ec3d";
  
  opacity: 0.3;
}
.icon-Mouse .path2:before {
  content: "\\ec3e";
  margin-left: -1em;
  
}
.icon-Mouse .path3:before {
  content: "\\ec3f";
  margin-left: -1em;
  
}
.icon-Phone .path1:before {
  content: "\\ec40";
  
}
.icon-Phone .path2:before {
  content: "\\ec41";
  margin-left: -1em;
  
  opacity: 0.3;
}
.icon-Phone .path3:before {
  content: "\\ec42";
  margin-left: -1em;
  
}
.icon-Printer .path1:before {
  content: "\\ec43";
  
}
.icon-Printer .path2:before {
  content: "\\ec44";
  margin-left: -1em;
  
  opacity: 0.3;
}
.icon-Radio .path1:before {
  content: "\\ec45";
  
  opacity: 0.3;
}
.icon-Radio .path2:before {
  content: "\\ec46";
  margin-left: -1em;
  
}
.icon-Radio .path3:before {
  content: "\\ec47";
  margin-left: -1em;
  
}
.icon-Radio .path4:before {
  content: "\\ec48";
  margin-left: -1em;
  
  opacity: 0.3;
}
.icon-Radio .path5:before {
  content: "\\ec49";
  margin-left: -1em;
  
  opacity: 0.3;
}
.icon-Router .path1:before {
  content: "\\ec4a";
  
}
.icon-Router .path2:before {
  content: "\\ec4b";
  margin-left: -1em;
  
  opacity: 0.3;
}
.icon-Router1 .path1:before {
  content: "\\ec4c";
  
}
.icon-Router1 .path2:before {
  content: "\\ec4d";
  margin-left: -1em;
  
  opacity: 0.3;
}
.icon-SD-card:before {
  content: "\\ec4e";
}
.icon-Server .path1:before {
  content: "\\ec4f";
  
  opacity: 0.3;
}
.icon-Server .path2:before {
  content: "\\ec50";
  margin-left: -1em;
  
}
.icon-Server .path3:before {
  content: "\\ec51";
  margin-left: -1em;
  
}
.icon-Speaker .path1:before {
  content: "\\ec52";
  
}
.icon-Speaker .path2:before {
  content: "\\ec53";
  margin-left: -1em;
  
  opacity: 0.3;
}
.icon-Tablet .path1:before {
  content: "\\ec54";
  
}
.icon-Tablet .path2:before {
  content: "\\ec55";
  margin-left: -1em;
  
  opacity: 0.3;
}
.icon-TV .path1:before {
  content: "\\ec56";
  
}
.icon-TV .path2:before {
  content: "\\ec57";
  margin-left: -1em;
  
  opacity: 0.3;
}
.icon-TV .path3:before {
  content: "\\ec58";
  margin-left: -1em;
  
  opacity: 0.3;
}
.icon-TV1 .path1:before {
  content: "\\ec59";
  
}
.icon-TV1 .path2:before {
  content: "\\ec5a";
  margin-left: -1em;
  
  opacity: 0.3;
}
.icon-USB .path1:before {
  content: "\\ec5b";
  
}
.icon-USB .path2:before {
  content: "\\ec5c";
  margin-left: -1em;
  
  opacity: 0.3;
}
.icon-USB .path3:before {
  content: "\\ec5d";
  margin-left: -1em;
  
  opacity: 0.3;
}
.icon-Usb-storage .path1:before {
  content: "\\ec5e";
  
}
.icon-Usb-storage .path2:before {
  content: "\\ec5f";
  margin-left: -1em;
  
  opacity: 0.3;
}
.icon-Video-camera .path1:before {
  content: "\\ec60";
  
}
.icon-Video-camera .path2:before {
  content: "\\ec61";
  margin-left: -1em;
  
  opacity: 0.3;
}
.icon-Watch .path1:before {
  content: "\\ec62";
  
}
.icon-Watch .path2:before {
  content: "\\ec63";
  margin-left: -1em;
  
  opacity: 0.3;
}
.icon-Watch .path3:before {
  content: "\\ec64";
  margin-left: -1em;
  
  opacity: 0.3;
}
.icon-Watch .path4:before {
  content: "\\ec65";
  margin-left: -1em;
  
  opacity: 0.3;
}
.icon-Watch1 .path1:before {
  content: "\\ec66";
  
  opacity: 0.3;
}
.icon-Watch1 .path2:before {
  content: "\\ec67";
  margin-left: -1em;
  
  opacity: 0.3;
}
.icon-Watch1 .path3:before {
  content: "\\ec68";
  margin-left: -1em;
  
  opacity: 0.3;
}
.icon-Watch1 .path4:before {
  content: "\\ec69";
  margin-left: -1em;
  
}
.icon-Wi-fi .path1:before {
  content: "\\ec6a";
  
  opacity: 0.3;
}
.icon-Wi-fi .path2:before {
  content: "\\ec6b";
  margin-left: -1em;
  
}
.icon-Adjust:before {
  content: "\\ec6c";
}
.icon-Anchor-center .path1:before {
  content: "\\ec6d";
  
}
.icon-Anchor-center .path2:before {
  content: "\\ec6e";
  margin-left: -1em;
  
  opacity: 0.3;
}
.icon-Anchor-center-down .path1:before {
  content: "\\ec6f";
  
  opacity: 0.3;
}
.icon-Anchor-center-down .path2:before {
  content: "\\ec70";
  margin-left: -1em;
  
}
.icon-Anchor-center-up .path1:before {
  content: "\\ec71";
  
  opacity: 0.3;
}
.icon-Anchor-center-up .path2:before {
  content: "\\ec72";
  margin-left: -1em;
  
}
.icon-Anchor-left .path1:before {
  content: "\\ec73";
  
  opacity: 0.3;
}
.icon-Anchor-left .path2:before {
  content: "\\ec74";
  margin-left: -1em;
  
}
.icon-Anchor-left-down .path1:before {
  content: "\\ec75";
  
  opacity: 0.3;
}
.icon-Anchor-left-down .path2:before {
  content: "\\ec76";
  margin-left: -1em;
  
}
.icon-Anchor-left-up .path1:before {
  content: "\\ec77";
  
  opacity: 0.3;
}
.icon-Anchor-left-up .path2:before {
  content: "\\ec78";
  margin-left: -1em;
  
}
.icon-Anchor-right .path1:before {
  content: "\\ec79";
  
  opacity: 0.3;
}
.icon-Anchor-right .path2:before {
  content: "\\ec7a";
  margin-left: -1em;
  
}
.icon-Anchor-right-down .path1:before {
  content: "\\ec7b";
  
  opacity: 0.3;
}
.icon-Anchor-right-down .path2:before {
  content: "\\ec7c";
  margin-left: -1em;
  
}
.icon-Anchor-right-up .path1:before {
  content: "\\ec7d";
  
  opacity: 0.3;
}
.icon-Anchor-right-up .path2:before {
  content: "\\ec7e";
  margin-left: -1em;
  
}
.icon-Arrows .path1:before {
  content: "\\ec7f";
  
  opacity: 0.3;
}
.icon-Arrows .path2:before {
  content: "\\ec80";
  margin-left: -1em;
  
}
.icon-Bezier-curve .path1:before {
  content: "\\ec81";
  
  opacity: 0.3;
}
.icon-Bezier-curve .path2:before {
  content: "\\ec82";
  margin-left: -1em;
  
}
.icon-Border:before {
  content: "\\ec83";
}
.icon-Brush1 .path1:before {
  content: "\\ec84";
  
}
.icon-Brush1 .path2:before {
  content: "\\ec85";
  margin-left: -1em;
  
  opacity: 0.3;
}
.icon-Bucket .path1:before {
  content: "\\ec86";
  
}
.icon-Bucket .path2:before {
  content: "\\ec87";
  margin-left: -1em;
  
  opacity: 0.3;
}
.icon-Cap-1 .path1:before {
  content: "\\ec88";
  
}
.icon-Cap-1 .path2:before {
  content: "\\ec89";
  margin-left: -1em;
  
  opacity: 0.3;
}
.icon-Cap-2 .path1:before {
  content: "\\ec8a";
  
  opacity: 0.3;
}
.icon-Cap-2 .path2:before {
  content: "\\ec8b";
  margin-left: -1em;
  
}
.icon-Cap-3 .path1:before {
  content: "\\ec8c";
  
}
.icon-Cap-3 .path2:before {
  content: "\\ec8d";
  margin-left: -1em;
  
  opacity: 0.3;
}
.icon-Circle:before {
  content: "\\ec8e";
}
.icon-Color:before {
  content: "\\ec8f";
}
.icon-Color-profile .path1:before {
  content: "\\ec90";
  
  opacity: 0.3;
}
.icon-Color-profile .path2:before {
  content: "\\ec91";
  margin-left: -1em;
  
}
.icon-Component:before {
  content: "\\ec92";
}
.icon-Crop .path1:before {
  content: "\\ec93";
  
  opacity: 0.3;
}
.icon-Crop .path2:before {
  content: "\\ec94";
  margin-left: -1em;
  
}
.icon-Difference .path1:before {
  content: "\\ec95";
  
}
.icon-Difference .path2:before {
  content: "\\ec96";
  margin-left: -1em;
  
  opacity: 0.3;
}
.icon-Edit .path1:before {
  content: "\\ec97";
  
}
.icon-Edit .path2:before {
  content: "\\ec98";
  margin-left: -1em;
  
  opacity: 0.3;
}
.icon-Eraser:before {
  content: "\\ec99";
}
.icon-Flatten .path1:before {
  content: "\\ec9a";
  
}
.icon-Flatten .path2:before {
  content: "\\ec9b";
  margin-left: -1em;
  
  opacity: 0.3;
}
.icon-Flip-horizontal .path1:before {
  content: "\\ec9c";
  
  opacity: 0.3;
}
.icon-Flip-horizontal .path2:before {
  content: "\\ec9d";
  margin-left: -1em;
  
}
.icon-Flip-horizontal .path3:before {
  content: "\\ec9e";
  margin-left: -1em;
  
  opacity: 0.3;
}
.icon-Flip-vertical .path1:before {
  content: "\\ec9f";
  
  opacity: 0.3;
}
.icon-Flip-vertical .path2:before {
  content: "\\eca0";
  margin-left: -1em;
  
}
.icon-Flip-vertical .path3:before {
  content: "\\eca1";
  margin-left: -1em;
  
  opacity: 0.3;
}
.icon-Horizontal .path1:before {
  content: "\\eca2";
  
}
.icon-Horizontal .path2:before {
  content: "\\eca3";
  margin-left: -1em;
  
  opacity: 0.3;
}
.icon-Image:before {
  content: "\\eca4";
}
.icon-Interselect .path1:before {
  content: "\\eca5";
  
  opacity: 0.3;
}
.icon-Interselect .path2:before {
  content: "\\eca6";
  margin-left: -1em;
  
}
.icon-Join-1 .path1:before {
  content: "\\eca7";
  
}
.icon-Join-1 .path2:before {
  content: "\\eca8";
  margin-left: -1em;
  
  opacity: 0.3;
}
.icon-Join-2 .path1:before {
  content: "\\eca9";
  
}
.icon-Join-2 .path2:before {
  content: "\\ecaa";
  margin-left: -1em;
  
  opacity: 0.3;
}
.icon-Join-3 .path1:before {
  content: "\\ecab";
  
  opacity: 0.3;
}
.icon-Join-3 .path2:before {
  content: "\\ecac";
  margin-left: -1em;
  
}
.icon-Layers .path1:before {
  content: "\\ecad";
  
}
.icon-Layers .path2:before {
  content: "\\ecae";
  margin-left: -1em;
  
  opacity: 0.3;
}
.icon-Line .path1:before {
  content: "\\ecaf";
  
  opacity: 0.3;
}
.icon-Line .path2:before {
  content: "\\ecb0";
  margin-left: -1em;
  
}
.icon-Line .path3:before {
  content: "\\ecb1";
  margin-left: -1em;
  
}
.icon-Magic .path1:before {
  content: "\\ecb2";
  
}
.icon-Magic .path2:before {
  content: "\\ecb3";
  margin-left: -1em;
  
  opacity: 0.3;
}
.icon-Mask .path1:before {
  content: "\\ecb4";
  
  opacity: 0.3;
}
.icon-Mask .path2:before {
  content: "\\ecb5";
  margin-left: -1em;
  
}
.icon-Patch .path1:before {
  content: "\\ecb6";
  
}
.icon-Patch .path2:before {
  content: "\\ecb7";
  margin-left: -1em;
  
  opacity: 0.3;
}
.icon-Patch .path3:before {
  content: "\\ecb8";
  margin-left: -1em;
  
  opacity: 0.3;
}
.icon-Penruller .path1:before {
  content: "\\ecb9";
  
  opacity: 0.3;
}
.icon-Penruller .path2:before {
  content: "\\ecba";
  margin-left: -1em;
  
}
.icon-Pencil:before {
  content: "\\ecbb";
}
.icon-Pen-tool-vector .path1:before {
  content: "\\ecbc";
  
}
.icon-Pen-tool-vector .path2:before {
  content: "\\ecbd";
  margin-left: -1em;
  
  opacity: 0.3;
}
.icon-Picker .path1:before {
  content: "\\ecbe";
  
}
.icon-Picker .path2:before {
  content: "\\ecbf";
  margin-left: -1em;
  
  opacity: 0.3;
}
.icon-Pixels .path1:before {
  content: "\\ecc0";
  
}
.icon-Pixels .path2:before {
  content: "\\ecc1";
  margin-left: -1em;
  
}
.icon-Pixels .path3:before {
  content: "\\ecc2";
  margin-left: -1em;
  
}
.icon-Pixels .path4:before {
  content: "\\ecc3";
  margin-left: -1em;
  
  opacity: 0.3;
}
.icon-Pixels .path5:before {
  content: "\\ecc4";
  margin-left: -1em;
  
}
.icon-Pixels .path6:before {
  content: "\\ecc5";
  margin-left: -1em;
  
}
.icon-Polygon:before {
  content: "\\ecc6";
}
.icon-Position:before {
  content: "\\ecc7";
}
.icon-Rectangle:before {
  content: "\\ecc8";
}
.icon-Saturation:before {
  content: "\\ecc9";
}
.icon-Select .path1:before {
  content: "\\ecca";
  
  opacity: 0.3;
}
.icon-Select .path2:before {
  content: "\\eccb";
  margin-left: -1em;
  
}
.icon-Sketch .path1:before {
  content: "\\eccc";
  
  opacity: 0.3;
}
.icon-Sketch .path2:before {
  content: "\\eccd";
  margin-left: -1em;
  
}
.icon-Stamp .path1:before {
  content: "\\ecce";
  
}
.icon-Stamp .path2:before {
  content: "\\eccf";
  margin-left: -1em;
  
  opacity: 0.3;
}
.icon-Substract .path1:before {
  content: "\\ecd0";
  
}
.icon-Substract .path2:before {
  content: "\\ecd1";
  margin-left: -1em;
  
  opacity: 0.3;
}
.icon-Target .path1:before {
  content: "\\ecd2";
  
  opacity: 0.3;
}
.icon-Target .path2:before {
  content: "\\ecd3";
  margin-left: -1em;
  
}
.icon-Triangle:before {
  content: "\\ecd4";
}
.icon-Union:before {
  content: "\\ecd5";
}
.icon-Vertical .path1:before {
  content: "\\ecd6";
  
}
.icon-Vertical .path2:before {
  content: "\\ecd7";
  margin-left: -1em;
  
  opacity: 0.3;
}
.icon-Zoom-minus .path1:before {
  content: "\\ecd8";
  
  opacity: 0.3;
}
.icon-Zoom-minus .path2:before {
  content: "\\ecd9";
  margin-left: -1em;
  
}
.icon-Zoom-minus .path3:before {
  content: "\\ecda";
  margin-left: -1em;
  
  opacity: 0.3;
}
.icon-Zoom-plus .path1:before {
  content: "\\ecdb";
  
  opacity: 0.3;
}
.icon-Zoom-plus .path2:before {
  content: "\\ecdc";
  margin-left: -1em;
  
}
.icon-Zoom-plus .path3:before {
  content: "\\ecdd";
  margin-left: -1em;
  
  opacity: 0.3;
}
.icon-Baking-glove .path1:before {
  content: "\\ecde";
  
}
.icon-Baking-glove .path2:before {
  content: "\\ecdf";
  margin-left: -1em;
  
  opacity: 0.3;
}
.icon-Bowl .path1:before {
  content: "\\ece0";
  
  opacity: 0.3;
}
.icon-Bowl .path2:before {
  content: "\\ece1";
  margin-left: -1em;
  
}
.icon-Chef .path1:before {
  content: "\\ece2";
  
  opacity: 0.3;
}
.icon-Chef .path2:before {
  content: "\\ece3";
  margin-left: -1em;
  
}
.icon-Cooking-book .path1:before {
  content: "\\ece4";
  
  opacity: 0.0900;
}
.icon-Cooking-book .path2:before {
  content: "\\ece5";
  margin-left: -1em;
  
  opacity: 0.3;
}
.icon-Cooking-pot .path1:before {
  content: "\\ece6";
  
  opacity: 0.3;
}
.icon-Cooking-pot .path2:before {
  content: "\\ece7";
  margin-left: -1em;
  
}
.icon-Cutting-board .path1:before {
  content: "\\ece8";
  
  opacity: 0.3;
}
.icon-Cutting-board .path2:before {
  content: "\\ece9";
  margin-left: -1em;
  
}
.icon-Dinner .path1:before {
  content: "\\ecea";
  
  opacity: 0.3;
}
.icon-Dinner .path2:before {
  content: "\\eceb";
  margin-left: -1em;
  
  opacity: 0.3;
}
.icon-Dinner .path3:before {
  content: "\\ecec";
  margin-left: -1em;
  
}
.icon-Dinner .path4:before {
  content: "\\eced";
  margin-left: -1em;
  
}
.icon-Dinner .path5:before {
  content: "\\ecee";
  margin-left: -1em;
  
  opacity: 0.3;
}
.icon-Dish .path1:before {
  content: "\\ecef";
  
}
.icon-Dish .path2:before {
  content: "\\ecf0";
  margin-left: -1em;
  
  opacity: 0.3;
}
.icon-Dishes .path1:before {
  content: "\\ecf1";
  
}
.icon-Dishes .path2:before {
  content: "\\ecf2";
  margin-left: -1em;
  
  opacity: 0.3;
}
.icon-Fork .path1:before {
  content: "\\ecf3";
  
  opacity: 0.3;
}
.icon-Fork .path2:before {
  content: "\\ecf4";
  margin-left: -1em;
  
}
.icon-Fork-spoon .path1:before {
  content: "\\ecf5";
  
}
.icon-Fork-spoon .path2:before {
  content: "\\ecf6";
  margin-left: -1em;
  
  opacity: 0.3;
}
.icon-Fork-spoon .path3:before {
  content: "\\ecf7";
  margin-left: -1em;
  
  opacity: 0.3;
}
.icon-Fork-spoon .path4:before {
  content: "\\ecf8";
  margin-left: -1em;
  
}
.icon-Fork-spoon-knife .path1:before {
  content: "\\ecf9";
  
}
.icon-Fork-spoon-knife .path2:before {
  content: "\\ecfa";
  margin-left: -1em;
  
  opacity: 0.3;
}
.icon-Fork-spoon-knife .path3:before {
  content: "\\ecfb";
  margin-left: -1em;
  
  opacity: 0.3;
}
.icon-Fork-spoon-knife .path4:before {
  content: "\\ecfc";
  margin-left: -1em;
  
}
.icon-Fork-spoon-knife .path5:before {
  content: "\\ecfd";
  margin-left: -1em;
  
  opacity: 0.3;
}
.icon-Fork-spoon-knife .path6:before {
  content: "\\ecfe";
  margin-left: -1em;
  
}
.icon-Frying-pan .path1:before {
  content: "\\ecff";
  
  opacity: 0.3;
}
.icon-Frying-pan .path2:before {
  content: "\\ed00";
  margin-left: -1em;
  
}
.icon-Grater .path1:before {
  content: "\\ed01";
  
  opacity: 0.3;
}
.icon-Grater .path2:before {
  content: "\\ed02";
  margin-left: -1em;
  
}
.icon-Kitchen-scale .path1:before {
  content: "\\ed03";
  
}
.icon-Kitchen-scale .path2:before {
  content: "\\ed04";
  margin-left: -1em;
  
  opacity: 0.3;
}
.icon-Knife .path1:before {
  content: "\\ed05";
  
  opacity: 0.3;
}
.icon-Knife .path2:before {
  content: "\\ed06";
  margin-left: -1em;
  
}
.icon-Knife1 .path1:before {
  content: "\\ed07";
  
  opacity: 0.3;
}
.icon-Knife1 .path2:before {
  content: "\\ed08";
  margin-left: -1em;
  
}
.icon-Knifefork .path1:before {
  content: "\\ed09";
  
}
.icon-Knifefork .path2:before {
  content: "\\ed0a";
  margin-left: -1em;
  
  opacity: 0.3;
}
.icon-Knifefork .path3:before {
  content: "\\ed0b";
  margin-left: -1em;
  
  opacity: 0.3;
}
.icon-Knifefork .path4:before {
  content: "\\ed0c";
  margin-left: -1em;
  
}
.icon-Knifefork1 .path1:before {
  content: "\\ed0d";
  
}
.icon-Knifefork1 .path2:before {
  content: "\\ed0e";
  margin-left: -1em;
  
}
.icon-Knifefork1 .path3:before {
  content: "\\ed0f";
  margin-left: -1em;
  
  opacity: 0.3;
}
.icon-Knifefork1 .path4:before {
  content: "\\ed10";
  margin-left: -1em;
  
  opacity: 0.3;
}
.icon-Ladle .path1:before {
  content: "\\ed11";
  
  opacity: 0.3;
}
.icon-Ladle .path2:before {
  content: "\\ed12";
  margin-left: -1em;
  
}
.icon-Rolling-pin .path1:before {
  content: "\\ed13";
  
}
.icon-Rolling-pin .path2:before {
  content: "\\ed14";
  margin-left: -1em;
  
  opacity: 0.3;
}
.icon-Saucepan .path1:before {
  content: "\\ed15";
  
}
.icon-Saucepan .path2:before {
  content: "\\ed16";
  margin-left: -1em;
  
  opacity: 0.3;
}
.icon-Shovel .path1:before {
  content: "\\ed17";
  
  opacity: 0.3;
}
.icon-Shovel .path2:before {
  content: "\\ed18";
  margin-left: -1em;
  
}
.icon-Sieve .path1:before {
  content: "\\ed19";
  
  opacity: 0.3;
}
.icon-Sieve .path2:before {
  content: "\\ed1a";
  margin-left: -1em;
  
}
.icon-Spoon .path1:before {
  content: "\\ed1b";
  
  opacity: 0.3;
}
.icon-Spoon .path2:before {
  content: "\\ed1c";
  margin-left: -1em;
  
}
.icon-Spoon .path3:before {
  content: "\\ed1d";
  margin-left: -1em;
  color: rgb(255, 255, 255);
}
.icon-Active-call .path1:before {
  content: "\\ed1e";
  
}
.icon-Active-call .path2:before {
  content: "\\ed1f";
  margin-left: -1em;
  
  opacity: 0.3;
}
.icon-Address-card:before {
  content: "\\ed20";
}
.icon-Add-user .path1:before {
  content: "\\ed21";
  
  opacity: 0.3;
}
.icon-Add-user .path2:before {
  content: "\\ed22";
  margin-left: -1em;
  
}
.icon-Adress-book .path1:before {
  content: "\\ed23";
  
  opacity: 0.3;
}
.icon-Adress-book .path2:before {
  content: "\\ed24";
  margin-left: -1em;
  
}
.icon-Adress-book1 .path1:before {
  content: "\\ed25";
  
  opacity: 0.3;
}
.icon-Adress-book1 .path2:before {
  content: "\\ed26";
  margin-left: -1em;
  
}
.icon-Archive:before {
  content: "\\ed27";
}
.icon-Call1:before {
  content: "\\ed28";
}
.icon-118:before {
  content: "\\ed28";
}
.icon-Call:before {
  content: "\\ed29";
}
.icon-Chat .path1:before {
  content: "\\ed2a";
  
  opacity: 0.3;
}
.icon-Chat .path2:before {
  content: "\\ed2b";
  margin-left: -1em;
  
}
.icon-Chat1 .path1:before {
  content: "\\ed2c";
  
  opacity: 0.3;
}
.icon-Chat1 .path2:before {
  content: "\\ed2d";
  margin-left: -1em;
  
}
.icon-Chat2:before {
  content: "\\ed2e";
}
.icon-41:before {
  content: "\\ed2e";
}
.icon-Chat3:before {
  content: "\\ed2f";
}
.icon-51:before {
  content: "\\ed2f";
}
.icon-Chat4:before {
  content: "\\ed30";
}
.icon-6:before {
  content: "\\ed30";
}
.icon-Chat-check .path1:before {
  content: "\\ed31";
  
  opacity: 0.3;
}
.icon-Chat-check .path2:before {
  content: "\\ed32";
  margin-left: -1em;
  
}
.icon-Chat-error .path1:before {
  content: "\\ed33";
  
}
.icon-Chat-error .path2:before {
  content: "\\ed34";
  margin-left: -1em;
  
  opacity: 0.3;
}
.icon-Chat-locked .path1:before {
  content: "\\ed35";
  
  opacity: 0.3;
}
.icon-Chat-locked .path2:before {
  content: "\\ed36";
  margin-left: -1em;
  
}
.icon-Chat-smile .path1:before {
  content: "\\ed37";
  
  opacity: 0.3;
}
.icon-Chat-smile .path2:before {
  content: "\\ed38";
  margin-left: -1em;
  
}
.icon-Clipboard-check .path1:before {
  content: "\\ed39";
  
  opacity: 0.3;
}
.icon-Clipboard-check .path2:before {
  content: "\\ed3a";
  margin-left: -1em;
  
}
.icon-Clipboard-check .path3:before {
  content: "\\ed3b";
  margin-left: -1em;
  
}
.icon-Clipboard-list .path1:before {
  content: "\\ed3c";
  
  opacity: 0.3;
}
.icon-Clipboard-list .path2:before {
  content: "\\ed3d";
  margin-left: -1em;
  
}
.icon-Clipboard-list .path3:before {
  content: "\\ed3e";
  margin-left: -1em;
  
  opacity: 0.3;
}
.icon-Clipboard-list .path4:before {
  content: "\\ed3f";
  margin-left: -1em;
  
  opacity: 0.3;
}
.icon-Clipboard-list .path5:before {
  content: "\\ed40";
  margin-left: -1em;
  
  opacity: 0.3;
}
.icon-Clipboard-list .path6:before {
  content: "\\ed41";
  margin-left: -1em;
  
  opacity: 0.3;
}
.icon-Clipboard-list .path7:before {
  content: "\\ed42";
  margin-left: -1em;
  
  opacity: 0.3;
}
.icon-Clipboard-list .path8:before {
  content: "\\ed43";
  margin-left: -1em;
  
  opacity: 0.3;
}
.icon-Contact:before {
  content: "\\ed44";
}
.icon-110:before {
  content: "\\ed44";
}
.icon-Delete-user .path1:before {
  content: "\\ed45";
  
  opacity: 0.3;
}
.icon-Delete-user .path2:before {
  content: "\\ed46";
  margin-left: -1em;
  
}
.icon-Dial-numbers .path1:before {
  content: "\\ed47";
  
  opacity: 0.3;
}
.icon-Dial-numbers .path2:before {
  content: "\\ed48";
  margin-left: -1em;
  
}
.icon-Dial-numbers .path3:before {
  content: "\\ed49";
  margin-left: -1em;
  
}
.icon-Dial-numbers .path4:before {
  content: "\\ed4a";
  margin-left: -1em;
  
}
.icon-Dial-numbers .path5:before {
  content: "\\ed4b";
  margin-left: -1em;
  
}
.icon-Dial-numbers .path6:before {
  content: "\\ed4c";
  margin-left: -1em;
  
}
.icon-Dial-numbers .path7:before {
  content: "\\ed4d";
  margin-left: -1em;
  
}
.icon-Dial-numbers .path8:before {
  content: "\\ed4e";
  margin-left: -1em;
  
}
.icon-Dial-numbers .path9:before {
  content: "\\ed4f";
  margin-left: -1em;
  
}
.icon-Flag .path1:before {
  content: "\\ed50";
  
}
.icon-Flag .path2:before {
  content: "\\ed51";
  margin-left: -1em;
  
  opacity: 0.3;
}
.icon-Forward1:before {
  content: "\\ed52";
}
.icon-Group .path1:before {
  content: "\\ed53";
  
  opacity: 0.3;
}
.icon-Group .path2:before {
  content: "\\ed54";
  margin-left: -1em;
  
}
.icon-Group-chat .path1:before {
  content: "\\ed55";
  
}
.icon-Group-chat .path2:before {
  content: "\\ed56";
  margin-left: -1em;
  
  opacity: 0.3;
}
.icon-Incoming-box .path1:before {
  content: "\\ed57";
  
}
.icon-Incoming-box .path2:before {
  content: "\\ed58";
  margin-left: -1em;
  
  opacity: 0.3;
}
.icon-Incoming-box .path3:before {
  content: "\\ed59";
  margin-left: -1em;
  
}
.icon-Incoming-call .path1:before {
  content: "\\ed5a";
  
  opacity: 0.3;
}
.icon-Incoming-call .path2:before {
  content: "\\ed5b";
  margin-left: -1em;
  
}
.icon-Incoming-mail .path1:before {
  content: "\\ed5c";
  
}
.icon-Incoming-mail .path2:before {
  content: "\\ed5d";
  margin-left: -1em;
  
  opacity: 0.3;
}
.icon-Mail:before {
  content: "\\ed5e";
}
.icon-Mail-:before {
  content: "\\ed5f";
}
.icon-Mail-attachment .path1:before {
  content: "\\ed60";
  
  opacity: 0.3;
}
.icon-Mail-attachment .path2:before {
  content: "\\ed61";
  margin-left: -1em;
  
}
.icon-Mail-box .path1:before {
  content: "\\ed62";
  
}
.icon-Mail-box .path2:before {
  content: "\\ed63";
  margin-left: -1em;
  
  opacity: 0.3;
}
.icon-Mail-error .path1:before {
  content: "\\ed64";
  
}
.icon-Mail-error .path2:before {
  content: "\\ed65";
  margin-left: -1em;
  
  opacity: 0.3;
}
.icon-Mail-heart .path1:before {
  content: "\\ed66";
  
  opacity: 0.3;
}
.icon-Mail-heart .path2:before {
  content: "\\ed67";
  margin-left: -1em;
  
}
.icon-Mail-locked .path1:before {
  content: "\\ed68";
  
}
.icon-Mail-locked .path2:before {
  content: "\\ed69";
  margin-left: -1em;
  
  opacity: 0.3;
}
.icon-Mail-notification .path1:before {
  content: "\\ed6a";
  
}
.icon-Mail-notification .path2:before {
  content: "\\ed6b";
  margin-left: -1em;
  
  opacity: 0.3;
}
.icon-Mail-opened .path1:before {
  content: "\\ed6c";
  
  opacity: 0.3;
}
.icon-Mail-opened .path2:before {
  content: "\\ed6d";
  margin-left: -1em;
  
}
.icon-Mail-unocked .path1:before {
  content: "\\ed6e";
  
  opacity: 0.3;
}
.icon-Mail-unocked .path2:before {
  content: "\\ed6f";
  margin-left: -1em;
  
}
.icon-Missed-call .path1:before {
  content: "\\ed70";
  
  opacity: 0.3;
}
.icon-Missed-call .path2:before {
  content: "\\ed71";
  margin-left: -1em;
  
}
.icon-Outgoing-box .path1:before {
  content: "\\ed72";
  
}
.icon-Outgoing-box .path2:before {
  content: "\\ed73";
  margin-left: -1em;
  
  opacity: 0.3;
}
.icon-Outgoing-box .path3:before {
  content: "\\ed74";
  margin-left: -1em;
  
}
.icon-Outgoing-call .path1:before {
  content: "\\ed75";
  
  opacity: 0.3;
}
.icon-Outgoing-call .path2:before {
  content: "\\ed76";
  margin-left: -1em;
  
}
.icon-Outgoing-mail .path1:before {
  content: "\\ed77";
  
}
.icon-Outgoing-mail .path2:before {
  content: "\\ed78";
  margin-left: -1em;
  
  opacity: 0.3;
}
.icon-Readed-mail .path1:before {
  content: "\\ed79";
  
  opacity: 0.3;
}
.icon-Readed-mail .path2:before {
  content: "\\ed7a";
  margin-left: -1em;
  
}
.icon-Reply:before {
  content: "\\ed7b";
}
.icon-Reply-all .path1:before {
  content: "\\ed7c";
  
  opacity: 0.3;
}
.icon-Reply-all .path2:before {
  content: "\\ed7d";
  margin-left: -1em;
  
}
.icon-Right:before {
  content: "\\ed7e";
}
.icon-RSS .path1:before {
  content: "\\ed7f";
  
}
.icon-RSS .path2:before {
  content: "\\ed80";
  margin-left: -1em;
  
  opacity: 0.3;
}
.icon-RSS .path3:before {
  content: "\\ed81";
  margin-left: -1em;
  
  opacity: 0.3;
}
.icon-Safe-chat .path1:before {
  content: "\\ed82";
  
  opacity: 0.3;
}
.icon-Safe-chat .path2:before {
  content: "\\ed83";
  margin-left: -1em;
  
}
.icon-Send:before {
  content: "\\ed84";
}
.icon-Sending-mail .path1:before {
  content: "\\ed85";
  
  opacity: 0.3;
}
.icon-Sending-mail .path2:before {
  content: "\\ed86";
  margin-left: -1em;
  
}
.icon-Sending .path1:before {
  content: "\\ed87";
  
}
.icon-Sending .path2:before {
  content: "\\ed88";
  margin-left: -1em;
  
  opacity: 0.3;
}
.icon-Share .path1:before {
  content: "\\ed89";
  
  opacity: 0.3;
}
.icon-Share .path2:before {
  content: "\\ed8a";
  margin-left: -1em;
  
}
.icon-Shield-thunder:before {
  content: "\\ed8b";
}
.icon-Shield-user:before {
  content: "\\ed8c";
}
.icon-Snoozed-mail .path1:before {
  content: "\\ed8d";
  
}
.icon-Snoozed-mail .path2:before {
  content: "\\ed8e";
  margin-left: -1em;
  
  opacity: 0.3;
}
.icon-Spam:before {
  content: "\\ed8f";
}
.icon-Thumbtack .path1:before {
  content: "\\ed90";
  
}
.icon-Thumbtack .path2:before {
  content: "\\ed91";
  margin-left: -1em;
  
  opacity: 0.3;
}
.icon-Urgent-mail .path1:before {
  content: "\\ed92";
  
  opacity: 0.3;
}
.icon-Urgent-mail .path2:before {
  content: "\\ed93";
  margin-left: -1em;
  
}
.icon-Write .path1:before {
  content: "\\ed94";
  
}
.icon-Write .path2:before {
  content: "\\ed95";
  margin-left: -1em;
  
  opacity: 0.3;
}
.icon-Backspace .path1:before {
  content: "\\ed96";
  
  opacity: 0.3;
}
.icon-Backspace .path2:before {
  content: "\\ed97";
  margin-left: -1em;
  
}
.icon-CMD:before {
  content: "\\ed98";
}
.icon-Code1 .path1:before {
  content: "\\ed99";
  
}
.icon-Code1 .path2:before {
  content: "\\ed9a";
  margin-left: -1em;
  
  opacity: 0.3;
}
.icon-Commit .path1:before {
  content: "\\ed9b";
  
  opacity: 0.3;
}
.icon-Commit .path2:before {
  content: "\\ed9c";
  margin-left: -1em;
  
}
.icon-Compiling .path1:before {
  content: "\\ed9d";
  
  opacity: 0.3;
}
.icon-Compiling .path2:before {
  content: "\\ed9e";
  margin-left: -1em;
  
}
.icon-Control:before {
  content: "\\ed9f";
}
.icon-Done-circle .path1:before {
  content: "\\eda0";
  
  opacity: 0.3;
}
.icon-Done-circle .path2:before {
  content: "\\eda1";
  margin-left: -1em;
  
}
.icon-Error-circle .path1:before {
  content: "\\eda2";
  
  opacity: 0.3;
}
.icon-Error-circle .path2:before {
  content: "\\eda3";
  margin-left: -1em;
  
}
.icon-Git2 .path1:before {
  content: "\\eda4";
  
  opacity: 0.3;
}
.icon-Git2 .path2:before {
  content: "\\eda5";
  margin-left: -1em;
  
}
.icon-Git2 .path3:before {
  content: "\\eda6";
  margin-left: -1em;
  
}
.icon-Git3 .path1:before {
  content: "\\eda7";
  
  opacity: 0.3;
}
.icon-Git3 .path2:before {
  content: "\\eda8";
  margin-left: -1em;
  
}
.icon-Git3 .path3:before {
  content: "\\eda9";
  margin-left: -1em;
  
  opacity: 0.3;
}
.icon-Git3 .path4:before {
  content: "\\edaa";
  margin-left: -1em;
  
}
.icon-Git3 .path5:before {
  content: "\\edab";
  margin-left: -1em;
  
}
.icon-Git3 .path6:before {
  content: "\\edac";
  margin-left: -1em;
  
}
.icon-Git .path1:before {
  content: "\\edad";
  
  opacity: 0.3;
}
.icon-Git .path2:before {
  content: "\\edae";
  margin-left: -1em;
  
}
.icon-Git .path3:before {
  content: "\\edaf";
  margin-left: -1em;
  
}
.icon-Git .path4:before {
  content: "\\edb0";
  margin-left: -1em;
  
}
.icon-Git1 .path1:before {
  content: "\\edb1";
  
}
.icon-Git1 .path2:before {
  content: "\\edb2";
  margin-left: -1em;
  
  opacity: 0.3;
}
.icon-Git1 .path3:before {
  content: "\\edb3";
  margin-left: -1em;
  
}
.icon-Git1 .path4:before {
  content: "\\edb4";
  margin-left: -1em;
  
}
.icon-Github .path1:before {
  content: "\\edb5";
  
}
.icon-Github .path2:before {
  content: "\\edb6";
  margin-left: -1em;
  
  opacity: 0.3;
}
.icon-Info-circle .path1:before {
  content: "\\edb7";
  
  opacity: 0.3;
}
.icon-Info-circle .path2:before {
  content: "\\edb8";
  margin-left: -1em;
  
}
.icon-Info-circle .path3:before {
  content: "\\edb9";
  margin-left: -1em;
  
}
.icon-Left-circle .path1:before {
  content: "\\edba";
  
  opacity: 0.3;
}
.icon-Left-circle .path2:before {
  content: "\\edbb";
  margin-left: -1em;
  
}
.icon-Loading:before {
  content: "\\edbc";
}
.icon-Lock-circle .path1:before {
  content: "\\edbd";
  
  opacity: 0.3;
}
.icon-Lock-circle .path2:before {
  content: "\\edbe";
  margin-left: -1em;
  
}
.icon-Lock-overturning .path1:before {
  content: "\\edbf";
  
  opacity: 0.3;
}
.icon-Lock-overturning .path2:before {
  content: "\\edc0";
  margin-left: -1em;
  
}
.icon-Minus .path1:before {
  content: "\\edc1";
  
  opacity: 0.3;
}
.icon-Minus .path2:before {
  content: "\\edc2";
  margin-left: -1em;
  
}
.icon-Option .path1:before {
  content: "\\edc3";
  
  opacity: 0.3;
}
.icon-Option .path2:before {
  content: "\\edc4";
  margin-left: -1em;
  
}
.icon-Plus .path1:before {
  content: "\\edc5";
  
  opacity: 0.3;
}
.icon-Plus .path2:before {
  content: "\\edc6";
  margin-left: -1em;
  
}
.icon-Puzzle:before {
  content: "\\edc7";
}
.icon-Question-circle .path1:before {
  content: "\\edc8";
  
  opacity: 0.3;
}
.icon-Question-circle .path2:before {
  content: "\\edc9";
  margin-left: -1em;
  
}
.icon-Right-circle .path1:before {
  content: "\\edca";
  
  opacity: 0.3;
}
.icon-Right-circle .path2:before {
  content: "\\edcb";
  margin-left: -1em;
  
}
.icon-Settings1 .path1:before {
  content: "\\edcc";
  
  opacity: 0.3;
}
.icon-Settings1 .path2:before {
  content: "\\edcd";
  margin-left: -1em;
  
}
.icon-Shift:before {
  content: "\\edce";
}
.icon-Spy .path1:before {
  content: "\\edcf";
  
}
.icon-Spy .path2:before {
  content: "\\edd0";
  margin-left: -1em;
  
  opacity: 0.3;
}
.icon-Stop:before {
  content: "\\edd1";
}
.icon-Terminal .path1:before {
  content: "\\edd2";
  
}
.icon-Terminal .path2:before {
  content: "\\edd3";
  margin-left: -1em;
  
  opacity: 0.3;
}
.icon-Thunder-circle .path1:before {
  content: "\\edd4";
  
  opacity: 0.3;
}
.icon-Thunder-circle .path2:before {
  content: "\\edd5";
  margin-left: -1em;
  
}
.icon-Time-schedule .path1:before {
  content: "\\edd6";
  
}
.icon-Time-schedule .path2:before {
  content: "\\edd7";
  margin-left: -1em;
  
  opacity: 0.3;
}
.icon-Warning-1-circle .path1:before {
  content: "\\edd8";
  
  opacity: 0.3;
}
.icon-Warning-1-circle .path2:before {
  content: "\\edd9";
  margin-left: -1em;
  
}
.icon-Warning-1-circle .path3:before {
  content: "\\edda";
  margin-left: -1em;
  
}
.icon-Warning-2 .path1:before {
  content: "\\eddb";
  
  opacity: 0.3;
}
.icon-Warning-2 .path2:before {
  content: "\\eddc";
  margin-left: -1em;
  
}
.icon-Warning-2 .path3:before {
  content: "\\eddd";
  margin-left: -1em;
  
}
.icon-Brassiere:before {
  content: "\\edde";
}
.icon-Briefcase .path1:before {
  content: "\\eddf";
  
}
.icon-Briefcase .path2:before {
  content: "\\ede0";
  margin-left: -1em;
  
  opacity: 0.3;
}
.icon-Cap .path1:before {
  content: "\\ede1";
  
  opacity: 0.3;
}
.icon-Cap .path2:before {
  content: "\\ede2";
  margin-left: -1em;
  
}
.icon-Crown .path1:before {
  content: "\\ede3";
  
  opacity: 0.3;
}
.icon-Crown .path2:before {
  content: "\\ede4";
  margin-left: -1em;
  
}
.icon-Dress .path1:before {
  content: "\\ede5";
  
  opacity: 0.3;
}
.icon-Dress .path2:before {
  content: "\\ede6";
  margin-left: -1em;
  
}
.icon-Hanger:before {
  content: "\\ede7";
}
.icon-Hat .path1:before {
  content: "\\ede8";
  
}
.icon-Hat .path2:before {
  content: "\\ede9";
  margin-left: -1em;
  
  opacity: 0.3;
}
.icon-Panties:before {
  content: "\\edea";
}
.icon-Shirt .path1:before {
  content: "\\edeb";
  
  opacity: 0.3;
}
.icon-Shirt .path2:before {
  content: "\\edec";
  margin-left: -1em;
  
}
.icon-Shoes .path1:before {
  content: "\\eded";
  
}
.icon-Shoes .path2:before {
  content: "\\edee";
  margin-left: -1em;
  
  opacity: 0.3;
}
.icon-Shorts:before {
  content: "\\edef";
}
.icon-Sneakers .path1:before {
  content: "\\edf0";
  
  opacity: 0.3;
}
.icon-Sneakers .path2:before {
  content: "\\edf1";
  margin-left: -1em;
  
}
.icon-Socks .path1:before {
  content: "\\edf2";
  
  opacity: 0.3;
}
.icon-Socks .path2:before {
  content: "\\edf3";
  margin-left: -1em;
  
}
.icon-Sun-glasses .path1:before {
  content: "\\edf4";
  
  opacity: 0.3;
}
.icon-Sun-glasses .path2:before {
  content: "\\edf5";
  margin-left: -1em;
  
}
.icon-Tie .path1:before {
  content: "\\edf6";
  
}
.icon-Tie .path2:before {
  content: "\\edf7";
  margin-left: -1em;
  
  opacity: 0.3;
}
.icon-T-Shirt:before {
  content: "\\edf8";
}
.icon-Celcium .path1:before {
  content: "\\edf9";
  
}
.icon-Celcium .path2:before {
  content: "\\edfa";
  margin-left: -1em;
  
  opacity: 0.3;
}
.icon-Cloud:before {
  content: "\\edfb";
}
.icon-18:before {
  content: "\\edfb";
}
.icon-Cloud1 .path1:before {
  content: "\\edfc";
  
  opacity: 0.3;
}
.icon-Cloud1 .path2:before {
  content: "\\edfd";
  margin-left: -1em;
  
}
.icon-Cloud-fog .path1:before {
  content: "\\edfe";
  
}
.icon-Cloud-fog .path2:before {
  content: "\\edff";
  margin-left: -1em;
  
  opacity: 0.3;
}
.icon-Cloud-sun .path1:before {
  content: "\\ee00";
  
  opacity: 0.3;
}
.icon-Cloud-sun .path2:before {
  content: "\\ee01";
  margin-left: -1em;
  
}
.icon-Cloud-wind .path1:before {
  content: "\\ee02";
  
}
.icon-Cloud-wind .path2:before {
  content: "\\ee03";
  margin-left: -1em;
  
  opacity: 0.3;
}
.icon-Cloud-wind .path3:before {
  content: "\\ee04";
  margin-left: -1em;
  
  opacity: 0.3;
}
.icon-Cloudy .path1:before {
  content: "\\ee05";
  
  opacity: 0.3;
}
.icon-Cloudy .path2:before {
  content: "\\ee06";
  margin-left: -1em;
  
}
.icon-Cloudy-night .path1:before {
  content: "\\ee07";
  
  opacity: 0.3;
}
.icon-Cloudy-night .path2:before {
  content: "\\ee08";
  margin-left: -1em;
  
}
.icon-Day-rain .path1:before {
  content: "\\ee09";
  
  opacity: 0.3;
}
.icon-Day-rain .path2:before {
  content: "\\ee0a";
  margin-left: -1em;
  
}
.icon-Fahrenheit .path1:before {
  content: "\\ee0b";
  
}
.icon-Fahrenheit .path2:before {
  content: "\\ee0c";
  margin-left: -1em;
  
  opacity: 0.3;
}
.icon-Fog:before {
  content: "\\ee0d";
}
.icon-Moon:before {
  content: "\\ee0e";
}
.icon-Night-fog .path1:before {
  content: "\\ee0f";
  
}
.icon-Night-fog .path2:before {
  content: "\\ee10";
  margin-left: -1em;
  
  opacity: 0.3;
}
.icon-Night-rain .path1:before {
  content: "\\ee11";
  
  opacity: 0.3;
}
.icon-Night-rain .path2:before {
  content: "\\ee12";
  margin-left: -1em;
  
}
.icon-Rain .path1:before {
  content: "\\ee13";
  
}
.icon-Rain .path2:before {
  content: "\\ee14";
  margin-left: -1em;
  
  opacity: 0.3;
}
.icon-Rain1 .path1:before {
  content: "\\ee15";
  
}
.icon-Rain1 .path2:before {
  content: "\\ee16";
  margin-left: -1em;
  
  opacity: 0.3;
}
.icon-Rain2 .path1:before {
  content: "\\ee17";
  
  opacity: 0.3;
}
.icon-Rain2 .path2:before {
  content: "\\ee18";
  margin-left: -1em;
  
}
.icon-Rainbow .path1:before {
  content: "\\ee19";
  
  opacity: 0.3;
}
.icon-Rainbow .path2:before {
  content: "\\ee1a";
  margin-left: -1em;
  
}
.icon-Snow .path1:before {
  content: "\\ee1b";
  
}
.icon-Snow .path2:before {
  content: "\\ee1c";
  margin-left: -1em;
  
  opacity: 0.3;
}
.icon-Snow1 .path1:before {
  content: "\\ee1d";
  
}
.icon-Snow1 .path2:before {
  content: "\\ee1e";
  margin-left: -1em;
  
  opacity: 0.3;
}
.icon-Snow2 .path1:before {
  content: "\\ee1f";
  
  opacity: 0.3;
}
.icon-Snow2 .path2:before {
  content: "\\ee20";
  margin-left: -1em;
  
}
.icon-Snow3:before {
  content: "\\ee21";
}
.icon-Storm .path1:before {
  content: "\\ee22";
  
}
.icon-Storm .path2:before {
  content: "\\ee23";
  margin-left: -1em;
  
  opacity: 0.3;
}
.icon-Sun .path1:before {
  content: "\\ee24";
  
}
.icon-Sun .path2:before {
  content: "\\ee25";
  margin-left: -1em;
  
  opacity: 0.3;
}
.icon-Sun-fog .path1:before {
  content: "\\ee26";
  
}
.icon-Sun-fog .path2:before {
  content: "\\ee27";
  margin-left: -1em;
  
  opacity: 0.3;
}
.icon-Suset .path1:before {
  content: "\\ee28";
  
}
.icon-Suset .path2:before {
  content: "\\ee29";
  margin-left: -1em;
  
  opacity: 0.3;
}
.icon-Suset1 .path1:before {
  content: "\\ee2a";
  
}
.icon-Suset1 .path2:before {
  content: "\\ee2b";
  margin-left: -1em;
  
  opacity: 0.3;
}
.icon-Temperature-empty:before {
  content: "\\ee2c";
}
.icon-Temperature-full:before {
  content: "\\ee2d";
}
.icon-Temperature-half:before {
  content: "\\ee2e";
}
.icon-Thunder .path1:before {
  content: "\\ee2f";
  
  opacity: 0.3;
}
.icon-Thunder .path2:before {
  content: "\\ee30";
  margin-left: -1em;
  
}
.icon-Thunder-night .path1:before {
  content: "\\ee31";
  
  opacity: 0.3;
}
.icon-Thunder-night .path2:before {
  content: "\\ee32";
  margin-left: -1em;
  
}
.icon-Umbrella .path1:before {
  content: "\\ee33";
  
}
.icon-Umbrella .path2:before {
  content: "\\ee34";
  margin-left: -1em;
  
  opacity: 0.3;
}
.icon-Wind .path1:before {
  content: "\\ee35";
  
}
.icon-Wind .path2:before {
  content: "\\ee36";
  margin-left: -1em;  
  opacity: 0.3;
}
`, "",{"version":3,"sources":["webpack://./src/icons/icomoon/icomoon.css"],"names":[],"mappings":"AAAA;EACE,sBAAsB;EACtB,6CAA8B;EAC9B;;;yDAGwC;EACxC,mBAAmB;EACnB,kBAAkB;EAClB,mBAAmB;AACrB;AACA;EACE,+EAA+E;EAC/E,uCAAuC;EACvC,YAAY;EACZ,kBAAkB;EAClB,mBAAmB;EACnB,oBAAoB;EACpB,oBAAoB;EACpB,cAAc;;EAEd,sCAAsC;EACtC,mCAAmC;EACnC,kCAAkC;AACpC;AACA;EACE,gBAAgB;;EAEhB,YAAY;AACd;AACA;EACE,gBAAgB;EAChB,iBAAiB;;EAEjB,YAAY;AACd;AACA;EACE,gBAAgB;EAChB,iBAAiB;;AAEnB;AACA;EACE,gBAAgB;;EAEhB,YAAY;AACd;AACA;EACE,gBAAgB;EAChB,iBAAiB;;AAEnB;AACA;EACE,gBAAgB;;EAEhB,YAAY;AACd;AACA;EACE,gBAAgB;EAChB,iBAAiB;;AAEnB;AACA;EACE,gBAAgB;;EAEhB,YAAY;AACd;AACA;EACE,gBAAgB;EAChB,iBAAiB;;AAEnB;AACA;EACE,gBAAgB;;EAEhB,YAAY;AACd;AACA;EACE,gBAAgB;EAChB,iBAAiB;;AAEnB;AACA;EACE,gBAAgB;EAChB,iBAAiB;;EAEjB,YAAY;AACd;AACA;EACE,gBAAgB;;EAEhB,YAAY;AACd;AACA;EACE,gBAAgB;EAChB,iBAAiB;;AAEnB;AACA;EACE,gBAAgB;;EAEhB,YAAY;AACd;AACA;EACE,gBAAgB;EAChB,iBAAiB;;EAEjB,YAAY;AACd;AACA;EACE,gBAAgB;EAChB,iBAAiB;;AAEnB;AACA;EACE,gBAAgB;;AAElB;AACA;EACE,gBAAgB;EAChB,iBAAiB;;EAEjB,YAAY;AACd;AACA;EACE,gBAAgB;;AAElB;AACA;EACE,gBAAgB;EAChB,iBAAiB;;AAEnB;AACA;EACE,gBAAgB;EAChB,iBAAiB;;EAEjB,YAAY;AACd;AACA;EACE,gBAAgB;;AAElB;AACA;EACE,gBAAgB;EAChB,iBAAiB;;EAEjB,YAAY;AACd;AACA;EACE,gBAAgB;;EAEhB,YAAY;AACd;AACA;EACE,gBAAgB;EAChB,iBAAiB;;AAEnB;AACA;EACE,gBAAgB;;EAEhB,YAAY;AACd;AACA;EACE,gBAAgB;EAChB,iBAAiB;;AAEnB;AACA;EACE,gBAAgB;;EAEhB,YAAY;AACd;AACA;EACE,gBAAgB;EAChB,iBAAiB;;AAEnB;AACA;EACE,gBAAgB;;EAEhB,YAAY;AACd;AACA;EACE,gBAAgB;EAChB,iBAAiB;;AAEnB;AACA;EACE,gBAAgB;;AAElB;AACA;EACE,gBAAgB;EAChB,iBAAiB;;EAEjB,YAAY;AACd;AACA;EACE,gBAAgB;;EAEhB,YAAY;AACd;AACA;EACE,gBAAgB;EAChB,iBAAiB;;AAEnB;AACA;EACE,gBAAgB;;EAEhB,YAAY;AACd;AACA;EACE,gBAAgB;EAChB,iBAAiB;;AAEnB;AACA;EACE,gBAAgB;;EAEhB,YAAY;AACd;AACA;EACE,gBAAgB;EAChB,iBAAiB;;AAEnB;AACA;EACE,gBAAgB;;EAEhB,YAAY;AACd;AACA;EACE,gBAAgB;EAChB,iBAAiB;;EAEjB,YAAY;AACd;AACA;EACE,gBAAgB;EAChB,iBAAiB;;AAEnB;AACA;EACE,gBAAgB;;EAEhB,YAAY;AACd;AACA;EACE,gBAAgB;EAChB,iBAAiB;;AAEnB;AACA;EACE,gBAAgB;;AAElB;AACA;EACE,gBAAgB;EAChB,iBAAiB;;EAEjB,YAAY;AACd;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;;AAElB;AACA;EACE,gBAAgB;EAChB,iBAAiB;;EAEjB,YAAY;AACd;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;;EAEhB,YAAY;AACd;AACA;EACE,gBAAgB;EAChB,iBAAiB;;AAEnB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;;AAElB;AACA;EACE,gBAAgB;EAChB,iBAAiB;;EAEjB,YAAY;AACd;AACA;EACE,gBAAgB;;AAElB;AACA;EACE,gBAAgB;EAChB,iBAAiB;;EAEjB,YAAY;AACd;AACA;EACE,gBAAgB;;AAElB;AACA;EACE,gBAAgB;EAChB,iBAAiB;;EAEjB,YAAY;AACd;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;;AAElB;AACA;EACE,gBAAgB;EAChB,iBAAiB;;EAEjB,YAAY;AACd;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;;AAElB;AACA;EACE,gBAAgB;EAChB,iBAAiB;;EAEjB,YAAY;AACd;AACA;EACE,gBAAgB;;AAElB;AACA;EACE,gBAAgB;EAChB,iBAAiB;;EAEjB,YAAY;AACd;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;;EAEhB,YAAY;AACd;AACA;EACE,gBAAgB;EAChB,iBAAiB;;AAEnB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;;EAEhB,YAAY;AACd;AACA;EACE,gBAAgB;EAChB,iBAAiB;;AAEnB;AACA;EACE,gBAAgB;;EAEhB,YAAY;AACd;AACA;EACE,gBAAgB;EAChB,iBAAiB;;AAEnB;AACA;EACE,gBAAgB;;AAElB;AACA;EACE,gBAAgB;EAChB,iBAAiB;;EAEjB,YAAY;AACd;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;;EAEhB,YAAY;AACd;AACA;EACE,gBAAgB;EAChB,iBAAiB;;AAEnB;AACA;EACE,gBAAgB;;EAEhB,YAAY;AACd;AACA;EACE,gBAAgB;EAChB,iBAAiB;;AAEnB;AACA;EACE,gBAAgB;;EAEhB,YAAY;AACd;AACA;EACE,gBAAgB;EAChB,iBAAiB;;AAEnB;AACA;EACE,gBAAgB;;AAElB;AACA;EACE,gBAAgB;EAChB,iBAAiB;;EAEjB,YAAY;AACd;AACA;EACE,gBAAgB;;EAEhB,YAAY;AACd;AACA;EACE,gBAAgB;EAChB,iBAAiB;;AAEnB;AACA;EACE,gBAAgB;;AAElB;AACA;EACE,gBAAgB;EAChB,iBAAiB;;EAEjB,YAAY;AACd;AACA;EACE,gBAAgB;EAChB,iBAAiB;;EAEjB,YAAY;AACd;AACA;EACE,gBAAgB;;EAEhB,YAAY;AACd;AACA;EACE,gBAAgB;EAChB,iBAAiB;;EAEjB,YAAY;AACd;AACA;EACE,gBAAgB;EAChB,iBAAiB;;AAEnB;AACA;EACE,gBAAgB;;EAEhB,YAAY;AACd;AACA;EACE,gBAAgB;EAChB,iBAAiB;;AAEnB;AACA;EACE,gBAAgB;;AAElB;AACA;EACE,gBAAgB;EAChB,iBAAiB;;EAEjB,YAAY;AACd;AACA;EACE,gBAAgB;;EAEhB,YAAY;AACd;AACA;EACE,gBAAgB;EAChB,iBAAiB;;AAEnB;AACA;EACE,gBAAgB;;EAEhB,YAAY;AACd;AACA;EACE,gBAAgB;EAChB,iBAAiB;;AAEnB;AACA;EACE,gBAAgB;;EAEhB,YAAY;AACd;AACA;EACE,gBAAgB;EAChB,iBAAiB;;AAEnB;AACA;EACE,gBAAgB;;EAEhB,YAAY;AACd;AACA;EACE,gBAAgB;EAChB,iBAAiB;;AAEnB;AACA;EACE,gBAAgB;;EAEhB,YAAY;AACd;AACA;EACE,gBAAgB;EAChB,iBAAiB;;AAEnB;AACA;EACE,gBAAgB;;EAEhB,YAAY;AACd;AACA;EACE,gBAAgB;EAChB,iBAAiB;;EAEjB,YAAY;AACd;AACA;EACE,gBAAgB;EAChB,iBAAiB;;AAEnB;AACA;EACE,gBAAgB;EAChB,iBAAiB;;EAEjB,YAAY;AACd;AACA;EACE,gBAAgB;;EAEhB,YAAY;AACd;AACA;EACE,gBAAgB;EAChB,iBAAiB;;EAEjB,YAAY;AACd;AACA;EACE,gBAAgB;EAChB,iBAAiB;;AAEnB;AACA;EACE,gBAAgB;EAChB,iBAAiB;;EAEjB,YAAY;AACd;AACA;EACE,gBAAgB;;EAEhB,YAAY;AACd;AACA;EACE,gBAAgB;EAChB,iBAAiB;;EAEjB,YAAY;AACd;AACA;EACE,gBAAgB;EAChB,iBAAiB;;AAEnB;AACA;EACE,gBAAgB;EAChB,iBAAiB;;EAEjB,YAAY;AACd;AACA;EACE,gBAAgB;;AAElB;AACA;EACE,gBAAgB;EAChB,iBAAiB;;EAEjB,YAAY;AACd;AACA;EACE,gBAAgB;;AAElB;AACA;EACE,gBAAgB;EAChB,iBAAiB;;EAEjB,YAAY;AACd;AACA;EACE,gBAAgB;;EAEhB,YAAY;AACd;AACA;EACE,gBAAgB;EAChB,iBAAiB;;AAEnB;AACA;EACE,gBAAgB;;EAEhB,YAAY;AACd;AACA;EACE,gBAAgB;EAChB,iBAAiB;;AAEnB;AACA;EACE,gBAAgB;EAChB,iBAAiB;;EAEjB,YAAY;AACd;AACA;EACE,gBAAgB;;EAEhB,YAAY;AACd;AACA;EACE,gBAAgB;EAChB,iBAAiB;;EAEjB,YAAY;AACd;AACA;EACE,gBAAgB;EAChB,iBAAiB;;AAEnB;AACA;EACE,gBAAgB;;EAEhB,YAAY;AACd;AACA;EACE,gBAAgB;EAChB,iBAAiB;;AAEnB;AACA;EACE,gBAAgB;;AAElB;AACA;EACE,gBAAgB;EAChB,iBAAiB;;EAEjB,YAAY;AACd;AACA;EACE,gBAAgB;;EAEhB,YAAY;AACd;AACA;EACE,gBAAgB;EAChB,iBAAiB;;EAEjB,YAAY;AACd;AACA;EACE,gBAAgB;EAChB,iBAAiB;;AAEnB;AACA;EACE,gBAAgB;;EAEhB,YAAY;AACd;AACA;EACE,gBAAgB;EAChB,iBAAiB;;AAEnB;AACA;EACE,gBAAgB;;EAEhB,YAAY;AACd;AACA;EACE,gBAAgB;EAChB,iBAAiB;;AAEnB;AACA;EACE,gBAAgB;;AAElB;AACA;EACE,gBAAgB;EAChB,iBAAiB;;EAEjB,YAAY;AACd;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;;EAEhB,YAAY;AACd;AACA;EACE,gBAAgB;EAChB,iBAAiB;;AAEnB;AACA;EACE,gBAAgB;;EAEhB,YAAY;AACd;AACA;EACE,gBAAgB;EAChB,iBAAiB;;AAEnB;AACA;EACE,gBAAgB;;AAElB;AACA;EACE,gBAAgB;EAChB,iBAAiB;;EAEjB,YAAY;AACd;AACA;EACE,gBAAgB;;EAEhB,YAAY;AACd;AACA;EACE,gBAAgB;EAChB,iBAAiB;;AAEnB;AACA;EACE,gBAAgB;EAChB,iBAAiB;;EAEjB,YAAY;AACd;AACA;EACE,gBAAgB;EAChB,iBAAiB;;EAEjB,YAAY;AACd;AACA;EACE,gBAAgB;;EAEhB,YAAY;AACd;AACA;EACE,gBAAgB;EAChB,iBAAiB;;AAEnB;AACA;EACE,gBAAgB;;AAElB;AACA;EACE,gBAAgB;EAChB,iBAAiB;;EAEjB,YAAY;AACd;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;;EAEhB,YAAY;AACd;AACA;EACE,gBAAgB;EAChB,iBAAiB;;AAEnB;AACA;EACE,gBAAgB;;EAEhB,YAAY;AACd;AACA;EACE,gBAAgB;EAChB,iBAAiB;;AAEnB;AACA;EACE,gBAAgB;EAChB,iBAAiB;;AAEnB;AACA;EACE,gBAAgB;;EAEhB,YAAY;AACd;AACA;EACE,gBAAgB;EAChB,iBAAiB;;EAEjB,YAAY;AACd;AACA;EACE,gBAAgB;EAChB,iBAAiB;;AAEnB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;;AAElB;AACA;EACE,gBAAgB;EAChB,iBAAiB;;EAEjB,YAAY;AACd;AACA;EACE,gBAAgB;;AAElB;AACA;EACE,gBAAgB;EAChB,iBAAiB;;EAEjB,YAAY;AACd;AACA;EACE,gBAAgB;;AAElB;AACA;EACE,gBAAgB;EAChB,iBAAiB;;EAEjB,YAAY;AACd;AACA;EACE,gBAAgB;;AAElB;AACA;EACE,gBAAgB;EAChB,iBAAiB;;EAEjB,YAAY;AACd;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;;EAEhB,YAAY;AACd;AACA;EACE,gBAAgB;EAChB,iBAAiB;;AAEnB;AACA;EACE,gBAAgB;;EAEhB,YAAY;AACd;AACA;EACE,gBAAgB;EAChB,iBAAiB;;AAEnB;AACA;EACE,gBAAgB;EAChB,iBAAiB;;EAEjB,YAAY;AACd;AACA;EACE,gBAAgB;;EAEhB,YAAY;AACd;AACA;EACE,gBAAgB;EAChB,iBAAiB;;EAEjB,YAAY;AACd;AACA;EACE,gBAAgB;EAChB,iBAAiB;;AAEnB;AACA;EACE,gBAAgB;;EAEhB,YAAY;AACd;AACA;EACE,gBAAgB;EAChB,iBAAiB;;EAEjB,YAAY;AACd;AACA;EACE,gBAAgB;EAChB,iBAAiB;;AAEnB;AACA;EACE,gBAAgB;;EAEhB,YAAY;AACd;AACA;EACE,gBAAgB;EAChB,iBAAiB;;AAEnB;AACA;EACE,gBAAgB;EAChB,iBAAiB;;EAEjB,YAAY;AACd;AACA;EACE,gBAAgB;;EAEhB,YAAY;AACd;AACA;EACE,gBAAgB;EAChB,iBAAiB;;AAEnB;AACA;EACE,gBAAgB;;EAEhB,YAAY;AACd;AACA;EACE,gBAAgB;EAChB,iBAAiB;;AAEnB;AACA;EACE,gBAAgB;;EAEhB,YAAY;AACd;AACA;EACE,gBAAgB;EAChB,iBAAiB;;AAEnB;AACA;EACE,gBAAgB;EAChB,iBAAiB;;AAEnB;AACA;EACE,gBAAgB;;EAEhB,YAAY;AACd;AACA;EACE,gBAAgB;EAChB,iBAAiB;;AAEnB;AACA;EACE,gBAAgB;EAChB,iBAAiB;;AAEnB;AACA;EACE,gBAAgB;;EAEhB,YAAY;AACd;AACA;EACE,gBAAgB;EAChB,iBAAiB;;AAEnB;AACA;EACE,gBAAgB;EAChB,iBAAiB;;EAEjB,YAAY;AACd;AACA;EACE,gBAAgB;;EAEhB,YAAY;AACd;AACA;EACE,gBAAgB;EAChB,iBAAiB;;EAEjB,YAAY;AACd;AACA;EACE,gBAAgB;EAChB,iBAAiB;;AAEnB;AACA;EACE,gBAAgB;;EAEhB,YAAY;AACd;AACA;EACE,gBAAgB;EAChB,iBAAiB;;EAEjB,YAAY;AACd;AACA;EACE,gBAAgB;EAChB,iBAAiB;;AAEnB;AACA;EACE,gBAAgB;;EAEhB,YAAY;AACd;AACA;EACE,gBAAgB;EAChB,iBAAiB;;AAEnB;AACA;EACE,gBAAgB;EAChB,iBAAiB;;EAEjB,YAAY;AACd;AACA;EACE,gBAAgB;;EAEhB,YAAY;AACd;AACA;EACE,gBAAgB;EAChB,iBAAiB;;AAEnB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;;AAElB;AACA;EACE,gBAAgB;EAChB,iBAAiB;;EAEjB,YAAY;AACd;AACA;EACE,gBAAgB;;EAEhB,YAAY;AACd;AACA;EACE,gBAAgB;EAChB,iBAAiB;;AAEnB;AACA;EACE,gBAAgB;;EAEhB,YAAY;AACd;AACA;EACE,gBAAgB;EAChB,iBAAiB;;AAEnB;AACA;EACE,gBAAgB;;EAEhB,YAAY;AACd;AACA;EACE,gBAAgB;EAChB,iBAAiB;;AAEnB;AACA;EACE,gBAAgB;;EAEhB,YAAY;AACd;AACA;EACE,gBAAgB;EAChB,iBAAiB;;AAEnB;AACA;EACE,gBAAgB;;EAEhB,YAAY;AACd;AACA;EACE,gBAAgB;EAChB,iBAAiB;;AAEnB;AACA;EACE,gBAAgB;EAChB,iBAAiB;;EAEjB,YAAY;AACd;AACA;EACE,gBAAgB;EAChB,iBAAiB;;AAEnB;AACA;EACE,gBAAgB;;AAElB;AACA;EACE,gBAAgB;EAChB,iBAAiB;;EAEjB,YAAY;AACd;AACA;EACE,gBAAgB;;EAEhB,YAAY;AACd;AACA;EACE,gBAAgB;EAChB,iBAAiB;;AAEnB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;;AAElB;AACA;EACE,gBAAgB;EAChB,iBAAiB;;EAEjB,YAAY;AACd;AACA;EACE,gBAAgB;;AAElB;AACA;EACE,gBAAgB;EAChB,iBAAiB;;EAEjB,YAAY;AACd;AACA;EACE,gBAAgB;;EAEhB,YAAY;AACd;AACA;EACE,gBAAgB;EAChB,iBAAiB;;AAEnB;AACA;EACE,gBAAgB;;EAEhB,YAAY;AACd;AACA;EACE,gBAAgB;EAChB,iBAAiB;;AAEnB;AACA;EACE,gBAAgB;EAChB,iBAAiB;;AAEnB;AACA;EACE,gBAAgB;;EAEhB,YAAY;AACd;AACA;EACE,gBAAgB;EAChB,iBAAiB;;EAEjB,YAAY;AACd;AACA;EACE,gBAAgB;EAChB,iBAAiB;;AAEnB;AACA;EACE,gBAAgB;;EAEhB,YAAY;AACd;AACA;EACE,gBAAgB;EAChB,iBAAiB;;EAEjB,YAAY;AACd;AACA;EACE,gBAAgB;EAChB,iBAAiB;;AAEnB;AACA;EACE,gBAAgB;;EAEhB,YAAY;AACd;AACA;EACE,gBAAgB;EAChB,iBAAiB;;AAEnB;AACA;EACE,gBAAgB;;EAEhB,YAAY;AACd;AACA;EACE,gBAAgB;EAChB,iBAAiB;;AAEnB;AACA;EACE,gBAAgB;EAChB,iBAAiB;;EAEjB,YAAY;AACd;AACA;EACE,gBAAgB;EAChB,iBAAiB;;AAEnB;AACA;EACE,gBAAgB;;EAEhB,YAAY;AACd;AACA;EACE,gBAAgB;EAChB,iBAAiB;;AAEnB;AACA;EACE,gBAAgB;;EAEhB,YAAY;AACd;AACA;EACE,gBAAgB;EAChB,iBAAiB;;AAEnB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;;AAElB;AACA;EACE,gBAAgB;EAChB,iBAAiB;;EAEjB,YAAY;AACd;AACA;EACE,gBAAgB;;EAEhB,YAAY;AACd;AACA;EACE,gBAAgB;EAChB,iBAAiB;;AAEnB;AACA;EACE,gBAAgB;;AAElB;AACA;EACE,gBAAgB;EAChB,iBAAiB;;EAEjB,YAAY;AACd;AACA;EACE,gBAAgB;;AAElB;AACA;EACE,gBAAgB;EAChB,iBAAiB;;EAEjB,YAAY;AACd;AACA;EACE,gBAAgB;;EAEhB,YAAY;AACd;AACA;EACE,gBAAgB;EAChB,iBAAiB;;AAEnB;AACA;EACE,gBAAgB;;AAElB;AACA;EACE,gBAAgB;EAChB,iBAAiB;;EAEjB,YAAY;AACd;AACA;EACE,gBAAgB;;EAEhB,YAAY;AACd;AACA;EACE,gBAAgB;EAChB,iBAAiB;;AAEnB;AACA;EACE,gBAAgB;;AAElB;AACA;EACE,gBAAgB;EAChB,iBAAiB;;EAEjB,YAAY;AACd;AACA;EACE,gBAAgB;;EAEhB,YAAY;AACd;AACA;EACE,gBAAgB;EAChB,iBAAiB;;AAEnB;AACA;EACE,gBAAgB;EAChB,iBAAiB;;AAEnB;AACA;EACE,gBAAgB;EAChB,iBAAiB;;AAEnB;AACA;EACE,gBAAgB;;EAEhB,YAAY;AACd;AACA;EACE,gBAAgB;EAChB,iBAAiB;;AAEnB;AACA;EACE,gBAAgB;;EAEhB,YAAY;AACd;AACA;EACE,gBAAgB;EAChB,iBAAiB;;EAEjB,YAAY;AACd;AACA;EACE,gBAAgB;EAChB,iBAAiB;;EAEjB,YAAY;AACd;AACA;EACE,gBAAgB;EAChB,iBAAiB;;AAEnB;AACA;EACE,gBAAgB;;EAEhB,YAAY;AACd;AACA;EACE,gBAAgB;EAChB,iBAAiB;;AAEnB;AACA;EACE,gBAAgB;;EAEhB,eAAe;AACjB;AACA;EACE,gBAAgB;EAChB,iBAAiB;;AAEnB;AACA;EACE,gBAAgB;;EAEhB,YAAY;AACd;AACA;EACE,gBAAgB;EAChB,iBAAiB;;AAEnB;AACA;EACE,gBAAgB;;EAEhB,YAAY;AACd;AACA;EACE,gBAAgB;EAChB,iBAAiB;;AAEnB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;;EAEhB,YAAY;AACd;AACA;EACE,gBAAgB;EAChB,iBAAiB;;AAEnB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;;EAEhB,YAAY;AACd;AACA;EACE,gBAAgB;EAChB,iBAAiB;;AAEnB;AACA;EACE,gBAAgB;;AAElB;AACA;EACE,gBAAgB;EAChB,iBAAiB;;EAEjB,YAAY;AACd;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;;AAElB;AACA;EACE,gBAAgB;EAChB,iBAAiB;;EAEjB,YAAY;AACd;AACA;EACE,gBAAgB;;EAEhB,YAAY;AACd;AACA;EACE,gBAAgB;EAChB,iBAAiB;;AAEnB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;;AAElB;AACA;EACE,gBAAgB;EAChB,iBAAiB;;EAEjB,YAAY;AACd;AACA;EACE,gBAAgB;;EAEhB,YAAY;AACd;AACA;EACE,gBAAgB;EAChB,iBAAiB;;AAEnB;AACA;EACE,gBAAgB;;EAEhB,YAAY;AACd;AACA;EACE,gBAAgB;EAChB,iBAAiB;;AAEnB;AACA;EACE,gBAAgB;;EAEhB,YAAY;AACd;AACA;EACE,gBAAgB;EAChB,iBAAiB;;AAEnB;AACA;EACE,gBAAgB;;EAEhB,YAAY;AACd;AACA;EACE,gBAAgB;EAChB,iBAAiB;;AAEnB;AACA;EACE,gBAAgB;;EAEhB,YAAY;AACd;AACA;EACE,gBAAgB;EAChB,iBAAiB;;AAEnB;AACA;EACE,gBAAgB;;EAEhB,YAAY;AACd;AACA;EACE,gBAAgB;EAChB,iBAAiB;;AAEnB;AACA;EACE,gBAAgB;;AAElB;AACA;EACE,gBAAgB;EAChB,iBAAiB;;EAEjB,YAAY;AACd;AACA;EACE,gBAAgB;;EAEhB,YAAY;AACd;AACA;EACE,gBAAgB;EAChB,iBAAiB;;AAEnB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;;EAEhB,YAAY;AACd;AACA;EACE,gBAAgB;EAChB,iBAAiB;;EAEjB,YAAY;AACd;AACA;EACE,gBAAgB;EAChB,iBAAiB;;AAEnB;AACA;EACE,gBAAgB;;AAElB;AACA;EACE,gBAAgB;EAChB,iBAAiB;;EAEjB,YAAY;AACd;AACA;EACE,gBAAgB;;AAElB;AACA;EACE,gBAAgB;EAChB,iBAAiB;;EAEjB,YAAY;AACd;AACA;EACE,gBAAgB;;AAElB;AACA;EACE,gBAAgB;EAChB,iBAAiB;;EAEjB,YAAY;AACd;AACA;EACE,gBAAgB;;EAEhB,YAAY;AACd;AACA;EACE,gBAAgB;EAChB,iBAAiB;;AAEnB;AACA;EACE,gBAAgB;;EAEhB,YAAY;AACd;AACA;EACE,gBAAgB;EAChB,iBAAiB;;AAEnB;AACA;EACE,gBAAgB;;AAElB;AACA;EACE,gBAAgB;EAChB,iBAAiB;;EAEjB,YAAY;AACd;AACA;EACE,gBAAgB;;AAElB;AACA;EACE,gBAAgB;EAChB,iBAAiB;;EAEjB,YAAY;AACd;AACA;EACE,gBAAgB;;AAElB;AACA;EACE,gBAAgB;EAChB,iBAAiB;;EAEjB,YAAY;AACd;AACA;EACE,gBAAgB;;AAElB;AACA;EACE,gBAAgB;EAChB,iBAAiB;;EAEjB,YAAY;AACd;AACA;EACE,gBAAgB;;AAElB;AACA;EACE,gBAAgB;EAChB,iBAAiB;;EAEjB,YAAY;AACd;AACA;EACE,gBAAgB;;AAElB;AACA;EACE,gBAAgB;EAChB,iBAAiB;;EAEjB,YAAY;AACd;AACA;EACE,gBAAgB;;AAElB;AACA;EACE,gBAAgB;EAChB,iBAAiB;;EAEjB,YAAY;AACd;AACA;EACE,gBAAgB;;AAElB;AACA;EACE,gBAAgB;EAChB,iBAAiB;;EAEjB,YAAY;AACd;AACA;EACE,gBAAgB;;AAElB;AACA;EACE,gBAAgB;EAChB,iBAAiB;;EAEjB,YAAY;AACd;AACA;EACE,gBAAgB;;AAElB;AACA;EACE,gBAAgB;EAChB,iBAAiB;;EAEjB,YAAY;AACd;AACA;EACE,gBAAgB;;AAElB;AACA;EACE,gBAAgB;EAChB,iBAAiB;;EAEjB,YAAY;AACd;AACA;EACE,gBAAgB;;AAElB;AACA;EACE,gBAAgB;EAChB,iBAAiB;;EAEjB,YAAY;AACd;AACA;EACE,gBAAgB;;AAElB;AACA;EACE,gBAAgB;EAChB,iBAAiB;;EAEjB,YAAY;AACd;AACA;EACE,gBAAgB;EAChB,iBAAiB;;AAEnB;AACA;EACE,gBAAgB;;EAEhB,YAAY;AACd;AACA;EACE,gBAAgB;EAChB,iBAAiB;;EAEjB,YAAY;AACd;AACA;EACE,gBAAgB;EAChB,iBAAiB;;AAEnB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;;EAEhB,YAAY;AACd;AACA;EACE,gBAAgB;EAChB,iBAAiB;;EAEjB,YAAY;AACd;AACA;EACE,gBAAgB;EAChB,iBAAiB;;AAEnB;AACA;EACE,gBAAgB;;EAEhB,YAAY;AACd;AACA;EACE,gBAAgB;EAChB,iBAAiB;;AAEnB;AACA;EACE,gBAAgB;EAChB,iBAAiB;;EAEjB,YAAY;AACd;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;;AAElB;AACA;EACE,gBAAgB;EAChB,iBAAiB;;EAEjB,YAAY;AACd;AACA;EACE,gBAAgB;;AAElB;AACA;EACE,gBAAgB;EAChB,iBAAiB;;EAEjB,YAAY;AACd;AACA;EACE,gBAAgB;;EAEhB,YAAY;AACd;AACA;EACE,gBAAgB;EAChB,iBAAiB;;AAEnB;AACA;EACE,gBAAgB;;AAElB;AACA;EACE,gBAAgB;EAChB,iBAAiB;EACjB,yBAAyB;AAC3B;AACA;EACE,gBAAgB;EAChB,iBAAiB;;EAEjB,YAAY;AACd;AACA;EACE,gBAAgB;;EAEhB,YAAY;AACd;AACA;EACE,gBAAgB;EAChB,iBAAiB;;EAEjB,YAAY;AACd;AACA;EACE,gBAAgB;EAChB,iBAAiB;;EAEjB,YAAY;AACd;AACA;EACE,gBAAgB;EAChB,iBAAiB;;AAEnB;AACA;EACE,gBAAgB;;EAEhB,YAAY;AACd;AACA;EACE,gBAAgB;EAChB,iBAAiB;;EAEjB,YAAY;AACd;AACA;EACE,gBAAgB;EAChB,iBAAiB;;EAEjB,YAAY;AACd;AACA;EACE,gBAAgB;EAChB,iBAAiB;;AAEnB;AACA;EACE,gBAAgB;;AAElB;AACA;EACE,gBAAgB;EAChB,iBAAiB;;EAEjB,YAAY;AACd;AACA;EACE,gBAAgB;;EAEhB,YAAY;AACd;AACA;EACE,gBAAgB;EAChB,iBAAiB;;AAEnB;AACA;EACE,gBAAgB;;EAEhB,YAAY;AACd;AACA;EACE,gBAAgB;EAChB,iBAAiB;;AAEnB;AACA;EACE,gBAAgB;;EAEhB,YAAY;AACd;AACA;EACE,gBAAgB;EAChB,iBAAiB;;AAEnB;AACA;EACE,gBAAgB;;EAEhB,YAAY;AACd;AACA;EACE,gBAAgB;EAChB,iBAAiB;;AAEnB;AACA;EACE,gBAAgB;;EAEhB,YAAY;AACd;AACA;EACE,gBAAgB;EAChB,iBAAiB;;EAEjB,YAAY;AACd;AACA;EACE,gBAAgB;EAChB,iBAAiB;;AAEnB;AACA;EACE,gBAAgB;;EAEhB,YAAY;AACd;AACA;EACE,gBAAgB;EAChB,iBAAiB;;AAEnB;AACA;EACE,gBAAgB;;EAEhB,YAAY;AACd;AACA;EACE,gBAAgB;EAChB,iBAAiB;;AAEnB;AACA;EACE,gBAAgB;;EAEhB,YAAY;AACd;AACA;EACE,gBAAgB;EAChB,iBAAiB;;AAEnB;AACA;EACE,gBAAgB;;EAEhB,YAAY;AACd;AACA;EACE,gBAAgB;EAChB,iBAAiB;;AAEnB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;;EAEhB,YAAY;AACd;AACA;EACE,gBAAgB;EAChB,iBAAiB;;AAEnB;AACA;EACE,gBAAgB;;AAElB;AACA;EACE,gBAAgB;EAChB,iBAAiB;;EAEjB,YAAY;AACd;AACA;EACE,gBAAgB;;EAEhB,YAAY;AACd;AACA;EACE,gBAAgB;EAChB,iBAAiB;;EAEjB,YAAY;AACd;AACA;EACE,gBAAgB;EAChB,iBAAiB;;EAEjB,YAAY;AACd;AACA;EACE,gBAAgB;EAChB,iBAAiB;;AAEnB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;;AAElB;AACA;EACE,gBAAgB;EAChB,iBAAiB;;EAEjB,YAAY;AACd;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;;EAEhB,YAAY;AACd;AACA;EACE,gBAAgB;EAChB,iBAAiB;;AAEnB;AACA;EACE,gBAAgB;;EAEhB,YAAY;AACd;AACA;EACE,gBAAgB;EAChB,iBAAiB;;AAEnB;AACA;EACE,gBAAgB;;AAElB;AACA;EACE,gBAAgB;EAChB,iBAAiB;;EAEjB,YAAY;AACd;AACA;EACE,gBAAgB;EAChB,iBAAiB;EACjB,yBAAyB;AAC3B;AACA;EACE,gBAAgB;EAChB,iBAAiB;;AAEnB;AACA;EACE,gBAAgB;;EAEhB,YAAY;AACd;AACA;EACE,gBAAgB;EAChB,iBAAiB;;EAEjB,YAAY;AACd;AACA;EACE,gBAAgB;EAChB,iBAAiB;;AAEnB;AACA;EACE,gBAAgB;;AAElB;AACA;EACE,gBAAgB;EAChB,iBAAiB;;EAEjB,YAAY;AACd;AACA;EACE,gBAAgB;;AAElB;AACA;EACE,gBAAgB;EAChB,iBAAiB;;EAEjB,YAAY;AACd;AACA;EACE,gBAAgB;;AAElB;AACA;EACE,gBAAgB;EAChB,iBAAiB;;EAEjB,YAAY;AACd;AACA;EACE,gBAAgB;;EAEhB,YAAY;AACd;AACA;EACE,gBAAgB;EAChB,iBAAiB;;EAEjB,YAAY;AACd;AACA;EACE,gBAAgB;EAChB,iBAAiB;;AAEnB;AACA;EACE,gBAAgB;EAChB,iBAAiB;;EAEjB,YAAY;AACd;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;;EAEhB,YAAY;AACd;AACA;EACE,gBAAgB;EAChB,iBAAiB;;AAEnB;AACA;EACE,gBAAgB;EAChB,iBAAiB;;AAEnB;AACA;EACE,gBAAgB;EAChB,iBAAiB;;AAEnB;AACA;EACE,gBAAgB;;EAEhB,YAAY;AACd;AACA;EACE,gBAAgB;EAChB,iBAAiB;;AAEnB;AACA;EACE,gBAAgB;EAChB,iBAAiB;;EAEjB,YAAY;AACd;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;;AAElB;AACA;EACE,gBAAgB;EAChB,iBAAiB;;EAEjB,YAAY;AACd;AACA;EACE,gBAAgB;;EAEhB,YAAY;AACd;AACA;EACE,gBAAgB;EAChB,iBAAiB;;AAEnB;AACA;EACE,gBAAgB;EAChB,iBAAiB;;EAEjB,YAAY;AACd;AACA;EACE,gBAAgB;;AAElB;AACA;EACE,gBAAgB;EAChB,iBAAiB;;EAEjB,YAAY;AACd;AACA;EACE,gBAAgB;;EAEhB,YAAY;AACd;AACA;EACE,gBAAgB;EAChB,iBAAiB;;AAEnB;AACA;EACE,gBAAgB;;EAEhB,YAAY;AACd;AACA;EACE,gBAAgB;EAChB,iBAAiB;;AAEnB;AACA;EACE,gBAAgB;;EAEhB,YAAY;AACd;AACA;EACE,gBAAgB;EAChB,iBAAiB;;AAEnB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;;EAEhB,YAAY;AACd;AACA;EACE,gBAAgB;EAChB,iBAAiB;;AAEnB;AACA;EACE,gBAAgB;;EAEhB,YAAY;AACd;AACA;EACE,gBAAgB;EAChB,iBAAiB;;AAEnB;AACA;EACE,gBAAgB;EAChB,iBAAiB;;EAEjB,YAAY;AACd;AACA;EACE,gBAAgB;EAChB,iBAAiB;;EAEjB,YAAY;AACd;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;;EAEhB,YAAY;AACd;AACA;EACE,gBAAgB;EAChB,iBAAiB;;AAEnB;AACA;EACE,gBAAgB;EAChB,iBAAiB;;EAEjB,YAAY;AACd;AACA;EACE,gBAAgB;EAChB,iBAAiB;;EAEjB,YAAY;AACd;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;;AAElB;AACA;EACE,gBAAgB;EAChB,iBAAiB;;EAEjB,YAAY;AACd;AACA;EACE,gBAAgB;;EAEhB,YAAY;AACd;AACA;EACE,gBAAgB;EAChB,iBAAiB;;AAEnB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;;EAEhB,YAAY;AACd;AACA;EACE,gBAAgB;EAChB,iBAAiB;;AAEnB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;;EAEhB,YAAY;AACd;AACA;EACE,gBAAgB;EAChB,iBAAiB;;AAEnB;AACA;EACE,gBAAgB;;EAEhB,YAAY;AACd;AACA;EACE,gBAAgB;EAChB,iBAAiB;;AAEnB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;;AAElB;AACA;EACE,gBAAgB;EAChB,iBAAiB;;AAEnB;AACA;EACE,gBAAgB;EAChB,iBAAiB;;EAEjB,YAAY;AACd;AACA;EACE,gBAAgB;;AAElB;AACA;EACE,gBAAgB;EAChB,iBAAiB;;EAEjB,YAAY;AACd;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;;AAElB;AACA;EACE,gBAAgB;EAChB,iBAAiB;;EAEjB,YAAY;AACd;AACA;EACE,gBAAgB;;AAElB;AACA;EACE,gBAAgB;EAChB,iBAAiB;;EAEjB,YAAY;AACd;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;;EAEhB,YAAY;AACd;AACA;EACE,gBAAgB;EAChB,iBAAiB;;AAEnB;AACA;EACE,gBAAgB;;AAElB;AACA;EACE,gBAAgB;EAChB,iBAAiB;;EAEjB,YAAY;AACd;AACA;EACE,gBAAgB;;AAElB;AACA;EACE,gBAAgB;EAChB,iBAAiB;;EAEjB,YAAY;AACd;AACA;EACE,gBAAgB;;EAEhB,YAAY;AACd;AACA;EACE,gBAAgB;EAChB,iBAAiB;;AAEnB;AACA;EACE,gBAAgB;;EAEhB,YAAY;AACd;AACA;EACE,gBAAgB;EAChB,iBAAiB;;AAEnB;AACA;EACE,gBAAgB;;EAEhB,YAAY;AACd;AACA;EACE,gBAAgB;EAChB,iBAAiB;;AAEnB;AACA;EACE,gBAAgB;;AAElB;AACA;EACE,gBAAgB;EAChB,iBAAiB;;EAEjB,YAAY;AACd;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;;EAEhB,YAAY;AACd;AACA;EACE,gBAAgB;EAChB,iBAAiB;;AAEnB;AACA;EACE,gBAAgB;;EAEhB,YAAY;AACd;AACA;EACE,gBAAgB;EAChB,iBAAiB;;AAEnB;AACA;EACE,gBAAgB;;EAEhB,YAAY;AACd;AACA;EACE,gBAAgB;EAChB,iBAAiB;;AAEnB;AACA;EACE,gBAAgB;;AAElB;AACA;EACE,gBAAgB;EAChB,iBAAiB;;EAEjB,YAAY;AACd;AACA;EACE,gBAAgB;;EAEhB,YAAY;AACd;AACA;EACE,gBAAgB;EAChB,iBAAiB;;AAEnB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;;AAElB;AACA;EACE,gBAAgB;EAChB,iBAAiB;;EAEjB,YAAY;AACd;AACA;EACE,gBAAgB;;AAElB;AACA;EACE,gBAAgB;EAChB,iBAAiB;;EAEjB,YAAY;AACd;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;;EAEhB,YAAY;AACd;AACA;EACE,gBAAgB;EAChB,iBAAiB;;AAEnB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;;EAEhB,YAAY;AACd;AACA;EACE,gBAAgB;EAChB,iBAAiB;;EAEjB,YAAY;AACd;AACA;EACE,gBAAgB;EAChB,iBAAiB;;EAEjB,YAAY;AACd;AACA;EACE,gBAAgB;EAChB,iBAAiB;;EAEjB,YAAY;AACd;AACA;EACE,gBAAgB;EAChB,iBAAiB;;AAEnB;AACA;EACE,gBAAgB;;AAElB;AACA;EACE,gBAAgB;EAChB,iBAAiB;;EAEjB,YAAY;AACd;AACA;EACE,gBAAgB;;AAElB;AACA;EACE,gBAAgB;EAChB,iBAAiB;;EAEjB,YAAY;AACd;AACA;EACE,gBAAgB;;EAEhB,YAAY;AACd;AACA;EACE,gBAAgB;EAChB,iBAAiB;;AAEnB;AACA;EACE,gBAAgB;;EAEhB,YAAY;AACd;AACA;EACE,gBAAgB;EAChB,iBAAiB;;AAEnB;AACA;EACE,gBAAgB;;AAElB;AACA;EACE,gBAAgB;EAChB,iBAAiB;;AAEnB;AACA;EACE,gBAAgB;EAChB,iBAAiB;;EAEjB,YAAY;AACd;AACA;EACE,gBAAgB;;AAElB;AACA;EACE,gBAAgB;EAChB,iBAAiB;;EAEjB,YAAY;AACd;AACA;EACE,gBAAgB;EAChB,iBAAiB;;EAEjB,YAAY;AACd;AACA;EACE,gBAAgB;;EAEhB,YAAY;AACd;AACA;EACE,gBAAgB;EAChB,iBAAiB;;EAEjB,YAAY;AACd;AACA;EACE,gBAAgB;EAChB,iBAAiB;;EAEjB,YAAY;AACd;AACA;EACE,gBAAgB;EAChB,iBAAiB;;AAEnB;AACA;EACE,gBAAgB;;AAElB;AACA;EACE,gBAAgB;EAChB,iBAAiB;;EAEjB,YAAY;AACd;AACA;EACE,gBAAgB;;AAElB;AACA;EACE,gBAAgB;EAChB,iBAAiB;;EAEjB,YAAY;AACd;AACA;EACE,gBAAgB;;AAElB;AACA;EACE,gBAAgB;EAChB,iBAAiB;;EAEjB,YAAY;AACd;AACA;EACE,gBAAgB;EAChB,iBAAiB;;EAEjB,YAAY;AACd;AACA;EACE,gBAAgB;EAChB,iBAAiB;;EAEjB,YAAY;AACd;AACA;EACE,gBAAgB;EAChB,iBAAiB;;EAEjB,YAAY;AACd;AACA;EACE,gBAAgB;;EAEhB,YAAY;AACd;AACA;EACE,gBAAgB;EAChB,iBAAiB;;AAEnB;AACA;EACE,gBAAgB;EAChB,iBAAiB;;EAEjB,YAAY;AACd;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;;EAEhB,YAAY;AACd;AACA;EACE,gBAAgB;EAChB,iBAAiB;;AAEnB;AACA;EACE,gBAAgB;;EAEhB,YAAY;AACd;AACA;EACE,gBAAgB;EAChB,iBAAiB;;AAEnB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;;EAEhB,YAAY;AACd;AACA;EACE,gBAAgB;EAChB,iBAAiB;;AAEnB;AACA;EACE,gBAAgB;;EAEhB,YAAY;AACd;AACA;EACE,gBAAgB;EAChB,iBAAiB;;AAEnB;AACA;EACE,gBAAgB;;AAElB;AACA;EACE,gBAAgB;EAChB,iBAAiB;;EAEjB,YAAY;AACd;AACA;EACE,gBAAgB;;AAElB;AACA;EACE,gBAAgB;EAChB,iBAAiB;;EAEjB,YAAY;AACd;AACA;EACE,gBAAgB;;AAElB;AACA;EACE,gBAAgB;EAChB,iBAAiB;;EAEjB,YAAY;AACd;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;;AAElB;AACA;EACE,gBAAgB;EAChB,iBAAiB;;EAEjB,YAAY;AACd;AACA;EACE,gBAAgB;;AAElB;AACA;EACE,gBAAgB;EAChB,iBAAiB;;EAEjB,YAAY;AACd;AACA;EACE,gBAAgB;;EAEhB,YAAY;AACd;AACA;EACE,gBAAgB;EAChB,iBAAiB;;AAEnB;AACA;EACE,gBAAgB;;EAEhB,YAAY;AACd;AACA;EACE,gBAAgB;EAChB,iBAAiB;;AAEnB;AACA;EACE,gBAAgB;;EAEhB,YAAY;AACd;AACA;EACE,gBAAgB;EAChB,iBAAiB;;AAEnB;AACA;EACE,gBAAgB;;EAEhB,YAAY;AACd;AACA;EACE,gBAAgB;EAChB,iBAAiB;;EAEjB,YAAY;AACd;AACA;EACE,gBAAgB;EAChB,iBAAiB;;EAEjB,YAAY;AACd;AACA;EACE,gBAAgB;EAChB,iBAAiB;;AAEnB;AACA;EACE,gBAAgB;EAChB,iBAAiB;;AAEnB;AACA;EACE,gBAAgB;;EAEhB,YAAY;AACd;AACA;EACE,gBAAgB;EAChB,iBAAiB;;EAEjB,YAAY;AACd;AACA;EACE,gBAAgB;EAChB,iBAAiB;;EAEjB,YAAY;AACd;AACA;EACE,gBAAgB;EAChB,iBAAiB;;AAEnB;AACA;EACE,gBAAgB;EAChB,iBAAiB;;AAEnB;AACA;EACE,gBAAgB;;EAEhB,YAAY;AACd;AACA;EACE,gBAAgB;EAChB,iBAAiB;;AAEnB;AACA;EACE,gBAAgB;;EAEhB,YAAY;AACd;AACA;EACE,gBAAgB;EAChB,iBAAiB;;AAEnB;AACA;EACE,gBAAgB;;EAEhB,YAAY;AACd;AACA;EACE,gBAAgB;EAChB,iBAAiB;;EAEjB,YAAY;AACd;AACA;EACE,gBAAgB;EAChB,iBAAiB;;AAEnB;AACA;EACE,gBAAgB;;EAEhB,YAAY;AACd;AACA;EACE,gBAAgB;EAChB,iBAAiB;;AAEnB;AACA;EACE,gBAAgB;;EAEhB,YAAY;AACd;AACA;EACE,gBAAgB;EAChB,iBAAiB;;AAEnB;AACA;EACE,gBAAgB;;EAEhB,YAAY;AACd;AACA;EACE,gBAAgB;EAChB,iBAAiB;;EAEjB,YAAY;AACd;AACA;EACE,gBAAgB;EAChB,iBAAiB;;AAEnB;AACA;EACE,gBAAgB;;EAEhB,YAAY;AACd;AACA;EACE,gBAAgB;EAChB,iBAAiB;;AAEnB;AACA;EACE,gBAAgB;EAChB,iBAAiB;;AAEnB;AACA;EACE,gBAAgB;;EAEhB,YAAY;AACd;AACA;EACE,gBAAgB;EAChB,iBAAiB;;AAEnB;AACA;EACE,gBAAgB;;EAEhB,YAAY;AACd;AACA;EACE,gBAAgB;EAChB,iBAAiB;;AAEnB;AACA;EACE,gBAAgB;;EAEhB,YAAY;AACd;AACA;EACE,gBAAgB;EAChB,iBAAiB;;AAEnB;AACA;EACE,gBAAgB;;EAEhB,YAAY;AACd;AACA;EACE,gBAAgB;EAChB,iBAAiB;;AAEnB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;;EAEhB,YAAY;AACd;AACA;EACE,gBAAgB;EAChB,iBAAiB;;AAEnB;AACA;EACE,gBAAgB;;EAEhB,YAAY;AACd;AACA;EACE,gBAAgB;EAChB,iBAAiB;;AAEnB;AACA;EACE,gBAAgB;;AAElB;AACA;EACE,gBAAgB;EAChB,iBAAiB;;EAEjB,YAAY;AACd;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;;EAEhB,YAAY;AACd;AACA;EACE,gBAAgB;EAChB,iBAAiB;;AAEnB;AACA;EACE,gBAAgB;;EAEhB,YAAY;AACd;AACA;EACE,gBAAgB;EAChB,iBAAiB;;AAEnB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;;EAEhB,YAAY;AACd;AACA;EACE,gBAAgB;EAChB,iBAAiB;;AAEnB;AACA;EACE,gBAAgB;;EAEhB,YAAY;AACd;AACA;EACE,gBAAgB;EAChB,iBAAiB;;EAEjB,YAAY;AACd;AACA;EACE,gBAAgB;EAChB,iBAAiB;;AAEnB;AACA;EACE,gBAAgB;;EAEhB,YAAY;AACd;AACA;EACE,gBAAgB;EAChB,iBAAiB;;AAEnB;AACA;EACE,gBAAgB;;EAEhB,YAAY;AACd;AACA;EACE,gBAAgB;EAChB,iBAAiB;;AAEnB;AACA;EACE,gBAAgB;;EAEhB,YAAY;AACd;AACA;EACE,gBAAgB;EAChB,iBAAiB;;AAEnB;AACA;EACE,gBAAgB;;EAEhB,YAAY;AACd;AACA;EACE,gBAAgB;EAChB,iBAAiB;;AAEnB;AACA;EACE,gBAAgB;;EAEhB,YAAY;AACd;AACA;EACE,gBAAgB;EAChB,iBAAiB;;EAEjB,YAAY;AACd;AACA;EACE,gBAAgB;EAChB,iBAAiB;;AAEnB;AACA;EACE,gBAAgB;EAChB,iBAAiB;;EAEjB,YAAY;AACd;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;;EAEhB,YAAY;AACd;AACA;EACE,gBAAgB;EAChB,iBAAiB;;AAEnB;AACA;EACE,gBAAgB;;EAEhB,YAAY;AACd;AACA;EACE,gBAAgB;EAChB,iBAAiB;;AAEnB;AACA;EACE,gBAAgB;;AAElB;AACA;EACE,gBAAgB;EAChB,iBAAiB;;EAEjB,YAAY;AACd;AACA;EACE,gBAAgB;EAChB,iBAAiB;;EAEjB,YAAY;AACd;AACA;EACE,gBAAgB;EAChB,iBAAiB;;EAEjB,YAAY;AACd;AACA;EACE,gBAAgB;;EAEhB,YAAY;AACd;AACA;EACE,gBAAgB;EAChB,iBAAiB;;EAEjB,YAAY;AACd;AACA;EACE,gBAAgB;EAChB,iBAAiB;;AAEnB;AACA;EACE,gBAAgB;;EAEhB,YAAY;AACd;AACA;EACE,gBAAgB;EAChB,iBAAiB;;AAEnB;AACA;EACE,gBAAgB;;EAEhB,YAAY;AACd;AACA;EACE,gBAAgB;EAChB,iBAAiB;;AAEnB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;;AAElB;AACA;EACE,gBAAgB;EAChB,iBAAiB;;EAEjB,YAAY;AACd;AACA;EACE,gBAAgB;;EAEhB,YAAY;AACd;AACA;EACE,gBAAgB;EAChB,iBAAiB;;AAEnB;AACA;EACE,gBAAgB;;AAElB;AACA;EACE,gBAAgB;EAChB,iBAAiB;;EAEjB,YAAY;AACd;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;;AAElB;AACA;EACE,gBAAgB;EAChB,iBAAiB;;EAEjB,YAAY;AACd;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;;EAEhB,YAAY;AACd;AACA;EACE,gBAAgB;EAChB,iBAAiB;;AAEnB;AACA;EACE,gBAAgB;;AAElB;AACA;EACE,gBAAgB;EAChB,iBAAiB;;EAEjB,YAAY;AACd;AACA;EACE,gBAAgB;;AAElB;AACA;EACE,gBAAgB;EAChB,iBAAiB;;EAEjB,YAAY;AACd;AACA;EACE,gBAAgB;;EAEhB,YAAY;AACd;AACA;EACE,gBAAgB;EAChB,iBAAiB;;AAEnB;AACA;EACE,gBAAgB;;AAElB;AACA;EACE,gBAAgB;EAChB,iBAAiB;;EAEjB,YAAY;AACd;AACA;EACE,gBAAgB;;AAElB;AACA;EACE,gBAAgB;EAChB,iBAAiB;;EAEjB,YAAY;AACd;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;;AAElB;AACA;EACE,gBAAgB;EAChB,iBAAiB;;EAEjB,YAAY;AACd;AACA;EACE,gBAAgB;;EAEhB,YAAY;AACd;AACA;EACE,gBAAgB;EAChB,iBAAiB;;EAEjB,YAAY;AACd;AACA;EACE,gBAAgB;EAChB,iBAAiB;;AAEnB;AACA;EACE,gBAAgB;EAChB,iBAAiB;;AAEnB;AACA;EACE,gBAAgB;;AAElB;AACA;EACE,gBAAgB;EAChB,iBAAiB;;EAEjB,YAAY;AACd;AACA;EACE,gBAAgB;;EAEhB,YAAY;AACd;AACA;EACE,gBAAgB;EAChB,iBAAiB;;AAEnB;AACA;EACE,gBAAgB;;AAElB;AACA;EACE,gBAAgB;EAChB,iBAAiB;;EAEjB,YAAY;AACd;AACA;EACE,gBAAgB;EAChB,iBAAiB;;EAEjB,YAAY;AACd;AACA;EACE,gBAAgB;;AAElB;AACA;EACE,gBAAgB;EAChB,iBAAiB;;EAEjB,YAAY;AACd;AACA;EACE,gBAAgB;;AAElB;AACA;EACE,gBAAgB;EAChB,iBAAiB;;EAEjB,YAAY;AACd;AACA;EACE,gBAAgB;;AAElB;AACA;EACE,gBAAgB;EAChB,iBAAiB;;EAEjB,YAAY;AACd;AACA;EACE,gBAAgB;;EAEhB,YAAY;AACd;AACA;EACE,gBAAgB;EAChB,iBAAiB;;AAEnB;AACA;EACE,gBAAgB;;AAElB;AACA;EACE,gBAAgB;EAChB,iBAAiB;;EAEjB,YAAY;AACd;AACA;EACE,gBAAgB;EAChB,iBAAiB;;EAEjB,YAAY;AACd;AACA;EACE,gBAAgB;;EAEhB,YAAY;AACd;AACA;EACE,gBAAgB;EAChB,iBAAiB;;AAEnB;AACA;EACE,gBAAgB;;EAEhB,YAAY;AACd;AACA;EACE,gBAAgB;EAChB,iBAAiB;;AAEnB;AACA;EACE,gBAAgB;EAChB,iBAAiB;;AAEnB;AACA;EACE,gBAAgB;;EAEhB,YAAY;AACd;AACA;EACE,gBAAgB;EAChB,iBAAiB;;EAEjB,YAAY;AACd;AACA;EACE,gBAAgB;EAChB,iBAAiB;;AAEnB;AACA;EACE,gBAAgB;EAChB,iBAAiB;;AAEnB;AACA;EACE,gBAAgB;EAChB,iBAAiB;;AAEnB;AACA;EACE,gBAAgB;EAChB,iBAAiB;;AAEnB;AACA;EACE,gBAAgB;EAChB,iBAAiB;;AAEnB;AACA;EACE,gBAAgB;EAChB,iBAAiB;;AAEnB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;;EAEhB,YAAY;AACd;AACA;EACE,gBAAgB;EAChB,iBAAiB;;AAEnB;AACA;EACE,gBAAgB;EAChB,iBAAiB;;EAEjB,YAAY;AACd;AACA;EACE,gBAAgB;;EAEhB,YAAY;AACd;AACA;EACE,gBAAgB;EAChB,iBAAiB;;AAEnB;AACA;EACE,gBAAgB;;EAEhB,YAAY;AACd;AACA;EACE,gBAAgB;EAChB,iBAAiB;;EAEjB,YAAY;AACd;AACA;EACE,gBAAgB;EAChB,iBAAiB;;AAEnB;AACA;EACE,gBAAgB;;EAEhB,YAAY;AACd;AACA;EACE,gBAAgB;EAChB,iBAAiB;;EAEjB,YAAY;AACd;AACA;EACE,gBAAgB;EAChB,iBAAiB;;AAEnB;AACA;EACE,gBAAgB;;EAEhB,YAAY;AACd;AACA;EACE,gBAAgB;EAChB,iBAAiB;;AAEnB;AACA;EACE,gBAAgB;;EAEhB,YAAY;AACd;AACA;EACE,gBAAgB;EAChB,iBAAiB;;AAEnB;AACA;EACE,gBAAgB;;EAEhB,YAAY;AACd;AACA;EACE,gBAAgB;EAChB,iBAAiB;;AAEnB;AACA;EACE,gBAAgB;;EAEhB,YAAY;AACd;AACA;EACE,gBAAgB;EAChB,iBAAiB;;AAEnB;AACA;EACE,gBAAgB;EAChB,iBAAiB;;AAEnB;AACA;EACE,gBAAgB;EAChB,iBAAiB;;AAEnB;AACA;EACE,gBAAgB;;AAElB;AACA;EACE,gBAAgB;EAChB,iBAAiB;;EAEjB,YAAY;AACd;AACA;EACE,gBAAgB;;EAEhB,YAAY;AACd;AACA;EACE,gBAAgB;EAChB,iBAAiB;;AAEnB;AACA;EACE,gBAAgB;;EAEhB,YAAY;AACd;AACA;EACE,gBAAgB;EAChB,iBAAiB;;AAEnB;AACA;EACE,gBAAgB;;AAElB;AACA;EACE,gBAAgB;EAChB,iBAAiB;;EAEjB,YAAY;AACd;AACA;EACE,gBAAgB;EAChB,iBAAiB;;EAEjB,YAAY;AACd;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;;EAEhB,YAAY;AACd;AACA;EACE,gBAAgB;EAChB,iBAAiB;;AAEnB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;;EAEhB,YAAY;AACd;AACA;EACE,gBAAgB;EAChB,iBAAiB;;AAEnB;AACA;EACE,gBAAgB;;AAElB;AACA;EACE,gBAAgB;EAChB,iBAAiB;;EAEjB,YAAY;AACd;AACA;EACE,gBAAgB;;AAElB;AACA;EACE,gBAAgB;EAChB,iBAAiB;;EAEjB,YAAY;AACd;AACA;EACE,gBAAgB;;EAEhB,YAAY;AACd;AACA;EACE,gBAAgB;EAChB,iBAAiB;;AAEnB;AACA;EACE,gBAAgB;;EAEhB,YAAY;AACd;AACA;EACE,gBAAgB;EAChB,iBAAiB;;AAEnB;AACA;EACE,gBAAgB;;AAElB;AACA;EACE,gBAAgB;EAChB,iBAAiB;;EAEjB,YAAY;AACd;AACA;EACE,gBAAgB;;EAEhB,YAAY;AACd;AACA;EACE,gBAAgB;EAChB,iBAAiB;;EAEjB,YAAY;AACd;AACA;EACE,gBAAgB;EAChB,iBAAiB;;EAEjB,YAAY;AACd;AACA;EACE,gBAAgB;EAChB,iBAAiB;;EAEjB,YAAY;AACd;AACA;EACE,gBAAgB;EAChB,iBAAiB;;AAEnB;AACA;EACE,gBAAgB;EAChB,iBAAiB;;AAEnB;AACA;EACE,gBAAgB;EAChB,iBAAiB;;AAEnB;AACA;EACE,gBAAgB;;EAEhB,YAAY;AACd;AACA;EACE,gBAAgB;EAChB,iBAAiB;;AAEnB;AACA;EACE,gBAAgB;EAChB,iBAAiB;;AAEnB;AACA;EACE,gBAAgB;;AAElB;AACA;EACE,gBAAgB;EAChB,iBAAiB;;EAEjB,YAAY;AACd;AACA;EACE,gBAAgB;EAChB,iBAAiB;;AAEnB;AACA;EACE,gBAAgB;;AAElB;AACA;EACE,gBAAgB;EAChB,iBAAiB;;EAEjB,YAAY;AACd;AACA;EACE,gBAAgB;;EAEhB,YAAY;AACd;AACA;EACE,gBAAgB;EAChB,iBAAiB;;AAEnB;AACA;EACE,gBAAgB;EAChB,iBAAiB;;AAEnB;AACA;EACE,gBAAgB;EAChB,iBAAiB;;EAEjB,YAAY;AACd;AACA;EACE,gBAAgB;EAChB,iBAAiB;;EAEjB,YAAY;AACd;AACA;EACE,gBAAgB;;AAElB;AACA;EACE,gBAAgB;EAChB,iBAAiB;;EAEjB,YAAY;AACd;AACA;EACE,gBAAgB;;AAElB;AACA;EACE,gBAAgB;EAChB,iBAAiB;;EAEjB,YAAY;AACd;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;;EAEhB,YAAY;AACd;AACA;EACE,gBAAgB;EAChB,iBAAiB;;AAEnB;AACA;EACE,gBAAgB;EAChB,iBAAiB;;AAEnB;AACA;EACE,gBAAgB;;AAElB;AACA;EACE,gBAAgB;EAChB,iBAAiB;;EAEjB,YAAY;AACd;AACA;EACE,gBAAgB;;AAElB;AACA;EACE,gBAAgB;EAChB,iBAAiB;;EAEjB,YAAY;AACd;AACA;EACE,gBAAgB;;AAElB;AACA;EACE,gBAAgB;EAChB,iBAAiB;;EAEjB,YAAY;AACd;AACA;EACE,gBAAgB;EAChB,iBAAiB;;EAEjB,YAAY;AACd;AACA;EACE,gBAAgB;;AAElB;AACA;EACE,gBAAgB;EAChB,iBAAiB;;EAEjB,YAAY;AACd;AACA;EACE,gBAAgB;;AAElB;AACA;EACE,gBAAgB;EAChB,iBAAiB;;EAEjB,YAAY;AACd;AACA;EACE,gBAAgB;EAChB,iBAAiB;;EAEjB,YAAY;AACd;AACA;EACE,gBAAgB;;AAElB;AACA;EACE,gBAAgB;EAChB,iBAAiB;;EAEjB,YAAY;AACd;AACA;EACE,gBAAgB;;AAElB;AACA;EACE,gBAAgB;EAChB,iBAAiB;;EAEjB,YAAY;AACd;AACA;EACE,gBAAgB;;AAElB;AACA;EACE,gBAAgB;EAChB,iBAAiB;;EAEjB,YAAY;AACd;AACA;EACE,gBAAgB;EAChB,iBAAiB;;EAEjB,YAAY;AACd;AACA;EACE,gBAAgB;EAChB,iBAAiB;;EAEjB,YAAY;AACd;AACA;EACE,gBAAgB;;EAEhB,YAAY;AACd;AACA;EACE,gBAAgB;EAChB,iBAAiB;;EAEjB,YAAY;AACd;AACA;EACE,gBAAgB;EAChB,iBAAiB;;EAEjB,YAAY;AACd;AACA;EACE,gBAAgB;EAChB,iBAAiB;;AAEnB;AACA;EACE,gBAAgB;;EAEhB,YAAY;AACd;AACA;EACE,gBAAgB;EAChB,iBAAiB;;AAEnB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;;AAElB;AACA;EACE,gBAAgB;EAChB,iBAAiB;;EAEjB,YAAY;AACd;AACA;EACE,gBAAgB;;EAEhB,YAAY;AACd;AACA;EACE,gBAAgB;EAChB,iBAAiB;;AAEnB;AACA;EACE,gBAAgB;;EAEhB,YAAY;AACd;AACA;EACE,gBAAgB;EAChB,iBAAiB;;AAEnB;AACA;EACE,gBAAgB;;EAEhB,YAAY;AACd;AACA;EACE,gBAAgB;EAChB,iBAAiB;;AAEnB;AACA;EACE,gBAAgB;;EAEhB,YAAY;AACd;AACA;EACE,gBAAgB;EAChB,iBAAiB;;AAEnB;AACA;EACE,gBAAgB;;EAEhB,YAAY;AACd;AACA;EACE,gBAAgB;EAChB,iBAAiB;;AAEnB;AACA;EACE,gBAAgB;;EAEhB,YAAY;AACd;AACA;EACE,gBAAgB;EAChB,iBAAiB;;AAEnB;AACA;EACE,gBAAgB;;EAEhB,YAAY;AACd;AACA;EACE,gBAAgB;EAChB,iBAAiB;;AAEnB;AACA;EACE,gBAAgB;;EAEhB,YAAY;AACd;AACA;EACE,gBAAgB;EAChB,iBAAiB;;AAEnB;AACA;EACE,gBAAgB;;EAEhB,YAAY;AACd;AACA;EACE,gBAAgB;EAChB,iBAAiB;;AAEnB;AACA;EACE,gBAAgB;;EAEhB,YAAY;AACd;AACA;EACE,gBAAgB;EAChB,iBAAiB;;AAEnB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;;AAElB;AACA;EACE,gBAAgB;EAChB,iBAAiB;;EAEjB,YAAY;AACd;AACA;EACE,gBAAgB;;AAElB;AACA;EACE,gBAAgB;EAChB,iBAAiB;;EAEjB,YAAY;AACd;AACA;EACE,gBAAgB;;AAElB;AACA;EACE,gBAAgB;EAChB,iBAAiB;;EAEjB,YAAY;AACd;AACA;EACE,gBAAgB;;EAEhB,YAAY;AACd;AACA;EACE,gBAAgB;EAChB,iBAAiB;;AAEnB;AACA;EACE,gBAAgB;;AAElB;AACA;EACE,gBAAgB;EAChB,iBAAiB;;EAEjB,YAAY;AACd;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;;EAEhB,YAAY;AACd;AACA;EACE,gBAAgB;EAChB,iBAAiB;;AAEnB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;;EAEhB,YAAY;AACd;AACA;EACE,gBAAgB;EAChB,iBAAiB;;AAEnB;AACA;EACE,gBAAgB;;AAElB;AACA;EACE,gBAAgB;EAChB,iBAAiB;;EAEjB,YAAY;AACd;AACA;EACE,gBAAgB;;AAElB;AACA;EACE,gBAAgB;EAChB,iBAAiB;;EAEjB,YAAY;AACd;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;;AAElB;AACA;EACE,gBAAgB;EAChB,iBAAiB;;EAEjB,YAAY;AACd;AACA;EACE,gBAAgB;;EAEhB,YAAY;AACd;AACA;EACE,gBAAgB;EAChB,iBAAiB;;AAEnB;AACA;EACE,gBAAgB;EAChB,iBAAiB;;EAEjB,YAAY;AACd;AACA;EACE,gBAAgB;;EAEhB,YAAY;AACd;AACA;EACE,gBAAgB;EAChB,iBAAiB;;AAEnB;AACA;EACE,gBAAgB;EAChB,iBAAiB;;EAEjB,YAAY;AACd;AACA;EACE,gBAAgB;;AAElB;AACA;EACE,gBAAgB;EAChB,iBAAiB;;EAEjB,YAAY;AACd;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;;EAEhB,YAAY;AACd;AACA;EACE,gBAAgB;EAChB,iBAAiB;;AAEnB;AACA;EACE,gBAAgB;;AAElB;AACA;EACE,gBAAgB;EAChB,iBAAiB;;EAEjB,YAAY;AACd;AACA;EACE,gBAAgB;;AAElB;AACA;EACE,gBAAgB;EAChB,iBAAiB;;EAEjB,YAAY;AACd;AACA;EACE,gBAAgB;;EAEhB,YAAY;AACd;AACA;EACE,gBAAgB;EAChB,iBAAiB;;AAEnB;AACA;EACE,gBAAgB;;AAElB;AACA;EACE,gBAAgB;EAChB,iBAAiB;;EAEjB,YAAY;AACd;AACA;EACE,gBAAgB;;EAEhB,YAAY;AACd;AACA;EACE,gBAAgB;EAChB,iBAAiB;;AAEnB;AACA;EACE,gBAAgB;EAChB,iBAAiB;;AAEnB;AACA;EACE,gBAAgB;;AAElB;AACA;EACE,gBAAgB;EAChB,iBAAiB;;EAEjB,YAAY;AACd;AACA;EACE,gBAAgB;;EAEhB,YAAY;AACd;AACA;EACE,gBAAgB;EAChB,iBAAiB;;AAEnB;AACA;EACE,gBAAgB;;AAElB;AACA;EACE,gBAAgB;EAChB,iBAAiB;;EAEjB,YAAY;AACd;AACA;EACE,gBAAgB;EAChB,iBAAiB;;EAEjB,YAAY;AACd;AACA;EACE,gBAAgB;;EAEhB,YAAY;AACd;AACA;EACE,gBAAgB;EAChB,iBAAiB;;AAEnB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;;AAElB;AACA;EACE,gBAAgB;EAChB,iBAAiB;;EAEjB,YAAY;AACd;AACA;EACE,gBAAgB;;AAElB;AACA;EACE,gBAAgB;EAChB,iBAAiB;;EAEjB,YAAY;AACd;AACA;EACE,gBAAgB;;AAElB;AACA;EACE,gBAAgB;EAChB,iBAAiB;;AAEnB;AACA;EACE,gBAAgB;EAChB,iBAAiB;;AAEnB;AACA;EACE,gBAAgB;EAChB,iBAAiB;;EAEjB,YAAY;AACd;AACA;EACE,gBAAgB;EAChB,iBAAiB;;AAEnB;AACA;EACE,gBAAgB;EAChB,iBAAiB;;AAEnB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;;EAEhB,YAAY;AACd;AACA;EACE,gBAAgB;EAChB,iBAAiB;;AAEnB;AACA;EACE,gBAAgB;;EAEhB,YAAY;AACd;AACA;EACE,gBAAgB;EAChB,iBAAiB;;AAEnB;AACA;EACE,gBAAgB;;AAElB;AACA;EACE,gBAAgB;EAChB,iBAAiB;;EAEjB,YAAY;AACd;AACA;EACE,gBAAgB;;AAElB;AACA;EACE,gBAAgB;EAChB,iBAAiB;;EAEjB,YAAY;AACd;AACA;EACE,gBAAgB;;EAEhB,YAAY;AACd;AACA;EACE,gBAAgB;EAChB,iBAAiB;;AAEnB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;;AAElB;AACA;EACE,gBAAgB;EAChB,iBAAiB;;EAEjB,YAAY;AACd;AACA;EACE,gBAAgB;;EAEhB,YAAY;AACd;AACA;EACE,gBAAgB;EAChB,iBAAiB;;AAEnB;AACA;EACE,gBAAgB;EAChB,iBAAiB;;EAEjB,YAAY;AACd;AACA;EACE,gBAAgB;;EAEhB,YAAY;AACd;AACA;EACE,gBAAgB;EAChB,iBAAiB;;AAEnB;AACA;EACE,gBAAgB;EAChB,iBAAiB;;EAEjB,YAAY;AACd;AACA;EACE,gBAAgB;;AAElB;AACA;EACE,gBAAgB;EAChB,iBAAiB;;EAEjB,YAAY;AACd;AACA;EACE,gBAAgB;;EAEhB,YAAY;AACd;AACA;EACE,gBAAgB;EAChB,iBAAiB;;AAEnB;AACA;EACE,gBAAgB;;EAEhB,YAAY;AACd;AACA;EACE,gBAAgB;EAChB,iBAAiB;;AAEnB;AACA;EACE,gBAAgB;;EAEhB,eAAe;AACjB;AACA;EACE,gBAAgB;EAChB,iBAAiB;;EAEjB,YAAY;AACd;AACA;EACE,gBAAgB;;EAEhB,YAAY;AACd;AACA;EACE,gBAAgB;EAChB,iBAAiB;;AAEnB;AACA;EACE,gBAAgB;;EAEhB,YAAY;AACd;AACA;EACE,gBAAgB;EAChB,iBAAiB;;AAEnB;AACA;EACE,gBAAgB;;EAEhB,YAAY;AACd;AACA;EACE,gBAAgB;EAChB,iBAAiB;;EAEjB,YAAY;AACd;AACA;EACE,gBAAgB;EAChB,iBAAiB;;AAEnB;AACA;EACE,gBAAgB;EAChB,iBAAiB;;AAEnB;AACA;EACE,gBAAgB;EAChB,iBAAiB;;EAEjB,YAAY;AACd;AACA;EACE,gBAAgB;;AAElB;AACA;EACE,gBAAgB;EAChB,iBAAiB;;EAEjB,YAAY;AACd;AACA;EACE,gBAAgB;;AAElB;AACA;EACE,gBAAgB;EAChB,iBAAiB;;EAEjB,YAAY;AACd;AACA;EACE,gBAAgB;;EAEhB,YAAY;AACd;AACA;EACE,gBAAgB;EAChB,iBAAiB;;AAEnB;AACA;EACE,gBAAgB;;AAElB;AACA;EACE,gBAAgB;EAChB,iBAAiB;;EAEjB,YAAY;AACd;AACA;EACE,gBAAgB;EAChB,iBAAiB;;EAEjB,YAAY;AACd;AACA;EACE,gBAAgB;EAChB,iBAAiB;;AAEnB;AACA;EACE,gBAAgB;;AAElB;AACA;EACE,gBAAgB;EAChB,iBAAiB;;EAEjB,YAAY;AACd;AACA;EACE,gBAAgB;EAChB,iBAAiB;;EAEjB,YAAY;AACd;AACA;EACE,gBAAgB;EAChB,iBAAiB;;AAEnB;AACA;EACE,gBAAgB;EAChB,iBAAiB;;EAEjB,YAAY;AACd;AACA;EACE,gBAAgB;EAChB,iBAAiB;;AAEnB;AACA;EACE,gBAAgB;;EAEhB,YAAY;AACd;AACA;EACE,gBAAgB;EAChB,iBAAiB;;AAEnB;AACA;EACE,gBAAgB;;EAEhB,YAAY;AACd;AACA;EACE,gBAAgB;EAChB,iBAAiB;;AAEnB;AACA;EACE,gBAAgB;;AAElB;AACA;EACE,gBAAgB;EAChB,iBAAiB;;EAEjB,YAAY;AACd;AACA;EACE,gBAAgB;;EAEhB,YAAY;AACd;AACA;EACE,gBAAgB;EAChB,iBAAiB;;AAEnB;AACA;EACE,gBAAgB;;EAEhB,YAAY;AACd;AACA;EACE,gBAAgB;EAChB,iBAAiB;;AAEnB;AACA;EACE,gBAAgB;;AAElB;AACA;EACE,gBAAgB;EAChB,iBAAiB;;EAEjB,YAAY;AACd;AACA;EACE,gBAAgB;EAChB,iBAAiB;;EAEjB,YAAY;AACd;AACA;EACE,gBAAgB;EAChB,iBAAiB;;AAEnB;AACA;EACE,gBAAgB;;AAElB;AACA;EACE,gBAAgB;EAChB,iBAAiB;;AAEnB;AACA;EACE,gBAAgB;EAChB,iBAAiB;;EAEjB,YAAY;AACd;AACA;EACE,gBAAgB;EAChB,iBAAiB;;EAEjB,YAAY;AACd;AACA;EACE,gBAAgB;;EAEhB,YAAY;AACd;AACA;EACE,gBAAgB;EAChB,iBAAiB;;AAEnB;AACA;EACE,gBAAgB;;AAElB;AACA;EACE,gBAAgB;EAChB,iBAAiB;;EAEjB,YAAY;AACd;AACA;EACE,gBAAgB;;AAElB;AACA;EACE,gBAAgB;EAChB,iBAAiB;;EAEjB,YAAY;AACd;AACA;EACE,gBAAgB;;EAEhB,YAAY;AACd;AACA;EACE,gBAAgB;EAChB,iBAAiB;;AAEnB;AACA;EACE,gBAAgB;;EAEhB,YAAY;AACd;AACA;EACE,gBAAgB;EAChB,iBAAiB;;AAEnB;AACA;EACE,gBAAgB;;EAEhB,YAAY;AACd;AACA;EACE,gBAAgB;EAChB,iBAAiB;;AAEnB;AACA;EACE,gBAAgB;EAChB,iBAAiB;EACjB,yBAAyB;AAC3B;AACA;EACE,gBAAgB;;AAElB;AACA;EACE,gBAAgB;EAChB,iBAAiB;;EAEjB,YAAY;AACd;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;;EAEhB,YAAY;AACd;AACA;EACE,gBAAgB;EAChB,iBAAiB;;AAEnB;AACA;EACE,gBAAgB;;EAEhB,YAAY;AACd;AACA;EACE,gBAAgB;EAChB,iBAAiB;;AAEnB;AACA;EACE,gBAAgB;;EAEhB,YAAY;AACd;AACA;EACE,gBAAgB;EAChB,iBAAiB;;AAEnB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;;EAEhB,YAAY;AACd;AACA;EACE,gBAAgB;EAChB,iBAAiB;;AAEnB;AACA;EACE,gBAAgB;;EAEhB,YAAY;AACd;AACA;EACE,gBAAgB;EAChB,iBAAiB;;AAEnB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;;EAEhB,YAAY;AACd;AACA;EACE,gBAAgB;EAChB,iBAAiB;;AAEnB;AACA;EACE,gBAAgB;;AAElB;AACA;EACE,gBAAgB;EAChB,iBAAiB;;EAEjB,YAAY;AACd;AACA;EACE,gBAAgB;;EAEhB,YAAY;AACd;AACA;EACE,gBAAgB;EAChB,iBAAiB;;AAEnB;AACA;EACE,gBAAgB;;EAEhB,YAAY;AACd;AACA;EACE,gBAAgB;EAChB,iBAAiB;;AAEnB;AACA;EACE,gBAAgB;;EAEhB,YAAY;AACd;AACA;EACE,gBAAgB;EAChB,iBAAiB;;AAEnB;AACA;EACE,gBAAgB;EAChB,iBAAiB;;AAEnB;AACA;EACE,gBAAgB;;EAEhB,YAAY;AACd;AACA;EACE,gBAAgB;EAChB,iBAAiB;;AAEnB;AACA;EACE,gBAAgB;EAChB,iBAAiB;;EAEjB,YAAY;AACd;AACA;EACE,gBAAgB;EAChB,iBAAiB;;EAEjB,YAAY;AACd;AACA;EACE,gBAAgB;EAChB,iBAAiB;;EAEjB,YAAY;AACd;AACA;EACE,gBAAgB;EAChB,iBAAiB;;EAEjB,YAAY;AACd;AACA;EACE,gBAAgB;EAChB,iBAAiB;;EAEjB,YAAY;AACd;AACA;EACE,gBAAgB;EAChB,iBAAiB;;EAEjB,YAAY;AACd;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;;EAEhB,YAAY;AACd;AACA;EACE,gBAAgB;EAChB,iBAAiB;;AAEnB;AACA;EACE,gBAAgB;;EAEhB,YAAY;AACd;AACA;EACE,gBAAgB;EAChB,iBAAiB;;AAEnB;AACA;EACE,gBAAgB;EAChB,iBAAiB;;AAEnB;AACA;EACE,gBAAgB;EAChB,iBAAiB;;AAEnB;AACA;EACE,gBAAgB;EAChB,iBAAiB;;AAEnB;AACA;EACE,gBAAgB;EAChB,iBAAiB;;AAEnB;AACA;EACE,gBAAgB;EAChB,iBAAiB;;AAEnB;AACA;EACE,gBAAgB;EAChB,iBAAiB;;AAEnB;AACA;EACE,gBAAgB;EAChB,iBAAiB;;AAEnB;AACA;EACE,gBAAgB;;AAElB;AACA;EACE,gBAAgB;EAChB,iBAAiB;;EAEjB,YAAY;AACd;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;;EAEhB,YAAY;AACd;AACA;EACE,gBAAgB;EAChB,iBAAiB;;AAEnB;AACA;EACE,gBAAgB;;AAElB;AACA;EACE,gBAAgB;EAChB,iBAAiB;;EAEjB,YAAY;AACd;AACA;EACE,gBAAgB;;AAElB;AACA;EACE,gBAAgB;EAChB,iBAAiB;;EAEjB,YAAY;AACd;AACA;EACE,gBAAgB;EAChB,iBAAiB;;AAEnB;AACA;EACE,gBAAgB;;EAEhB,YAAY;AACd;AACA;EACE,gBAAgB;EAChB,iBAAiB;;AAEnB;AACA;EACE,gBAAgB;;AAElB;AACA;EACE,gBAAgB;EAChB,iBAAiB;;EAEjB,YAAY;AACd;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;;EAEhB,YAAY;AACd;AACA;EACE,gBAAgB;EAChB,iBAAiB;;AAEnB;AACA;EACE,gBAAgB;;AAElB;AACA;EACE,gBAAgB;EAChB,iBAAiB;;EAEjB,YAAY;AACd;AACA;EACE,gBAAgB;;AAElB;AACA;EACE,gBAAgB;EAChB,iBAAiB;;EAEjB,YAAY;AACd;AACA;EACE,gBAAgB;;EAEhB,YAAY;AACd;AACA;EACE,gBAAgB;EAChB,iBAAiB;;AAEnB;AACA;EACE,gBAAgB;;AAElB;AACA;EACE,gBAAgB;EAChB,iBAAiB;;EAEjB,YAAY;AACd;AACA;EACE,gBAAgB;;AAElB;AACA;EACE,gBAAgB;EAChB,iBAAiB;;EAEjB,YAAY;AACd;AACA;EACE,gBAAgB;;EAEhB,YAAY;AACd;AACA;EACE,gBAAgB;EAChB,iBAAiB;;AAEnB;AACA;EACE,gBAAgB;;EAEhB,YAAY;AACd;AACA;EACE,gBAAgB;EAChB,iBAAiB;;AAEnB;AACA;EACE,gBAAgB;;EAEhB,YAAY;AACd;AACA;EACE,gBAAgB;EAChB,iBAAiB;;AAEnB;AACA;EACE,gBAAgB;;AAElB;AACA;EACE,gBAAgB;EAChB,iBAAiB;;EAEjB,YAAY;AACd;AACA;EACE,gBAAgB;EAChB,iBAAiB;;AAEnB;AACA;EACE,gBAAgB;;EAEhB,YAAY;AACd;AACA;EACE,gBAAgB;EAChB,iBAAiB;;AAEnB;AACA;EACE,gBAAgB;;AAElB;AACA;EACE,gBAAgB;EAChB,iBAAiB;;EAEjB,YAAY;AACd;AACA;EACE,gBAAgB;;EAEhB,YAAY;AACd;AACA;EACE,gBAAgB;EAChB,iBAAiB;;AAEnB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;;EAEhB,YAAY;AACd;AACA;EACE,gBAAgB;EAChB,iBAAiB;;AAEnB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;;AAElB;AACA;EACE,gBAAgB;EAChB,iBAAiB;;EAEjB,YAAY;AACd;AACA;EACE,gBAAgB;EAChB,iBAAiB;;EAEjB,YAAY;AACd;AACA;EACE,gBAAgB;;EAEhB,YAAY;AACd;AACA;EACE,gBAAgB;EAChB,iBAAiB;;AAEnB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;;EAEhB,YAAY;AACd;AACA;EACE,gBAAgB;EAChB,iBAAiB;;AAEnB;AACA;EACE,gBAAgB;;AAElB;AACA;EACE,gBAAgB;EAChB,iBAAiB;;EAEjB,YAAY;AACd;AACA;EACE,gBAAgB;;EAEhB,YAAY;AACd;AACA;EACE,gBAAgB;EAChB,iBAAiB;;AAEnB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;;AAElB;AACA;EACE,gBAAgB;EAChB,iBAAiB;;EAEjB,YAAY;AACd;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;;AAElB;AACA;EACE,gBAAgB;EAChB,iBAAiB;;EAEjB,YAAY;AACd;AACA;EACE,gBAAgB;;EAEhB,YAAY;AACd;AACA;EACE,gBAAgB;EAChB,iBAAiB;;AAEnB;AACA;EACE,gBAAgB;;AAElB;AACA;EACE,gBAAgB;EAChB,iBAAiB;;EAEjB,YAAY;AACd;AACA;EACE,gBAAgB;;EAEhB,YAAY;AACd;AACA;EACE,gBAAgB;EAChB,iBAAiB;;AAEnB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;;AAElB;AACA;EACE,gBAAgB;EAChB,iBAAiB;;EAEjB,YAAY;AACd;AACA;EACE,gBAAgB;;EAEhB,YAAY;AACd;AACA;EACE,gBAAgB;EAChB,iBAAiB;;AAEnB;AACA;EACE,gBAAgB;;EAEhB,YAAY;AACd;AACA;EACE,gBAAgB;EAChB,iBAAiB;;AAEnB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;;EAEhB,YAAY;AACd;AACA;EACE,gBAAgB;EAChB,iBAAiB;;AAEnB;AACA;EACE,gBAAgB;;EAEhB,YAAY;AACd;AACA;EACE,gBAAgB;EAChB,iBAAiB;;AAEnB;AACA;EACE,gBAAgB;;EAEhB,YAAY;AACd;AACA;EACE,gBAAgB;EAChB,iBAAiB;;AAEnB;AACA;EACE,gBAAgB;EAChB,iBAAiB;;AAEnB;AACA;EACE,gBAAgB;;EAEhB,YAAY;AACd;AACA;EACE,gBAAgB;EAChB,iBAAiB;;AAEnB;AACA;EACE,gBAAgB;EAChB,iBAAiB;;EAEjB,YAAY;AACd;AACA;EACE,gBAAgB;EAChB,iBAAiB;;AAEnB;AACA;EACE,gBAAgB;EAChB,iBAAiB;;AAEnB;AACA;EACE,gBAAgB;EAChB,iBAAiB;;AAEnB;AACA;EACE,gBAAgB;;EAEhB,YAAY;AACd;AACA;EACE,gBAAgB;EAChB,iBAAiB;;AAEnB;AACA;EACE,gBAAgB;EAChB,iBAAiB;;AAEnB;AACA;EACE,gBAAgB;EAChB,iBAAiB;;AAEnB;AACA;EACE,gBAAgB;;AAElB;AACA;EACE,gBAAgB;EAChB,iBAAiB;;EAEjB,YAAY;AACd;AACA;EACE,gBAAgB;EAChB,iBAAiB;;AAEnB;AACA;EACE,gBAAgB;EAChB,iBAAiB;;AAEnB;AACA;EACE,gBAAgB;;AAElB;AACA;EACE,gBAAgB;EAChB,iBAAiB;;EAEjB,YAAY;AACd;AACA;EACE,gBAAgB;;EAEhB,YAAY;AACd;AACA;EACE,gBAAgB;EAChB,iBAAiB;;AAEnB;AACA;EACE,gBAAgB;EAChB,iBAAiB;;AAEnB;AACA;EACE,gBAAgB;;EAEhB,YAAY;AACd;AACA;EACE,gBAAgB;EAChB,iBAAiB;;AAEnB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;;EAEhB,YAAY;AACd;AACA;EACE,gBAAgB;EAChB,iBAAiB;;AAEnB;AACA;EACE,gBAAgB;;EAEhB,YAAY;AACd;AACA;EACE,gBAAgB;EAChB,iBAAiB;;AAEnB;AACA;EACE,gBAAgB;;EAEhB,YAAY;AACd;AACA;EACE,gBAAgB;EAChB,iBAAiB;;AAEnB;AACA;EACE,gBAAgB;;EAEhB,YAAY;AACd;AACA;EACE,gBAAgB;EAChB,iBAAiB;;AAEnB;AACA;EACE,gBAAgB;;EAEhB,YAAY;AACd;AACA;EACE,gBAAgB;EAChB,iBAAiB;;AAEnB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;;EAEhB,YAAY;AACd;AACA;EACE,gBAAgB;EAChB,iBAAiB;;AAEnB;AACA;EACE,gBAAgB;;EAEhB,YAAY;AACd;AACA;EACE,gBAAgB;EAChB,iBAAiB;;AAEnB;AACA;EACE,gBAAgB;;EAEhB,YAAY;AACd;AACA;EACE,gBAAgB;EAChB,iBAAiB;;AAEnB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;;AAElB;AACA;EACE,gBAAgB;EAChB,iBAAiB;;EAEjB,YAAY;AACd;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;;AAElB;AACA;EACE,gBAAgB;EAChB,iBAAiB;;EAEjB,YAAY;AACd;AACA;EACE,gBAAgB;;EAEhB,YAAY;AACd;AACA;EACE,gBAAgB;EAChB,iBAAiB;;AAEnB;AACA;EACE,gBAAgB;;AAElB;AACA;EACE,gBAAgB;EAChB,iBAAiB;;EAEjB,YAAY;AACd;AACA;EACE,gBAAgB;;EAEhB,YAAY;AACd;AACA;EACE,gBAAgB;EAChB,iBAAiB;;AAEnB;AACA;EACE,gBAAgB;EAChB,iBAAiB;;AAEnB;AACA;EACE,gBAAgB;;EAEhB,YAAY;AACd;AACA;EACE,gBAAgB;EAChB,iBAAiB;;AAEnB;AACA;EACE,gBAAgB;EAChB,iBAAiB;;AAEnB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;;AAElB;AACA;EACE,gBAAgB;EAChB,iBAAiB;;EAEjB,YAAY;AACd;AACA;EACE,gBAAgB;;EAEhB,YAAY;AACd;AACA;EACE,gBAAgB;EAChB,iBAAiB;;AAEnB;AACA;EACE,gBAAgB;;EAEhB,YAAY;AACd;AACA;EACE,gBAAgB;EAChB,iBAAiB;;AAEnB;AACA;EACE,gBAAgB;;EAEhB,YAAY;AACd;AACA;EACE,gBAAgB;EAChB,iBAAiB;;AAEnB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;;AAElB;AACA;EACE,gBAAgB;EAChB,iBAAiB;;EAEjB,YAAY;AACd;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;;EAEhB,YAAY;AACd;AACA;EACE,gBAAgB;EAChB,iBAAiB;;AAEnB;AACA;EACE,gBAAgB;;AAElB;AACA;EACE,gBAAgB;EAChB,iBAAiB;;EAEjB,YAAY;AACd;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;;EAEhB,YAAY;AACd;AACA;EACE,gBAAgB;EAChB,iBAAiB;;AAEnB;AACA;EACE,gBAAgB;;EAEhB,YAAY;AACd;AACA;EACE,gBAAgB;EAChB,iBAAiB;;AAEnB;AACA;EACE,gBAAgB;;EAEhB,YAAY;AACd;AACA;EACE,gBAAgB;EAChB,iBAAiB;;AAEnB;AACA;EACE,gBAAgB;;AAElB;AACA;EACE,gBAAgB;EAChB,iBAAiB;;EAEjB,YAAY;AACd;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;;AAElB;AACA;EACE,gBAAgB;EAChB,iBAAiB;;EAEjB,YAAY;AACd;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;;EAEhB,YAAY;AACd;AACA;EACE,gBAAgB;EAChB,iBAAiB;;AAEnB;AACA;EACE,gBAAgB;;AAElB;AACA;EACE,gBAAgB;EAChB,iBAAiB;;EAEjB,YAAY;AACd;AACA;EACE,gBAAgB;;EAEhB,YAAY;AACd;AACA;EACE,gBAAgB;EAChB,iBAAiB;;AAEnB;AACA;EACE,gBAAgB;;AAElB;AACA;EACE,gBAAgB;EAChB,iBAAiB;;EAEjB,YAAY;AACd;AACA;EACE,gBAAgB;EAChB,iBAAiB;;EAEjB,YAAY;AACd;AACA;EACE,gBAAgB;;EAEhB,YAAY;AACd;AACA;EACE,gBAAgB;EAChB,iBAAiB;;AAEnB;AACA;EACE,gBAAgB;;EAEhB,YAAY;AACd;AACA;EACE,gBAAgB;EAChB,iBAAiB;;AAEnB;AACA;EACE,gBAAgB;;EAEhB,YAAY;AACd;AACA;EACE,gBAAgB;EAChB,iBAAiB;;AAEnB;AACA;EACE,gBAAgB;;AAElB;AACA;EACE,gBAAgB;EAChB,iBAAiB;;EAEjB,YAAY;AACd;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;;AAElB;AACA;EACE,gBAAgB;EAChB,iBAAiB;;EAEjB,YAAY;AACd;AACA;EACE,gBAAgB;;EAEhB,YAAY;AACd;AACA;EACE,gBAAgB;EAChB,iBAAiB;;AAEnB;AACA;EACE,gBAAgB;;AAElB;AACA;EACE,gBAAgB;EAChB,iBAAiB;;EAEjB,YAAY;AACd;AACA;EACE,gBAAgB;;AAElB;AACA;EACE,gBAAgB;EAChB,iBAAiB;;EAEjB,YAAY;AACd;AACA;EACE,gBAAgB;;EAEhB,YAAY;AACd;AACA;EACE,gBAAgB;EAChB,iBAAiB;;AAEnB;AACA;EACE,gBAAgB;;EAEhB,YAAY;AACd;AACA;EACE,gBAAgB;EAChB,iBAAiB;;AAEnB;AACA;EACE,gBAAgB;;AAElB;AACA;EACE,gBAAgB;EAChB,iBAAiB;;EAEjB,YAAY;AACd;AACA;EACE,gBAAgB;;AAElB;AACA;EACE,gBAAgB;EAChB,iBAAiB;;EAEjB,YAAY;AACd;AACA;EACE,gBAAgB;;EAEhB,YAAY;AACd;AACA;EACE,gBAAgB;EAChB,iBAAiB;;AAEnB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;;AAElB;AACA;EACE,gBAAgB;EAChB,iBAAiB;;EAEjB,YAAY;AACd;AACA;EACE,gBAAgB;;AAElB;AACA;EACE,gBAAgB;EAChB,iBAAiB;;EAEjB,YAAY;AACd;AACA;EACE,gBAAgB;;AAElB;AACA;EACE,gBAAgB;EAChB,iBAAiB;;EAEjB,YAAY;AACd;AACA;EACE,gBAAgB;;AAElB;AACA;EACE,gBAAgB;EAChB,iBAAiB;;EAEjB,YAAY;AACd;AACA;EACE,gBAAgB;;AAElB;AACA;EACE,gBAAgB;EAChB,iBAAiB;;EAEjB,YAAY;AACd;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;;EAEhB,YAAY;AACd;AACA;EACE,gBAAgB;EAChB,iBAAiB;;AAEnB;AACA;EACE,gBAAgB;;EAEhB,YAAY;AACd;AACA;EACE,gBAAgB;EAChB,iBAAiB;;AAEnB;AACA;EACE,gBAAgB;;AAElB;AACA;EACE,gBAAgB;EAChB,iBAAiB;;EAEjB,YAAY;AACd;AACA;EACE,gBAAgB;;AAElB;AACA;EACE,gBAAgB;EAChB,iBAAiB;EACjB,YAAY;AACd","sourcesContent":["@font-face {\n  font-family: 'icomoon';\n  src:  url('fonts/icomoon.eot');\n  src:  url('fonts/icomoon.eot') format('embedded-opentype'),\n    url('fonts/icomoon.ttf') format('truetype'),\n    url('fonts/icomoon.woff') format('woff'),\n    url('fonts/icomoon.svg') format('svg');\n  font-weight: normal;\n  font-style: normal;\n  font-display: block;\n}\n[class^=\"icon-\"], [class*=\" icon-\"] {\n  /* use !important to prevent issues with browser extensions that change fonts */\n  /* font-family: 'icomoon' !important; */\n  speak: never;\n  font-style: normal;\n  font-weight: normal;\n  font-variant: normal;\n  text-transform: none;\n  line-height: 1;\n\n  /* Better Font Rendering =========== */\n  -webkit-font-smoothing: antialiased;\n  -moz-osx-font-smoothing: grayscale;\n}\n.icon-Angle-Grinder .path1:before {\n  content: \"\\e900\";\n  \n  opacity: 0.3;\n}\n.icon-Angle-Grinder .path2:before {\n  content: \"\\e901\";\n  margin-left: -1em;\n  \n  opacity: 0.3;\n}\n.icon-Angle-Grinder .path3:before {\n  content: \"\\e902\";\n  margin-left: -1em;\n  \n}\n.icon-Axe .path1:before {\n  content: \"\\e903\";\n  \n  opacity: 0.3;\n}\n.icon-Axe .path2:before {\n  content: \"\\e904\";\n  margin-left: -1em;\n  \n}\n.icon-Brush .path1:before {\n  content: \"\\e905\";\n  \n  opacity: 0.3;\n}\n.icon-Brush .path2:before {\n  content: \"\\e906\";\n  margin-left: -1em;\n  \n}\n.icon-Compass .path1:before {\n  content: \"\\e907\";\n  \n  opacity: 0.3;\n}\n.icon-Compass .path2:before {\n  content: \"\\e908\";\n  margin-left: -1em;\n  \n}\n.icon-Hummer .path1:before {\n  content: \"\\e909\";\n  \n  opacity: 0.3;\n}\n.icon-Hummer .path2:before {\n  content: \"\\e90a\";\n  margin-left: -1em;\n  \n}\n.icon-Hummer .path3:before {\n  content: \"\\e90b\";\n  margin-left: -1em;\n  \n  opacity: 0.3;\n}\n.icon-Hummer1 .path1:before {\n  content: \"\\e90c\";\n  \n  opacity: 0.3;\n}\n.icon-Hummer1 .path2:before {\n  content: \"\\e90d\";\n  margin-left: -1em;\n  \n}\n.icon-Pantone .path1:before {\n  content: \"\\e90e\";\n  \n  opacity: 0.3;\n}\n.icon-Pantone .path2:before {\n  content: \"\\e90f\";\n  margin-left: -1em;\n  \n  opacity: 0.3;\n}\n.icon-Pantone .path3:before {\n  content: \"\\e910\";\n  margin-left: -1em;\n  \n}\n.icon-Road-Cone .path1:before {\n  content: \"\\e911\";\n  \n}\n.icon-Road-Cone .path2:before {\n  content: \"\\e912\";\n  margin-left: -1em;\n  \n  opacity: 0.3;\n}\n.icon-Roller .path1:before {\n  content: \"\\e913\";\n  \n}\n.icon-Roller .path2:before {\n  content: \"\\e914\";\n  margin-left: -1em;\n  \n}\n.icon-Roller .path3:before {\n  content: \"\\e915\";\n  margin-left: -1em;\n  \n  opacity: 0.3;\n}\n.icon-Roulette .path1:before {\n  content: \"\\e916\";\n  \n}\n.icon-Roulette .path2:before {\n  content: \"\\e917\";\n  margin-left: -1em;\n  \n  opacity: 0.3;\n}\n.icon-Screwdriver .path1:before {\n  content: \"\\e918\";\n  \n  opacity: 0.3;\n}\n.icon-Screwdriver .path2:before {\n  content: \"\\e919\";\n  margin-left: -1em;\n  \n}\n.icon-Shovel1 .path1:before {\n  content: \"\\e91a\";\n  \n  opacity: 0.3;\n}\n.icon-Shovel1 .path2:before {\n  content: \"\\e91b\";\n  margin-left: -1em;\n  \n}\n.icon-Spatula .path1:before {\n  content: \"\\e91c\";\n  \n  opacity: 0.3;\n}\n.icon-Spatula .path2:before {\n  content: \"\\e91d\";\n  margin-left: -1em;\n  \n}\n.icon-Swiss-knife .path1:before {\n  content: \"\\e91e\";\n  \n  opacity: 0.3;\n}\n.icon-Swiss-knife .path2:before {\n  content: \"\\e91f\";\n  margin-left: -1em;\n  \n}\n.icon-Tools .path1:before {\n  content: \"\\e920\";\n  \n}\n.icon-Tools .path2:before {\n  content: \"\\e921\";\n  margin-left: -1em;\n  \n  opacity: 0.3;\n}\n.icon-Align-auto .path1:before {\n  content: \"\\e922\";\n  \n  opacity: 0.3;\n}\n.icon-Align-auto .path2:before {\n  content: \"\\e923\";\n  margin-left: -1em;\n  \n}\n.icon-Align-center .path1:before {\n  content: \"\\e924\";\n  \n  opacity: 0.3;\n}\n.icon-Align-center .path2:before {\n  content: \"\\e925\";\n  margin-left: -1em;\n  \n}\n.icon-Align-justify .path1:before {\n  content: \"\\e926\";\n  \n  opacity: 0.3;\n}\n.icon-Align-justify .path2:before {\n  content: \"\\e927\";\n  margin-left: -1em;\n  \n}\n.icon-Align-left .path1:before {\n  content: \"\\e928\";\n  \n  opacity: 0.3;\n}\n.icon-Align-left .path2:before {\n  content: \"\\e929\";\n  margin-left: -1em;\n  \n  opacity: 0.3;\n}\n.icon-Align-left .path3:before {\n  content: \"\\e92a\";\n  margin-left: -1em;\n  \n}\n.icon-Align-right .path1:before {\n  content: \"\\e92b\";\n  \n  opacity: 0.3;\n}\n.icon-Align-right .path2:before {\n  content: \"\\e92c\";\n  margin-left: -1em;\n  \n}\n.icon-Article .path1:before {\n  content: \"\\e92d\";\n  \n}\n.icon-Article .path2:before {\n  content: \"\\e92e\";\n  margin-left: -1em;\n  \n  opacity: 0.3;\n}\n.icon-Bold:before {\n  content: \"\\e92f\";\n}\n.icon-Bullet-list .path1:before {\n  content: \"\\e930\";\n  \n}\n.icon-Bullet-list .path2:before {\n  content: \"\\e931\";\n  margin-left: -1em;\n  \n  opacity: 0.3;\n}\n.icon-Code:before {\n  content: \"\\e932\";\n}\n.icon-Edit-text .path1:before {\n  content: \"\\e933\";\n  \n  opacity: 0.3;\n}\n.icon-Edit-text .path2:before {\n  content: \"\\e934\";\n  margin-left: -1em;\n  \n}\n.icon-Filter:before {\n  content: \"\\e935\";\n}\n.icon-Font .path1:before {\n  content: \"\\e936\";\n  \n}\n.icon-Font .path2:before {\n  content: \"\\e937\";\n  margin-left: -1em;\n  \n  opacity: 0.3;\n}\n.icon-H1 .path1:before {\n  content: \"\\e938\";\n  \n}\n.icon-H1 .path2:before {\n  content: \"\\e939\";\n  margin-left: -1em;\n  \n  opacity: 0.3;\n}\n.icon-H2 .path1:before {\n  content: \"\\e93a\";\n  \n}\n.icon-H2 .path2:before {\n  content: \"\\e93b\";\n  margin-left: -1em;\n  \n  opacity: 0.3;\n}\n.icon-Itallic:before {\n  content: \"\\e93c\";\n}\n.icon-Menu .path1:before {\n  content: \"\\e93d\";\n  \n}\n.icon-Menu .path2:before {\n  content: \"\\e93e\";\n  margin-left: -1em;\n  \n  opacity: 0.3;\n}\n.icon-Paragraph:before {\n  content: \"\\e93f\";\n}\n.icon-Quote .path1:before {\n  content: \"\\e940\";\n  \n}\n.icon-Quote .path2:before {\n  content: \"\\e941\";\n  margin-left: -1em;\n  \n  opacity: 0.3;\n}\n.icon-Quote1 .path1:before {\n  content: \"\\e942\";\n  \n}\n.icon-Quote1 .path2:before {\n  content: \"\\e943\";\n  margin-left: -1em;\n  \n  opacity: 0.3;\n}\n.icon-Redo:before {\n  content: \"\\e944\";\n}\n.icon-Strikethrough .path1:before {\n  content: \"\\e945\";\n  \n  opacity: 0.3;\n}\n.icon-Strikethrough .path2:before {\n  content: \"\\e946\";\n  margin-left: -1em;\n  \n}\n.icon-Text:before {\n  content: \"\\e947\";\n}\n.icon-Text-height .path1:before {\n  content: \"\\e948\";\n  \n  opacity: 0.3;\n}\n.icon-Text-height .path2:before {\n  content: \"\\e949\";\n  margin-left: -1em;\n  \n}\n.icon-Text-width .path1:before {\n  content: \"\\e94a\";\n  \n  opacity: 0.3;\n}\n.icon-Text-width .path2:before {\n  content: \"\\e94b\";\n  margin-left: -1em;\n  \n}\n.icon-Underline .path1:before {\n  content: \"\\e94c\";\n  \n}\n.icon-Underline .path2:before {\n  content: \"\\e94d\";\n  margin-left: -1em;\n  \n  opacity: 0.3;\n}\n.icon-Undo:before {\n  content: \"\\e94e\";\n}\n.icon-ATM .path1:before {\n  content: \"\\e94f\";\n  \n  opacity: 0.3;\n}\n.icon-ATM .path2:before {\n  content: \"\\e950\";\n  margin-left: -1em;\n  \n}\n.icon-Bag .path1:before {\n  content: \"\\e951\";\n  \n  opacity: 0.3;\n}\n.icon-Bag .path2:before {\n  content: \"\\e952\";\n  margin-left: -1em;\n  \n}\n.icon-Bag1 .path1:before {\n  content: \"\\e953\";\n  \n  opacity: 0.3;\n}\n.icon-Bag1 .path2:before {\n  content: \"\\e954\";\n  margin-left: -1em;\n  \n}\n.icon-Barcode .path1:before {\n  content: \"\\e955\";\n  \n}\n.icon-Barcode .path2:before {\n  content: \"\\e956\";\n  margin-left: -1em;\n  \n  opacity: 0.3;\n}\n.icon-Barcode-read .path1:before {\n  content: \"\\e957\";\n  \n  opacity: 0.3;\n}\n.icon-Barcode-read .path2:before {\n  content: \"\\e958\";\n  margin-left: -1em;\n  \n}\n.icon-Barcode-scan .path1:before {\n  content: \"\\e959\";\n  \n}\n.icon-Barcode-scan .path2:before {\n  content: \"\\e95a\";\n  margin-left: -1em;\n  \n  opacity: 0.3;\n}\n.icon-Barcode-scan .path3:before {\n  content: \"\\e95b\";\n  margin-left: -1em;\n  \n  opacity: 0.3;\n}\n.icon-Bitcoin .path1:before {\n  content: \"\\e95c\";\n  \n  opacity: 0.3;\n}\n.icon-Bitcoin .path2:before {\n  content: \"\\e95d\";\n  margin-left: -1em;\n  \n  opacity: 0.3;\n}\n.icon-Bitcoin .path3:before {\n  content: \"\\e95e\";\n  margin-left: -1em;\n  \n}\n.icon-Box1 .path1:before {\n  content: \"\\e95f\";\n  \n  opacity: 0.3;\n}\n.icon-Box1 .path2:before {\n  content: \"\\e960\";\n  margin-left: -1em;\n  \n}\n.icon-Box2 .path1:before {\n  content: \"\\e961\";\n  \n}\n.icon-Box2 .path2:before {\n  content: \"\\e962\";\n  margin-left: -1em;\n  \n  opacity: 0.3;\n}\n.icon-Box3 .path1:before {\n  content: \"\\e963\";\n  \n  opacity: 0.3;\n}\n.icon-Box3 .path2:before {\n  content: \"\\e964\";\n  margin-left: -1em;\n  \n}\n.icon-Calculator .path1:before {\n  content: \"\\e965\";\n  \n  opacity: 0.3;\n}\n.icon-Calculator .path2:before {\n  content: \"\\e966\";\n  margin-left: -1em;\n  \n}\n.icon-Cart1 .path1:before {\n  content: \"\\e967\";\n  \n  opacity: 0.3;\n}\n.icon-Cart1 .path2:before {\n  content: \"\\e968\";\n  margin-left: -1em;\n  \n}\n.icon-Cart2 .path1:before {\n  content: \"\\e969\";\n  \n  opacity: 0.3;\n}\n.icon-Cart2 .path2:before {\n  content: \"\\e96a\";\n  margin-left: -1em;\n  \n}\n.icon-Cart .path1:before {\n  content: \"\\e96b\";\n  \n  opacity: 0.3;\n}\n.icon-Cart .path2:before {\n  content: \"\\e96c\";\n  margin-left: -1em;\n  \n}\n.icon-Chart-bar .path1:before {\n  content: \"\\e96d\";\n  \n  opacity: 0.3;\n}\n.icon-Chart-bar .path2:before {\n  content: \"\\e96e\";\n  margin-left: -1em;\n  \n  opacity: 0.3;\n}\n.icon-Chart-bar .path3:before {\n  content: \"\\e96f\";\n  margin-left: -1em;\n  \n}\n.icon-Chart-bar .path4:before {\n  content: \"\\e970\";\n  margin-left: -1em;\n  \n  opacity: 0.3;\n}\n.icon-Chart-bar1 .path1:before {\n  content: \"\\e971\";\n  \n  opacity: 0.3;\n}\n.icon-Chart-bar1 .path2:before {\n  content: \"\\e972\";\n  margin-left: -1em;\n  \n  opacity: 0.3;\n}\n.icon-Chart-bar1 .path3:before {\n  content: \"\\e973\";\n  margin-left: -1em;\n  \n}\n.icon-Chart-bar1 .path4:before {\n  content: \"\\e974\";\n  margin-left: -1em;\n  \n  opacity: 0.3;\n}\n.icon-Chart-bar2 .path1:before {\n  content: \"\\e975\";\n  \n  opacity: 0.3;\n}\n.icon-Chart-bar2 .path2:before {\n  content: \"\\e976\";\n  margin-left: -1em;\n  \n  opacity: 0.3;\n}\n.icon-Chart-bar2 .path3:before {\n  content: \"\\e977\";\n  margin-left: -1em;\n  \n}\n.icon-Chart-bar2 .path4:before {\n  content: \"\\e978\";\n  margin-left: -1em;\n  \n  opacity: 0.3;\n}\n.icon-Chart-line .path1:before {\n  content: \"\\e979\";\n  \n}\n.icon-Chart-line .path2:before {\n  content: \"\\e97a\";\n  margin-left: -1em;\n  \n  opacity: 0.3;\n}\n.icon-Chart-line1 .path1:before {\n  content: \"\\e97b\";\n  \n}\n.icon-Chart-line1 .path2:before {\n  content: \"\\e97c\";\n  margin-left: -1em;\n  \n  opacity: 0.3;\n}\n.icon-Chart-pie .path1:before {\n  content: \"\\e97d\";\n  \n  opacity: 0.3;\n}\n.icon-Chart-pie .path2:before {\n  content: \"\\e97e\";\n  margin-left: -1em;\n  \n}\n.icon-Credit-card .path1:before {\n  content: \"\\e97f\";\n  \n  opacity: 0.3;\n}\n.icon-Credit-card .path2:before {\n  content: \"\\e980\";\n  margin-left: -1em;\n  \n}\n.icon-Credit-card .path3:before {\n  content: \"\\e981\";\n  margin-left: -1em;\n  \n  opacity: 0.3;\n}\n.icon-Dollar .path1:before {\n  content: \"\\e982\";\n  \n  opacity: 0.3;\n}\n.icon-Dollar .path2:before {\n  content: \"\\e983\";\n  margin-left: -1em;\n  \n  opacity: 0.3;\n}\n.icon-Dollar .path3:before {\n  content: \"\\e984\";\n  margin-left: -1em;\n  \n}\n.icon-Euro .path1:before {\n  content: \"\\e985\";\n  \n  opacity: 0.3;\n}\n.icon-Euro .path2:before {\n  content: \"\\e986\";\n  margin-left: -1em;\n  \n}\n.icon-Gift .path1:before {\n  content: \"\\e987\";\n  \n}\n.icon-Gift .path2:before {\n  content: \"\\e988\";\n  margin-left: -1em;\n  \n  opacity: 0.3;\n}\n.icon-Loader .path1:before {\n  content: \"\\e989\";\n  \n  opacity: 0.3;\n}\n.icon-Loader .path2:before {\n  content: \"\\e98a\";\n  margin-left: -1em;\n  \n  opacity: 0.3;\n}\n.icon-Loader .path3:before {\n  content: \"\\e98b\";\n  margin-left: -1em;\n  \n}\n.icon-MC .path1:before {\n  content: \"\\e98c\";\n  \n  opacity: 0.3;\n}\n.icon-MC .path2:before {\n  content: \"\\e98d\";\n  margin-left: -1em;\n  \n}\n.icon-Money .path1:before {\n  content: \"\\e98e\";\n  \n  opacity: 0.3;\n}\n.icon-Money .path2:before {\n  content: \"\\e98f\";\n  margin-left: -1em;\n  \n}\n.icon-Pound .path1:before {\n  content: \"\\e990\";\n  \n}\n.icon-Pound .path2:before {\n  content: \"\\e991\";\n  margin-left: -1em;\n  \n  opacity: 0.3;\n}\n.icon-Price:before {\n  content: \"\\e992\";\n}\n.icon-145:before {\n  content: \"\\e992\";\n}\n.icon-Price1:before {\n  content: \"\\e993\";\n}\n.icon-245:before {\n  content: \"\\e993\";\n}\n.icon-Rouble .path1:before {\n  content: \"\\e994\";\n  \n  opacity: 0.3;\n}\n.icon-Rouble .path2:before {\n  content: \"\\e995\";\n  margin-left: -1em;\n  \n}\n.icon-Safe .path1:before {\n  content: \"\\e996\";\n  \n  opacity: 0.3;\n}\n.icon-Safe .path2:before {\n  content: \"\\e997\";\n  margin-left: -1em;\n  \n}\n.icon-Sale .path1:before {\n  content: \"\\e998\";\n  \n}\n.icon-Sale .path2:before {\n  content: \"\\e999\";\n  margin-left: -1em;\n  \n  opacity: 0.3;\n}\n.icon-Sale1 .path1:before {\n  content: \"\\e99a\";\n  \n  opacity: 0.3;\n}\n.icon-Sale1 .path2:before {\n  content: \"\\e99b\";\n  margin-left: -1em;\n  \n}\n.icon-Sale1 .path3:before {\n  content: \"\\e99c\";\n  margin-left: -1em;\n  \n  opacity: 0.3;\n}\n.icon-Sale1 .path4:before {\n  content: \"\\e99d\";\n  margin-left: -1em;\n  \n  opacity: 0.3;\n}\n.icon-Settings .path1:before {\n  content: \"\\e99e\";\n  \n  opacity: 0.3;\n}\n.icon-Settings .path2:before {\n  content: \"\\e99f\";\n  margin-left: -1em;\n  \n}\n.icon-Sort .path1:before {\n  content: \"\\e9a0\";\n  \n}\n.icon-Sort .path2:before {\n  content: \"\\e9a1\";\n  margin-left: -1em;\n  \n  opacity: 0.3;\n}\n.icon-Sort1:before {\n  content: \"\\e9a2\";\n}\n.icon-25:before {\n  content: \"\\e9a2\";\n}\n.icon-Sort2:before {\n  content: \"\\e9a3\";\n}\n.icon-32:before {\n  content: \"\\e9a3\";\n}\n.icon-Ticket:before {\n  content: \"\\e9a4\";\n}\n.icon-Wallet .path1:before {\n  content: \"\\e9a5\";\n  \n  opacity: 0.3;\n}\n.icon-Wallet .path2:before {\n  content: \"\\e9a6\";\n  margin-left: -1em;\n  \n}\n.icon-Wallet1 .path1:before {\n  content: \"\\e9a7\";\n  \n  opacity: 0.3;\n}\n.icon-Wallet1 .path2:before {\n  content: \"\\e9a8\";\n  margin-left: -1em;\n  \n}\n.icon-Wallet1 .path3:before {\n  content: \"\\e9a9\";\n  margin-left: -1em;\n  \n}\n.icon-Wallet2 .path1:before {\n  content: \"\\e9aa\";\n  \n  opacity: 0.3;\n}\n.icon-Wallet2 .path2:before {\n  content: \"\\e9ab\";\n  margin-left: -1em;\n  \n  opacity: 0.3;\n}\n.icon-Wallet2 .path3:before {\n  content: \"\\e9ac\";\n  margin-left: -1em;\n  \n}\n.icon-Angle-up:before {\n  content: \"\\e9ad\";\n}\n.icon-Angle-double-down .path1:before {\n  content: \"\\e9ae\";\n  \n}\n.icon-Angle-double-down .path2:before {\n  content: \"\\e9af\";\n  margin-left: -1em;\n  \n  opacity: 0.3;\n}\n.icon-Angle-double-left .path1:before {\n  content: \"\\e9b0\";\n  \n}\n.icon-Angle-double-left .path2:before {\n  content: \"\\e9b1\";\n  margin-left: -1em;\n  \n  opacity: 0.3;\n}\n.icon-Angle-double-right .path1:before {\n  content: \"\\e9b2\";\n  \n}\n.icon-Angle-double-right .path2:before {\n  content: \"\\e9b3\";\n  margin-left: -1em;\n  \n  opacity: 0.3;\n}\n.icon-Angle-double-up .path1:before {\n  content: \"\\e9b4\";\n  \n}\n.icon-Angle-double-up .path2:before {\n  content: \"\\e9b5\";\n  margin-left: -1em;\n  \n  opacity: 0.3;\n}\n.icon-Angle-down:before {\n  content: \"\\e9b6\";\n}\n.icon-Angle-left:before {\n  content: \"\\e9b7\";\n}\n.icon-Angle-right:before {\n  content: \"\\e9b8\";\n}\n.icon-Arrow-down .path1:before {\n  content: \"\\e9b9\";\n  \n  opacity: 0.3;\n}\n.icon-Arrow-down .path2:before {\n  content: \"\\e9ba\";\n  margin-left: -1em;\n  \n}\n.icon-Arrow-from-bottom .path1:before {\n  content: \"\\e9bb\";\n  \n  opacity: 0.3;\n}\n.icon-Arrow-from-bottom .path2:before {\n  content: \"\\e9bc\";\n  margin-left: -1em;\n  \n}\n.icon-Arrow-from-bottom .path3:before {\n  content: \"\\e9bd\";\n  margin-left: -1em;\n  \n  opacity: 0.3;\n}\n.icon-Arrow-from-left .path1:before {\n  content: \"\\e9be\";\n  \n  opacity: 0.3;\n}\n.icon-Arrow-from-left .path2:before {\n  content: \"\\e9bf\";\n  margin-left: -1em;\n  \n  opacity: 0.3;\n}\n.icon-Arrow-from-left .path3:before {\n  content: \"\\e9c0\";\n  margin-left: -1em;\n  \n}\n.icon-Arrow-from-right .path1:before {\n  content: \"\\e9c1\";\n  \n  opacity: 0.3;\n}\n.icon-Arrow-from-right .path2:before {\n  content: \"\\e9c2\";\n  margin-left: -1em;\n  \n  opacity: 0.3;\n}\n.icon-Arrow-from-right .path3:before {\n  content: \"\\e9c3\";\n  margin-left: -1em;\n  \n}\n.icon-Arrow-from-top .path1:before {\n  content: \"\\e9c4\";\n  \n  opacity: 0.3;\n}\n.icon-Arrow-from-top .path2:before {\n  content: \"\\e9c5\";\n  margin-left: -1em;\n  \n}\n.icon-Arrow-from-top .path3:before {\n  content: \"\\e9c6\";\n  margin-left: -1em;\n  \n  opacity: 0.3;\n}\n.icon-Arrow-left .path1:before {\n  content: \"\\e9c7\";\n  \n  opacity: 0.3;\n}\n.icon-Arrow-left .path2:before {\n  content: \"\\e9c8\";\n  margin-left: -1em;\n  \n}\n.icon-Arrow-right .path1:before {\n  content: \"\\e9c9\";\n  \n  opacity: 0.3;\n}\n.icon-Arrow-right .path2:before {\n  content: \"\\e9ca\";\n  margin-left: -1em;\n  \n}\n.icon-Arrows-h .path1:before {\n  content: \"\\e9cb\";\n  \n  opacity: 0.3;\n}\n.icon-Arrows-h .path2:before {\n  content: \"\\e9cc\";\n  margin-left: -1em;\n  \n}\n.icon-Arrows-h .path3:before {\n  content: \"\\e9cd\";\n  margin-left: -1em;\n  \n}\n.icon-Arrows-v .path1:before {\n  content: \"\\e9ce\";\n  \n  opacity: 0.3;\n}\n.icon-Arrows-v .path2:before {\n  content: \"\\e9cf\";\n  margin-left: -1em;\n  \n}\n.icon-Arrows-v .path3:before {\n  content: \"\\e9d0\";\n  margin-left: -1em;\n  \n}\n.icon-Arrow-to-bottom .path1:before {\n  content: \"\\e9d1\";\n  \n  opacity: 0.3;\n}\n.icon-Arrow-to-bottom .path2:before {\n  content: \"\\e9d2\";\n  margin-left: -1em;\n  \n}\n.icon-Arrow-to-bottom .path3:before {\n  content: \"\\e9d3\";\n  margin-left: -1em;\n  \n  opacity: 0.3;\n}\n.icon-Arrow-to-left .path1:before {\n  content: \"\\e9d4\";\n  \n  opacity: 0.3;\n}\n.icon-Arrow-to-left .path2:before {\n  content: \"\\e9d5\";\n  margin-left: -1em;\n  \n  opacity: 0.3;\n}\n.icon-Arrow-to-left .path3:before {\n  content: \"\\e9d6\";\n  margin-left: -1em;\n  \n}\n.icon-Arrow-to-right .path1:before {\n  content: \"\\e9d7\";\n  \n  opacity: 0.3;\n}\n.icon-Arrow-to-right .path2:before {\n  content: \"\\e9d8\";\n  margin-left: -1em;\n  \n  opacity: 0.3;\n}\n.icon-Arrow-to-right .path3:before {\n  content: \"\\e9d9\";\n  margin-left: -1em;\n  \n}\n.icon-Arrow-to-up .path1:before {\n  content: \"\\e9da\";\n  \n  opacity: 0.3;\n}\n.icon-Arrow-to-up .path2:before {\n  content: \"\\e9db\";\n  margin-left: -1em;\n  \n}\n.icon-Arrow-to-up .path3:before {\n  content: \"\\e9dc\";\n  margin-left: -1em;\n  \n  opacity: 0.3;\n}\n.icon-Arrow-up .path1:before {\n  content: \"\\e9dd\";\n  \n  opacity: 0.3;\n}\n.icon-Arrow-up .path2:before {\n  content: \"\\e9de\";\n  margin-left: -1em;\n  \n}\n.icon-Check:before {\n  content: \"\\e9df\";\n}\n.icon-Close .path1:before {\n  content: \"\\e9e0\";\n  \n}\n.icon-Close .path2:before {\n  content: \"\\e9e1\";\n  margin-left: -1em;\n  \n  opacity: 0.3;\n}\n.icon-Double-check .path1:before {\n  content: \"\\e9e2\";\n  \n  opacity: 0.3;\n}\n.icon-Double-check .path2:before {\n  content: \"\\e9e3\";\n  margin-left: -1em;\n  \n}\n.icon-Down-2 .path1:before {\n  content: \"\\e9e4\";\n  \n  opacity: 0.3;\n}\n.icon-Down-2 .path2:before {\n  content: \"\\e9e5\";\n  margin-left: -1em;\n  \n}\n.icon-Down-left .path1:before {\n  content: \"\\e9e6\";\n  \n  opacity: 0.3;\n}\n.icon-Down-left .path2:before {\n  content: \"\\e9e7\";\n  margin-left: -1em;\n  \n}\n.icon-Down-right .path1:before {\n  content: \"\\e9e8\";\n  \n  opacity: 0.3;\n}\n.icon-Down-right .path2:before {\n  content: \"\\e9e9\";\n  margin-left: -1em;\n  \n}\n.icon-Exchange .path1:before {\n  content: \"\\e9ea\";\n  \n  opacity: 0.3;\n}\n.icon-Exchange .path2:before {\n  content: \"\\e9eb\";\n  margin-left: -1em;\n  \n}\n.icon-Exchange .path3:before {\n  content: \"\\e9ec\";\n  margin-left: -1em;\n  \n  opacity: 0.3;\n}\n.icon-Exchange .path4:before {\n  content: \"\\e9ed\";\n  margin-left: -1em;\n  \n}\n.icon-Left-3 .path1:before {\n  content: \"\\e9ee\";\n  \n}\n.icon-Left-3 .path2:before {\n  content: \"\\e9ef\";\n  margin-left: -1em;\n  \n  opacity: 0.3;\n}\n.icon-Left-2 .path1:before {\n  content: \"\\e9f0\";\n  \n  opacity: 0.3;\n}\n.icon-Left-2 .path2:before {\n  content: \"\\e9f1\";\n  margin-left: -1em;\n  \n}\n.icon-Minus1:before {\n  content: \"\\e9f2\";\n}\n.icon-Plus1 .path1:before {\n  content: \"\\e9f3\";\n  \n}\n.icon-Plus1 .path2:before {\n  content: \"\\e9f4\";\n  margin-left: -1em;\n  \n  opacity: 0.3;\n}\n.icon-Right-3 .path1:before {\n  content: \"\\e9f5\";\n  \n}\n.icon-Right-3 .path2:before {\n  content: \"\\e9f6\";\n  margin-left: -1em;\n  \n  opacity: 0.3;\n}\n.icon-Right-2 .path1:before {\n  content: \"\\e9f7\";\n  \n  opacity: 0.3;\n}\n.icon-Right-2 .path2:before {\n  content: \"\\e9f8\";\n  margin-left: -1em;\n  \n}\n.icon-Route .path1:before {\n  content: \"\\e9f9\";\n  \n  opacity: 0.3;\n}\n.icon-Route .path2:before {\n  content: \"\\e9fa\";\n  margin-left: -1em;\n  \n}\n.icon-Route .path3:before {\n  content: \"\\e9fb\";\n  margin-left: -1em;\n  \n}\n.icon-Sign-in .path1:before {\n  content: \"\\e9fc\";\n  \n  opacity: 0.3;\n}\n.icon-Sign-in .path2:before {\n  content: \"\\e9fd\";\n  margin-left: -1em;\n  \n  opacity: 0.3;\n}\n.icon-Sign-in .path3:before {\n  content: \"\\e9fe\";\n  margin-left: -1em;\n  \n}\n.icon-Sign-out .path1:before {\n  content: \"\\e9ff\";\n  \n  opacity: 0.3;\n}\n.icon-Sign-out .path2:before {\n  content: \"\\ea00\";\n  margin-left: -1em;\n  \n  opacity: 0.3;\n}\n.icon-Sign-out .path3:before {\n  content: \"\\ea01\";\n  margin-left: -1em;\n  \n}\n.icon-Up-2 .path1:before {\n  content: \"\\ea02\";\n  \n  opacity: 0.3;\n}\n.icon-Up-2 .path2:before {\n  content: \"\\ea03\";\n  margin-left: -1em;\n  \n}\n.icon-Up-down .path1:before {\n  content: \"\\ea04\";\n  \n  opacity: 0.3;\n}\n.icon-Up-down .path2:before {\n  content: \"\\ea05\";\n  margin-left: -1em;\n  \n}\n.icon-Up-down .path3:before {\n  content: \"\\ea06\";\n  margin-left: -1em;\n  \n  opacity: 0.3;\n}\n.icon-Up-down .path4:before {\n  content: \"\\ea07\";\n  margin-left: -1em;\n  \n}\n.icon-Up-left .path1:before {\n  content: \"\\ea08\";\n  \n  opacity: 0.3;\n}\n.icon-Up-left .path2:before {\n  content: \"\\ea09\";\n  margin-left: -1em;\n  \n}\n.icon-Up-right .path1:before {\n  content: \"\\ea0a\";\n  \n  opacity: 0.3;\n}\n.icon-Up-right .path2:before {\n  content: \"\\ea0b\";\n  margin-left: -1em;\n  \n}\n.icon-Waiting:before {\n  content: \"\\ea0c\";\n}\n.icon-Add-music .path1:before {\n  content: \"\\ea0d\";\n  \n}\n.icon-Add-music .path2:before {\n  content: \"\\ea0e\";\n  margin-left: -1em;\n  \n  opacity: 0.3;\n}\n.icon-Airplay .path1:before {\n  content: \"\\ea0f\";\n  \n  opacity: 0.3;\n}\n.icon-Airplay .path2:before {\n  content: \"\\ea10\";\n  margin-left: -1em;\n  \n}\n.icon-Airplay-video .path1:before {\n  content: \"\\ea11\";\n  \n}\n.icon-Airplay-video .path2:before {\n  content: \"\\ea12\";\n  margin-left: -1em;\n  \n  opacity: 0.3;\n}\n.icon-Back .path1:before {\n  content: \"\\ea13\";\n  \n}\n.icon-Back .path2:before {\n  content: \"\\ea14\";\n  margin-left: -1em;\n  \n  opacity: 0.3;\n}\n.icon-Backward .path1:before {\n  content: \"\\ea15\";\n  \n  opacity: 0.3;\n}\n.icon-Backward .path2:before {\n  content: \"\\ea16\";\n  margin-left: -1em;\n  \n}\n.icon-CD .path1:before {\n  content: \"\\ea17\";\n  \n}\n.icon-CD .path2:before {\n  content: \"\\ea18\";\n  margin-left: -1em;\n  \n  opacity: 0.3;\n}\n.icon-DVD .path1:before {\n  content: \"\\ea19\";\n  \n  opacity: 0.3;\n}\n.icon-DVD .path2:before {\n  content: \"\\ea1a\";\n  margin-left: -1em;\n  \n}\n.icon-Eject .path1:before {\n  content: \"\\ea1b\";\n  \n}\n.icon-Eject .path2:before {\n  content: \"\\ea1c\";\n  margin-left: -1em;\n  \n  opacity: 0.3;\n}\n.icon-Equalizer .path1:before {\n  content: \"\\ea1d\";\n  \n  opacity: 0.3;\n}\n.icon-Equalizer .path2:before {\n  content: \"\\ea1e\";\n  margin-left: -1em;\n  \n}\n.icon-Equalizer .path3:before {\n  content: \"\\ea1f\";\n  margin-left: -1em;\n  \n}\n.icon-Equalizer .path4:before {\n  content: \"\\ea20\";\n  margin-left: -1em;\n  \n}\n.icon-Forward .path1:before {\n  content: \"\\ea21\";\n  \n  opacity: 0.3;\n}\n.icon-Forward .path2:before {\n  content: \"\\ea22\";\n  margin-left: -1em;\n  \n}\n.icon-Media-library .path1:before {\n  content: \"\\ea23\";\n  \n  opacity: 0.3;\n}\n.icon-Media-library .path2:before {\n  content: \"\\ea24\";\n  margin-left: -1em;\n  \n  opacity: 0.3;\n}\n.icon-Media-library .path3:before {\n  content: \"\\ea25\";\n  margin-left: -1em;\n  \n  opacity: 0.3;\n}\n.icon-Media-library .path4:before {\n  content: \"\\ea26\";\n  margin-left: -1em;\n  \n}\n.icon-Media-library1 .path1:before {\n  content: \"\\ea27\";\n  \n  opacity: 0.3;\n}\n.icon-Media-library1 .path2:before {\n  content: \"\\ea28\";\n  margin-left: -1em;\n  \n}\n.icon-Media-library2 .path1:before {\n  content: \"\\ea29\";\n  \n  opacity: 0.0900;\n}\n.icon-Media-library2 .path2:before {\n  content: \"\\ea2a\";\n  margin-left: -1em;\n  \n}\n.icon-Movie-Lane .path1:before {\n  content: \"\\ea2b\";\n  \n  opacity: 0.3;\n}\n.icon-Movie-Lane .path2:before {\n  content: \"\\ea2c\";\n  margin-left: -1em;\n  \n}\n.icon-Movie-lane .path1:before {\n  content: \"\\ea2d\";\n  \n  opacity: 0.3;\n}\n.icon-Movie-lane .path2:before {\n  content: \"\\ea2e\";\n  margin-left: -1em;\n  \n}\n.icon-Music1:before {\n  content: \"\\ea2f\";\n}\n.icon-Music-cloud .path1:before {\n  content: \"\\ea30\";\n  \n  opacity: 0.3;\n}\n.icon-Music-cloud .path2:before {\n  content: \"\\ea31\";\n  margin-left: -1em;\n  \n}\n.icon-Music-note:before {\n  content: \"\\ea32\";\n}\n.icon-Mute .path1:before {\n  content: \"\\ea33\";\n  \n  opacity: 0.3;\n}\n.icon-Mute .path2:before {\n  content: \"\\ea34\";\n  margin-left: -1em;\n  \n}\n.icon-Next .path1:before {\n  content: \"\\ea35\";\n  \n}\n.icon-Next .path2:before {\n  content: \"\\ea36\";\n  margin-left: -1em;\n  \n  opacity: 0.3;\n}\n.icon-Pause:before {\n  content: \"\\ea37\";\n}\n.icon-Play:before {\n  content: \"\\ea38\";\n}\n.icon-Playlist .path1:before {\n  content: \"\\ea39\";\n  \n}\n.icon-Playlist .path2:before {\n  content: \"\\ea3a\";\n  margin-left: -1em;\n  \n  opacity: 0.3;\n}\n.icon-Playlist1 .path1:before {\n  content: \"\\ea3b\";\n  \n  opacity: 0.3;\n}\n.icon-Playlist1 .path2:before {\n  content: \"\\ea3c\";\n  margin-left: -1em;\n  \n}\n.icon-Rec:before {\n  content: \"\\ea3d\";\n}\n.icon-Repeat .path1:before {\n  content: \"\\ea3e\";\n  \n}\n.icon-Repeat .path2:before {\n  content: \"\\ea3f\";\n  margin-left: -1em;\n  \n  opacity: 0.3;\n}\n.icon-Repeat-one .path1:before {\n  content: \"\\ea40\";\n  \n  opacity: 0.3;\n}\n.icon-Repeat-one .path2:before {\n  content: \"\\ea41\";\n  margin-left: -1em;\n  \n}\n.icon-Shuffle .path1:before {\n  content: \"\\ea42\";\n  \n  opacity: 0.3;\n}\n.icon-Shuffle .path2:before {\n  content: \"\\ea43\";\n  margin-left: -1em;\n  \n}\n.icon-Volume-down .path1:before {\n  content: \"\\ea44\";\n  \n  opacity: 0.3;\n}\n.icon-Volume-down .path2:before {\n  content: \"\\ea45\";\n  margin-left: -1em;\n  \n}\n.icon-Volume-full .path1:before {\n  content: \"\\ea46\";\n  \n  opacity: 0.3;\n}\n.icon-Volume-full .path2:before {\n  content: \"\\ea47\";\n  margin-left: -1em;\n  \n}\n.icon-Volume-half .path1:before {\n  content: \"\\ea48\";\n  \n  opacity: 0.3;\n}\n.icon-Volume-half .path2:before {\n  content: \"\\ea49\";\n  margin-left: -1em;\n  \n}\n.icon-Volume-up .path1:before {\n  content: \"\\ea4a\";\n  \n  opacity: 0.3;\n}\n.icon-Volume-up .path2:before {\n  content: \"\\ea4b\";\n  margin-left: -1em;\n  \n}\n.icon-Vynil .path1:before {\n  content: \"\\ea4c\";\n  \n}\n.icon-Vynil .path2:before {\n  content: \"\\ea4d\";\n  margin-left: -1em;\n  \n  opacity: 0.3;\n}\n.icon-Youtube .path1:before {\n  content: \"\\ea4e\";\n  \n  opacity: 0.3;\n}\n.icon-Youtube .path2:before {\n  content: \"\\ea4f\";\n  margin-left: -1em;\n  \n}\n.icon-Compass1:before {\n  content: \"\\ea50\";\n}\n.icon-Direction1:before {\n  content: \"\\ea51\";\n}\n.icon-136:before {\n  content: \"\\ea51\";\n}\n.icon-Direction:before {\n  content: \"\\ea52\";\n}\n.icon-228:before {\n  content: \"\\ea52\";\n}\n.icon-Location-arrow:before {\n  content: \"\\ea53\";\n}\n.icon-Marker:before {\n  content: \"\\ea54\";\n}\n.icon-128:before {\n  content: \"\\ea54\";\n}\n.icon-Marker1:before {\n  content: \"\\ea55\";\n}\n.icon-229:before {\n  content: \"\\ea55\";\n}\n.icon-Position1 .path1:before {\n  content: \"\\ea56\";\n  \n  opacity: 0.3;\n}\n.icon-Position1 .path2:before {\n  content: \"\\ea57\";\n  margin-left: -1em;\n  \n  opacity: 0.3;\n}\n.icon-Position1 .path3:before {\n  content: \"\\ea58\";\n  margin-left: -1em;\n  \n}\n.icon-Layout-3d .path1:before {\n  content: \"\\ea59\";\n  \n}\n.icon-Layout-3d .path2:before {\n  content: \"\\ea5a\";\n  margin-left: -1em;\n  \n  opacity: 0.3;\n}\n.icon-Layout-4-blocks .path1:before {\n  content: \"\\ea5b\";\n  \n}\n.icon-Layout-4-blocks .path2:before {\n  content: \"\\ea5c\";\n  margin-left: -1em;\n  \n  opacity: 0.3;\n}\n.icon-Layout-arrange .path1:before {\n  content: \"\\ea5d\";\n  \n}\n.icon-Layout-arrange .path2:before {\n  content: \"\\ea5e\";\n  margin-left: -1em;\n  \n  opacity: 0.3;\n}\n.icon-Layout-grid .path1:before {\n  content: \"\\ea5f\";\n  \n  opacity: 0.3;\n}\n.icon-Layout-grid .path2:before {\n  content: \"\\ea60\";\n  margin-left: -1em;\n  \n}\n.icon-Layout-horizontal .path1:before {\n  content: \"\\ea61\";\n  \n  opacity: 0.3;\n}\n.icon-Layout-horizontal .path2:before {\n  content: \"\\ea62\";\n  margin-left: -1em;\n  \n}\n.icon-Layout-left-panel-1 .path1:before {\n  content: \"\\ea63\";\n  \n}\n.icon-Layout-left-panel-1 .path2:before {\n  content: \"\\ea64\";\n  margin-left: -1em;\n  \n  opacity: 0.3;\n}\n.icon-Layout-left-panel-2 .path1:before {\n  content: \"\\ea65\";\n  \n}\n.icon-Layout-left-panel-2 .path2:before {\n  content: \"\\ea66\";\n  margin-left: -1em;\n  \n  opacity: 0.3;\n}\n.icon-Layout-right-panel-1 .path1:before {\n  content: \"\\ea67\";\n  \n}\n.icon-Layout-right-panel-1 .path2:before {\n  content: \"\\ea68\";\n  margin-left: -1em;\n  \n  opacity: 0.3;\n}\n.icon-Layout-right-panel-2 .path1:before {\n  content: \"\\ea69\";\n  \n}\n.icon-Layout-right-panel-2 .path2:before {\n  content: \"\\ea6a\";\n  margin-left: -1em;\n  \n  opacity: 0.3;\n}\n.icon-Layout-top-panel-1 .path1:before {\n  content: \"\\ea6b\";\n  \n}\n.icon-Layout-top-panel-1 .path2:before {\n  content: \"\\ea6c\";\n  margin-left: -1em;\n  \n  opacity: 0.3;\n}\n.icon-Layout-top-panel-2 .path1:before {\n  content: \"\\ea6d\";\n  \n}\n.icon-Layout-top-panel-2 .path2:before {\n  content: \"\\ea6e\";\n  margin-left: -1em;\n  \n  opacity: 0.3;\n}\n.icon-Layout-top-panel-3 .path1:before {\n  content: \"\\ea6f\";\n  \n}\n.icon-Layout-top-panel-3 .path2:before {\n  content: \"\\ea70\";\n  margin-left: -1em;\n  \n  opacity: 0.3;\n}\n.icon-Layout-top-panel-4 .path1:before {\n  content: \"\\ea71\";\n  \n}\n.icon-Layout-top-panel-4 .path2:before {\n  content: \"\\ea72\";\n  margin-left: -1em;\n  \n  opacity: 0.3;\n}\n.icon-Layout-top-panel-5 .path1:before {\n  content: \"\\ea73\";\n  \n}\n.icon-Layout-top-panel-5 .path2:before {\n  content: \"\\ea74\";\n  margin-left: -1em;\n  \n  opacity: 0.3;\n}\n.icon-Layout-top-panel-6 .path1:before {\n  content: \"\\ea75\";\n  \n}\n.icon-Layout-top-panel-6 .path2:before {\n  content: \"\\ea76\";\n  margin-left: -1em;\n  \n  opacity: 0.3;\n}\n.icon-Layout-vertical .path1:before {\n  content: \"\\ea77\";\n  \n}\n.icon-Layout-vertical .path2:before {\n  content: \"\\ea78\";\n  margin-left: -1em;\n  \n  opacity: 0.3;\n}\n.icon-Air-ballon .path1:before {\n  content: \"\\ea79\";\n  \n}\n.icon-Air-ballon .path2:before {\n  content: \"\\ea7a\";\n  margin-left: -1em;\n  \n  opacity: 0.3;\n}\n.icon-Alarm-clock .path1:before {\n  content: \"\\ea7b\";\n  \n}\n.icon-Alarm-clock .path2:before {\n  content: \"\\ea7c\";\n  margin-left: -1em;\n  \n  opacity: 0.3;\n}\n.icon-Alarm-clock .path3:before {\n  content: \"\\ea7d\";\n  margin-left: -1em;\n  \n}\n.icon-Armchair .path1:before {\n  content: \"\\ea7e\";\n  \n  opacity: 0.3;\n}\n.icon-Armchair .path2:before {\n  content: \"\\ea7f\";\n  margin-left: -1em;\n  \n  opacity: 0.3;\n}\n.icon-Armchair .path3:before {\n  content: \"\\ea80\";\n  margin-left: -1em;\n  \n}\n.icon-Bag-chair:before {\n  content: \"\\ea81\";\n}\n.icon-Bath .path1:before {\n  content: \"\\ea82\";\n  \n  opacity: 0.3;\n}\n.icon-Bath .path2:before {\n  content: \"\\ea83\";\n  margin-left: -1em;\n  \n  opacity: 0.3;\n}\n.icon-Bath .path3:before {\n  content: \"\\ea84\";\n  margin-left: -1em;\n  \n}\n.icon-Bed .path1:before {\n  content: \"\\ea85\";\n  \n  opacity: 0.3;\n}\n.icon-Bed .path2:before {\n  content: \"\\ea86\";\n  margin-left: -1em;\n  \n}\n.icon-Bed .path3:before {\n  content: \"\\ea87\";\n  margin-left: -1em;\n  \n  opacity: 0.3;\n}\n.icon-Book:before {\n  content: \"\\ea88\";\n}\n.icon-Book-open .path1:before {\n  content: \"\\ea89\";\n  \n}\n.icon-Book-open .path2:before {\n  content: \"\\ea8a\";\n  margin-left: -1em;\n  \n  opacity: 0.3;\n}\n.icon-Box .path1:before {\n  content: \"\\ea8b\";\n  \n}\n.icon-Box .path2:before {\n  content: \"\\ea8c\";\n  margin-left: -1em;\n  \n  opacity: 0.3;\n}\n.icon-Broom .path1:before {\n  content: \"\\ea8d\";\n  \n  opacity: 0.3;\n}\n.icon-Broom .path2:before {\n  content: \"\\ea8e\";\n  margin-left: -1em;\n  \n}\n.icon-Building .path1:before {\n  content: \"\\ea8f\";\n  \n}\n.icon-Building .path2:before {\n  content: \"\\ea90\";\n  margin-left: -1em;\n  color: rgb(255, 255, 255);\n}\n.icon-Building .path3:before {\n  content: \"\\ea91\";\n  margin-left: -1em;\n  \n  opacity: 0.3;\n}\n.icon-Bulb .path1:before {\n  content: \"\\ea92\";\n  \n  opacity: 0.3;\n}\n.icon-Bulb .path2:before {\n  content: \"\\ea93\";\n  margin-left: -1em;\n  \n  opacity: 0.3;\n}\n.icon-Bulb .path3:before {\n  content: \"\\ea94\";\n  margin-left: -1em;\n  \n  opacity: 0.3;\n}\n.icon-Bulb .path4:before {\n  content: \"\\ea95\";\n  margin-left: -1em;\n  \n}\n.icon-Bulb1 .path1:before {\n  content: \"\\ea96\";\n  \n  opacity: 0.3;\n}\n.icon-Bulb1 .path2:before {\n  content: \"\\ea97\";\n  margin-left: -1em;\n  \n  opacity: 0.3;\n}\n.icon-Bulb1 .path3:before {\n  content: \"\\ea98\";\n  margin-left: -1em;\n  \n  opacity: 0.3;\n}\n.icon-Bulb1 .path4:before {\n  content: \"\\ea99\";\n  margin-left: -1em;\n  \n}\n.icon-Chair .path1:before {\n  content: \"\\ea9a\";\n  \n}\n.icon-Chair .path2:before {\n  content: \"\\ea9b\";\n  margin-left: -1em;\n  \n  opacity: 0.3;\n}\n.icon-Chair1 .path1:before {\n  content: \"\\ea9c\";\n  \n  opacity: 0.3;\n}\n.icon-Chair1 .path2:before {\n  content: \"\\ea9d\";\n  margin-left: -1em;\n  \n}\n.icon-Clock .path1:before {\n  content: \"\\ea9e\";\n  \n  opacity: 0.3;\n}\n.icon-Clock .path2:before {\n  content: \"\\ea9f\";\n  margin-left: -1em;\n  \n}\n.icon-Commode .path1:before {\n  content: \"\\eaa0\";\n  \n  opacity: 0.3;\n}\n.icon-Commode .path2:before {\n  content: \"\\eaa1\";\n  margin-left: -1em;\n  \n}\n.icon-Commode1 .path1:before {\n  content: \"\\eaa2\";\n  \n  opacity: 0.3;\n}\n.icon-Commode1 .path2:before {\n  content: \"\\eaa3\";\n  margin-left: -1em;\n  \n}\n.icon-Couch .path1:before {\n  content: \"\\eaa4\";\n  \n  opacity: 0.3;\n}\n.icon-Couch .path2:before {\n  content: \"\\eaa5\";\n  margin-left: -1em;\n  \n  opacity: 0.3;\n}\n.icon-Couch .path3:before {\n  content: \"\\eaa6\";\n  margin-left: -1em;\n  \n}\n.icon-Cupboard .path1:before {\n  content: \"\\eaa7\";\n  \n  opacity: 0.3;\n}\n.icon-Cupboard .path2:before {\n  content: \"\\eaa8\";\n  margin-left: -1em;\n  \n}\n.icon-Curtains .path1:before {\n  content: \"\\eaa9\";\n  \n  opacity: 0.3;\n}\n.icon-Curtains .path2:before {\n  content: \"\\eaaa\";\n  margin-left: -1em;\n  \n}\n.icon-Deer .path1:before {\n  content: \"\\eaab\";\n  \n  opacity: 0.3;\n}\n.icon-Deer .path2:before {\n  content: \"\\eaac\";\n  margin-left: -1em;\n  \n}\n.icon-Door-open .path1:before {\n  content: \"\\eaad\";\n  \n  opacity: 0.3;\n}\n.icon-Door-open .path2:before {\n  content: \"\\eaae\";\n  margin-left: -1em;\n  \n}\n.icon-Earth:before {\n  content: \"\\eaaf\";\n}\n.icon-Fireplace .path1:before {\n  content: \"\\eab0\";\n  \n  opacity: 0.3;\n}\n.icon-Fireplace .path2:before {\n  content: \"\\eab1\";\n  margin-left: -1em;\n  \n}\n.icon-Flashlight .path1:before {\n  content: \"\\eab2\";\n  \n}\n.icon-Flashlight .path2:before {\n  content: \"\\eab3\";\n  margin-left: -1em;\n  \n  opacity: 0.3;\n}\n.icon-Flower .path1:before {\n  content: \"\\eab4\";\n  \n  opacity: 0.3;\n}\n.icon-Flower .path2:before {\n  content: \"\\eab5\";\n  margin-left: -1em;\n  \n  opacity: 0.3;\n}\n.icon-Flower .path3:before {\n  content: \"\\eab6\";\n  margin-left: -1em;\n  \n  opacity: 0.3;\n}\n.icon-Flower .path4:before {\n  content: \"\\eab7\";\n  margin-left: -1em;\n  \n}\n.icon-Flower1:before {\n  content: \"\\eab8\";\n}\n.icon-239:before {\n  content: \"\\eab8\";\n}\n.icon-Flower2:before {\n  content: \"\\eab9\";\n}\n.icon-38:before {\n  content: \"\\eab9\";\n}\n.icon-Globe .path1:before {\n  content: \"\\eaba\";\n  \n}\n.icon-Globe .path2:before {\n  content: \"\\eabb\";\n  margin-left: -1em;\n  \n  opacity: 0.3;\n}\n.icon-Home:before {\n  content: \"\\eabc\";\n}\n.icon-Home-heart:before {\n  content: \"\\eabd\";\n}\n.icon-Key .path1:before {\n  content: \"\\eabe\";\n  \n  opacity: 0.3;\n}\n.icon-Key .path2:before {\n  content: \"\\eabf\";\n  margin-left: -1em;\n  \n}\n.icon-Ladder .path1:before {\n  content: \"\\eac0\";\n  \n  opacity: 0.3;\n}\n.icon-Ladder .path2:before {\n  content: \"\\eac1\";\n  margin-left: -1em;\n  \n}\n.icon-Lamp .path1:before {\n  content: \"\\eac2\";\n  \n}\n.icon-Lamp .path2:before {\n  content: \"\\eac3\";\n  margin-left: -1em;\n  \n  opacity: 0.3;\n}\n.icon-Lamp .path3:before {\n  content: \"\\eac4\";\n  margin-left: -1em;\n  color: rgb(255, 255, 255);\n}\n.icon-Lamp .path4:before {\n  content: \"\\eac5\";\n  margin-left: -1em;\n  \n}\n.icon-Lamp1 .path1:before {\n  content: \"\\eac6\";\n  \n  opacity: 0.3;\n}\n.icon-Lamp1 .path2:before {\n  content: \"\\eac7\";\n  margin-left: -1em;\n  \n  opacity: 0.3;\n}\n.icon-Lamp1 .path3:before {\n  content: \"\\eac8\";\n  margin-left: -1em;\n  \n}\n.icon-Library .path1:before {\n  content: \"\\eac9\";\n  \n}\n.icon-Library .path2:before {\n  content: \"\\eaca\";\n  margin-left: -1em;\n  \n  opacity: 0.3;\n}\n.icon-Mailbox .path1:before {\n  content: \"\\eacb\";\n  \n}\n.icon-Mailbox .path2:before {\n  content: \"\\eacc\";\n  margin-left: -1em;\n  \n  opacity: 0.3;\n}\n.icon-Mirror .path1:before {\n  content: \"\\eacd\";\n  \n}\n.icon-Mirror .path2:before {\n  content: \"\\eace\";\n  margin-left: -1em;\n  \n  opacity: 0.3;\n}\n.icon-Picture .path1:before {\n  content: \"\\eacf\";\n  \n  opacity: 0.3;\n}\n.icon-Picture .path2:before {\n  content: \"\\ead0\";\n  margin-left: -1em;\n  \n  opacity: 0.3;\n}\n.icon-Picture .path3:before {\n  content: \"\\ead1\";\n  margin-left: -1em;\n  \n}\n.icon-Picture .path4:before {\n  content: \"\\ead2\";\n  margin-left: -1em;\n  \n  opacity: 0.3;\n}\n.icon-Ruller:before {\n  content: \"\\ead3\";\n}\n.icon-Stairs:before {\n  content: \"\\ead4\";\n}\n.icon-Timer .path1:before {\n  content: \"\\ead5\";\n  \n  opacity: 0.3;\n}\n.icon-Timer .path2:before {\n  content: \"\\ead6\";\n  margin-left: -1em;\n  \n}\n.icon-Timer .path3:before {\n  content: \"\\ead7\";\n  margin-left: -1em;\n  \n}\n.icon-Timer .path4:before {\n  content: \"\\ead8\";\n  margin-left: -1em;\n  \n}\n.icon-Toilet .path1:before {\n  content: \"\\ead9\";\n  \n  opacity: 0.3;\n}\n.icon-Toilet .path2:before {\n  content: \"\\eada\";\n  margin-left: -1em;\n  \n}\n.icon-Toilet .path3:before {\n  content: \"\\eadb\";\n  margin-left: -1em;\n  \n  opacity: 0.3;\n}\n.icon-Towel:before {\n  content: \"\\eadc\";\n}\n.icon-Trash1 .path1:before {\n  content: \"\\eadd\";\n  \n}\n.icon-Trash1 .path2:before {\n  content: \"\\eade\";\n  margin-left: -1em;\n  \n  opacity: 0.3;\n}\n.icon-Water-mixer .path1:before {\n  content: \"\\eadf\";\n  \n  opacity: 0.3;\n}\n.icon-Water-mixer .path2:before {\n  content: \"\\eae0\";\n  margin-left: -1em;\n  \n}\n.icon-Water-mixer .path3:before {\n  content: \"\\eae1\";\n  margin-left: -1em;\n  \n  opacity: 0.3;\n}\n.icon-Weight .path1:before {\n  content: \"\\eae2\";\n  \n}\n.icon-Weight .path2:before {\n  content: \"\\eae3\";\n  margin-left: -1em;\n  \n  opacity: 0.3;\n}\n.icon-Weight1 .path1:before {\n  content: \"\\eae4\";\n  \n  opacity: 0.3;\n}\n.icon-Weight1 .path2:before {\n  content: \"\\eae5\";\n  margin-left: -1em;\n  \n}\n.icon-Wood .path1:before {\n  content: \"\\eae6\";\n  \n  opacity: 0.3;\n}\n.icon-Wood .path2:before {\n  content: \"\\eae7\";\n  margin-left: -1em;\n  \n}\n.icon-Wood1 .path1:before {\n  content: \"\\eae8\";\n  \n  opacity: 0.3;\n}\n.icon-Wood1 .path2:before {\n  content: \"\\eae9\";\n  margin-left: -1em;\n  \n}\n.icon-Wood-horse:before {\n  content: \"\\eaea\";\n}\n.icon-Attachment .path1:before {\n  content: \"\\eaeb\";\n  \n  opacity: 0.3;\n}\n.icon-Attachment .path2:before {\n  content: \"\\eaec\";\n  margin-left: -1em;\n  \n}\n.icon-Attachment1 .path1:before {\n  content: \"\\eaed\";\n  \n  opacity: 0.3;\n}\n.icon-Attachment1 .path2:before {\n  content: \"\\eaee\";\n  margin-left: -1em;\n  \n}\n.icon-Attachment1 .path3:before {\n  content: \"\\eaef\";\n  margin-left: -1em;\n  \n  opacity: 0.3;\n}\n.icon-Attachment1 .path4:before {\n  content: \"\\eaf0\";\n  margin-left: -1em;\n  \n  opacity: 0.3;\n}\n.icon-Binocular:before {\n  content: \"\\eaf1\";\n}\n.icon-Bookmark:before {\n  content: \"\\eaf2\";\n}\n.icon-Clip:before {\n  content: \"\\eaf3\";\n}\n.icon-Clipboard .path1:before {\n  content: \"\\eaf4\";\n  \n  opacity: 0.3;\n}\n.icon-Clipboard .path2:before {\n  content: \"\\eaf5\";\n  margin-left: -1em;\n  \n}\n.icon-Clipboard .path3:before {\n  content: \"\\eaf6\";\n  margin-left: -1em;\n  \n  opacity: 0.3;\n}\n.icon-Clipboard .path4:before {\n  content: \"\\eaf7\";\n  margin-left: -1em;\n  \n  opacity: 0.3;\n}\n.icon-Cursor:before {\n  content: \"\\eaf8\";\n}\n.icon-Dislike .path1:before {\n  content: \"\\eaf9\";\n  \n}\n.icon-Dislike .path2:before {\n  content: \"\\eafa\";\n  margin-left: -1em;\n  \n  opacity: 0.3;\n}\n.icon-Duplicate .path1:before {\n  content: \"\\eafb\";\n  \n  opacity: 0.3;\n}\n.icon-Duplicate .path2:before {\n  content: \"\\eafc\";\n  margin-left: -1em;\n  \n}\n.icon-Edit1:before {\n  content: \"\\eafd\";\n}\n.icon-Expand-arrows .path1:before {\n  content: \"\\eafe\";\n  \n  opacity: 0.3;\n}\n.icon-Expand-arrows .path2:before {\n  content: \"\\eaff\";\n  margin-left: -1em;\n  \n}\n.icon-Fire:before {\n  content: \"\\eb00\";\n}\n.icon-Folder1:before {\n  content: \"\\eb01\";\n}\n.icon-Half-heart .path1:before {\n  content: \"\\eb02\";\n  \n  opacity: 0.3;\n}\n.icon-Half-heart .path2:before {\n  content: \"\\eb03\";\n  margin-left: -1em;\n  \n}\n.icon-Half-star .path1:before {\n  content: \"\\eb04\";\n  \n  opacity: 0.3;\n}\n.icon-Half-star .path2:before {\n  content: \"\\eb05\";\n  margin-left: -1em;\n  \n}\n.icon-Heart:before {\n  content: \"\\eb06\";\n}\n.icon-Hidden .path1:before {\n  content: \"\\eb07\";\n  \n}\n.icon-Hidden .path2:before {\n  content: \"\\eb08\";\n  margin-left: -1em;\n  \n}\n.icon-Hidden .path3:before {\n  content: \"\\eb09\";\n  margin-left: -1em;\n  \n  opacity: 0.3;\n}\n.icon-Like .path1:before {\n  content: \"\\eb0a\";\n  \n}\n.icon-Like .path2:before {\n  content: \"\\eb0b\";\n  margin-left: -1em;\n  \n  opacity: 0.3;\n}\n.icon-Lock:before {\n  content: \"\\eb0c\";\n}\n.icon-Notification .path1:before {\n  content: \"\\eb0d\";\n  \n}\n.icon-Notification .path2:before {\n  content: \"\\eb0e\";\n  margin-left: -1em;\n  \n  opacity: 0.3;\n}\n.icon-Notifications .path1:before {\n  content: \"\\eb0f\";\n  \n}\n.icon-Notifications .path2:before {\n  content: \"\\eb10\";\n  margin-left: -1em;\n  \n  opacity: 0.3;\n}\n.icon-Other:before {\n  content: \"\\eb11\";\n}\n.icon-133:before {\n  content: \"\\eb11\";\n}\n.icon-Other1:before {\n  content: \"\\eb12\";\n}\n.icon-234:before {\n  content: \"\\eb12\";\n}\n.icon-Sad .path1:before {\n  content: \"\\eb13\";\n  \n  opacity: 0.3;\n}\n.icon-Sad .path2:before {\n  content: \"\\eb14\";\n  margin-left: -1em;\n  \n}\n.icon-Save .path1:before {\n  content: \"\\eb15\";\n  \n}\n.icon-Save .path2:before {\n  content: \"\\eb16\";\n  margin-left: -1em;\n  \n  opacity: 0.3;\n}\n.icon-Scale .path1:before {\n  content: \"\\eb17\";\n  \n}\n.icon-Scale .path2:before {\n  content: \"\\eb18\";\n  margin-left: -1em;\n  \n  opacity: 0.3;\n}\n.icon-Scissors .path1:before {\n  content: \"\\eb19\";\n  \n  opacity: 0.3;\n}\n.icon-Scissors .path2:before {\n  content: \"\\eb1a\";\n  margin-left: -1em;\n  \n}\n.icon-Search .path1:before {\n  content: \"\\eb1b\";\n  \n  opacity: 0.3;\n}\n.icon-Search .path2:before {\n  content: \"\\eb1c\";\n  margin-left: -1em;\n  \n}\n.icon-Settings2 .path1:before {\n  content: \"\\eb1d\";\n  \n  opacity: 0.3;\n}\n.icon-Settings2 .path2:before {\n  content: \"\\eb1e\";\n  margin-left: -1em;\n  \n}\n.icon-Settings-1 .path1:before {\n  content: \"\\eb1f\";\n  \n}\n.icon-Settings-1 .path2:before {\n  content: \"\\eb20\";\n  margin-left: -1em;\n  \n  opacity: 0.3;\n}\n.icon-Settings-2:before {\n  content: \"\\eb21\";\n}\n.icon-Shield-check .path1:before {\n  content: \"\\eb22\";\n  \n  opacity: 0.3;\n}\n.icon-Shield-check .path2:before {\n  content: \"\\eb23\";\n  margin-left: -1em;\n  \n}\n.icon-Shield-disabled .path1:before {\n  content: \"\\eb24\";\n  \n  opacity: 0.3;\n}\n.icon-Shield-disabled .path2:before {\n  content: \"\\eb25\";\n  margin-left: -1em;\n  \n}\n.icon-Shield-protected .path1:before {\n  content: \"\\eb26\";\n  \n  opacity: 0.3;\n}\n.icon-Shield-protected .path2:before {\n  content: \"\\eb27\";\n  margin-left: -1em;\n  \n}\n.icon-Size .path1:before {\n  content: \"\\eb28\";\n  \n}\n.icon-Size .path2:before {\n  content: \"\\eb29\";\n  margin-left: -1em;\n  \n  opacity: 0.3;\n}\n.icon-Smile .path1:before {\n  content: \"\\eb2a\";\n  \n  opacity: 0.3;\n}\n.icon-Smile .path2:before {\n  content: \"\\eb2b\";\n  margin-left: -1em;\n  \n}\n.icon-Star:before {\n  content: \"\\eb2c\";\n}\n.icon-Thunder1:before {\n  content: \"\\eb2d\";\n}\n.icon-Thunder-move .path1:before {\n  content: \"\\eb2e\";\n  \n}\n.icon-Thunder-move .path2:before {\n  content: \"\\eb2f\";\n  margin-left: -1em;\n  \n  opacity: 0.3;\n}\n.icon-Trash .path1:before {\n  content: \"\\eb30\";\n  \n}\n.icon-Trash .path2:before {\n  content: \"\\eb31\";\n  margin-left: -1em;\n  \n  opacity: 0.3;\n}\n.icon-Unlock:before {\n  content: \"\\eb32\";\n}\n.icon-Update:before {\n  content: \"\\eb33\";\n}\n.icon-User .path1:before {\n  content: \"\\eb34\";\n  \n  opacity: 0.3;\n}\n.icon-User .path2:before {\n  content: \"\\eb35\";\n  margin-left: -1em;\n  \n}\n.icon-Visible:before {\n  content: \"\\eb36\";\n}\n.icon-Beer .path1:before {\n  content: \"\\eb37\";\n  \n  opacity: 0.3;\n}\n.icon-Beer .path2:before {\n  content: \"\\eb38\";\n  margin-left: -1em;\n  \n  opacity: 0.3;\n}\n.icon-Beer .path3:before {\n  content: \"\\eb39\";\n  margin-left: -1em;\n  \n  opacity: 0.3;\n}\n.icon-Beer .path4:before {\n  content: \"\\eb3a\";\n  margin-left: -1em;\n  \n  opacity: 0.3;\n}\n.icon-Beer .path5:before {\n  content: \"\\eb3b\";\n  margin-left: -1em;\n  \n}\n.icon-Bottle .path1:before {\n  content: \"\\eb3c\";\n  \n}\n.icon-Bottle .path2:before {\n  content: \"\\eb3d\";\n  margin-left: -1em;\n  \n  opacity: 0.3;\n}\n.icon-Bottle1 .path1:before {\n  content: \"\\eb3e\";\n  \n}\n.icon-Bottle1 .path2:before {\n  content: \"\\eb3f\";\n  margin-left: -1em;\n  \n  opacity: 0.3;\n}\n.icon-Bread .path1:before {\n  content: \"\\eb40\";\n  \n  opacity: 0.3;\n}\n.icon-Bread .path2:before {\n  content: \"\\eb41\";\n  margin-left: -1em;\n  \n}\n.icon-Bucket1 .path1:before {\n  content: \"\\eb42\";\n  \n  opacity: 0.3;\n}\n.icon-Bucket1 .path2:before {\n  content: \"\\eb43\";\n  margin-left: -1em;\n  \n}\n.icon-Burger .path1:before {\n  content: \"\\eb44\";\n  \n}\n.icon-Burger .path2:before {\n  content: \"\\eb45\";\n  margin-left: -1em;\n  \n}\n.icon-Burger .path3:before {\n  content: \"\\eb46\";\n  margin-left: -1em;\n  \n  opacity: 0.3;\n}\n.icon-Cake .path1:before {\n  content: \"\\eb47\";\n  \n}\n.icon-Cake .path2:before {\n  content: \"\\eb48\";\n  margin-left: -1em;\n  \n  opacity: 0.3;\n}\n.icon-Cake .path3:before {\n  content: \"\\eb49\";\n  margin-left: -1em;\n  \n  opacity: 0.3;\n}\n.icon-Carrot .path1:before {\n  content: \"\\eb4a\";\n  \n  opacity: 0.3;\n}\n.icon-Carrot .path2:before {\n  content: \"\\eb4b\";\n  margin-left: -1em;\n  \n  opacity: 0.3;\n}\n.icon-Carrot .path3:before {\n  content: \"\\eb4c\";\n  margin-left: -1em;\n  \n  opacity: 0.3;\n}\n.icon-Carrot .path4:before {\n  content: \"\\eb4d\";\n  margin-left: -1em;\n  \n}\n.icon-Cheese .path1:before {\n  content: \"\\eb4e\";\n  \n}\n.icon-Cheese .path2:before {\n  content: \"\\eb4f\";\n  margin-left: -1em;\n  \n  opacity: 0.3;\n}\n.icon-Chicken .path1:before {\n  content: \"\\eb50\";\n  \n}\n.icon-Chicken .path2:before {\n  content: \"\\eb51\";\n  margin-left: -1em;\n  \n  opacity: 0.3;\n}\n.icon-Coffee .path1:before {\n  content: \"\\eb52\";\n  \n}\n.icon-Coffee .path2:before {\n  content: \"\\eb53\";\n  margin-left: -1em;\n  \n  opacity: 0.3;\n}\n.icon-Coffee .path3:before {\n  content: \"\\eb54\";\n  margin-left: -1em;\n  \n  opacity: 0.3;\n}\n.icon-Coffee .path4:before {\n  content: \"\\eb55\";\n  margin-left: -1em;\n  \n  opacity: 0.3;\n}\n.icon-Coffee .path5:before {\n  content: \"\\eb56\";\n  margin-left: -1em;\n  \n  opacity: 0.3;\n}\n.icon-Coffee1 .path1:before {\n  content: \"\\eb57\";\n  \n  opacity: 0.3;\n}\n.icon-Coffee1 .path2:before {\n  content: \"\\eb58\";\n  margin-left: -1em;\n  \n}\n.icon-Coffee1 .path3:before {\n  content: \"\\eb59\";\n  margin-left: -1em;\n  \n  opacity: 0.3;\n}\n.icon-Cookie:before {\n  content: \"\\eb5a\";\n}\n.icon-Dinner1 .path1:before {\n  content: \"\\eb5b\";\n  \n  opacity: 0.3;\n}\n.icon-Dinner1 .path2:before {\n  content: \"\\eb5c\";\n  margin-left: -1em;\n  \n}\n.icon-Fish .path1:before {\n  content: \"\\eb5d\";\n  \n  opacity: 0.3;\n}\n.icon-Fish .path2:before {\n  content: \"\\eb5e\";\n  margin-left: -1em;\n  \n}\n.icon-French-Bread:before {\n  content: \"\\eb5f\";\n}\n.icon-Glass-martini .path1:before {\n  content: \"\\eb60\";\n  \n  opacity: 0.3;\n}\n.icon-Glass-martini .path2:before {\n  content: \"\\eb61\";\n  margin-left: -1em;\n  \n}\n.icon-Ice-cream1 .path1:before {\n  content: \"\\eb62\";\n  \n  opacity: 0.3;\n}\n.icon-Ice-cream1 .path2:before {\n  content: \"\\eb63\";\n  margin-left: -1em;\n  \n}\n.icon-Ice-cream .path1:before {\n  content: \"\\eb64\";\n  \n}\n.icon-Ice-cream .path2:before {\n  content: \"\\eb65\";\n  margin-left: -1em;\n  \n  opacity: 0.3;\n}\n.icon-Miso-soup .path1:before {\n  content: \"\\eb66\";\n  \n}\n.icon-Miso-soup .path2:before {\n  content: \"\\eb67\";\n  margin-left: -1em;\n  \n  opacity: 0.3;\n}\n.icon-Orange .path1:before {\n  content: \"\\eb68\";\n  \n}\n.icon-Orange .path2:before {\n  content: \"\\eb69\";\n  margin-left: -1em;\n  \n  opacity: 0.3;\n}\n.icon-Pizza:before {\n  content: \"\\eb6a\";\n}\n.icon-Sushi .path1:before {\n  content: \"\\eb6b\";\n  \n}\n.icon-Sushi .path2:before {\n  content: \"\\eb6c\";\n  margin-left: -1em;\n  \n  opacity: 0.3;\n}\n.icon-Two-bottles .path1:before {\n  content: \"\\eb6d\";\n  \n}\n.icon-Two-bottles .path2:before {\n  content: \"\\eb6e\";\n  margin-left: -1em;\n  \n  opacity: 0.3;\n}\n.icon-Wine .path1:before {\n  content: \"\\eb6f\";\n  \n  opacity: 0.3;\n}\n.icon-Wine .path2:before {\n  content: \"\\eb70\";\n  margin-left: -1em;\n  \n}\n.icon-Cloud-download .path1:before {\n  content: \"\\eb71\";\n  \n  opacity: 0.3;\n}\n.icon-Cloud-download .path2:before {\n  content: \"\\eb72\";\n  margin-left: -1em;\n  \n}\n.icon-Cloud-upload .path1:before {\n  content: \"\\eb73\";\n  \n  opacity: 0.3;\n}\n.icon-Cloud-upload .path2:before {\n  content: \"\\eb74\";\n  margin-left: -1em;\n  \n}\n.icon-Compilation .path1:before {\n  content: \"\\eb75\";\n  \n  opacity: 0.3;\n}\n.icon-Compilation .path2:before {\n  content: \"\\eb76\";\n  margin-left: -1em;\n  \n  opacity: 0.3;\n}\n.icon-Compilation .path3:before {\n  content: \"\\eb77\";\n  margin-left: -1em;\n  \n  opacity: 0.3;\n}\n.icon-Compilation .path4:before {\n  content: \"\\eb78\";\n  margin-left: -1em;\n  \n}\n.icon-Compilation .path5:before {\n  content: \"\\eb79\";\n  margin-left: -1em;\n  \n}\n.icon-Compiled-file .path1:before {\n  content: \"\\eb7a\";\n  \n  opacity: 0.3;\n}\n.icon-Compiled-file .path2:before {\n  content: \"\\eb7b\";\n  margin-left: -1em;\n  \n  opacity: 0.3;\n}\n.icon-Compiled-file .path3:before {\n  content: \"\\eb7c\";\n  margin-left: -1em;\n  \n  opacity: 0.3;\n}\n.icon-Compiled-file .path4:before {\n  content: \"\\eb7d\";\n  margin-left: -1em;\n  \n}\n.icon-Compiled-file .path5:before {\n  content: \"\\eb7e\";\n  margin-left: -1em;\n  \n}\n.icon-Deleted-file .path1:before {\n  content: \"\\eb7f\";\n  \n  opacity: 0.3;\n}\n.icon-Deleted-file .path2:before {\n  content: \"\\eb80\";\n  margin-left: -1em;\n  \n}\n.icon-Deleted-folder .path1:before {\n  content: \"\\eb81\";\n  \n  opacity: 0.3;\n}\n.icon-Deleted-folder .path2:before {\n  content: \"\\eb82\";\n  margin-left: -1em;\n  \n}\n.icon-Download .path1:before {\n  content: \"\\eb83\";\n  \n  opacity: 0.3;\n}\n.icon-Download .path2:before {\n  content: \"\\eb84\";\n  margin-left: -1em;\n  \n  opacity: 0.3;\n}\n.icon-Download .path3:before {\n  content: \"\\eb85\";\n  margin-left: -1em;\n  \n}\n.icon-Downloaded-file .path1:before {\n  content: \"\\eb86\";\n  \n  opacity: 0.3;\n}\n.icon-Downloaded-file .path2:before {\n  content: \"\\eb87\";\n  margin-left: -1em;\n  \n}\n.icon-Downloads-folder .path1:before {\n  content: \"\\eb88\";\n  \n  opacity: 0.3;\n}\n.icon-Downloads-folder .path2:before {\n  content: \"\\eb89\";\n  margin-left: -1em;\n  \n}\n.icon-Export .path1:before {\n  content: \"\\eb8a\";\n  \n  opacity: 0.3;\n}\n.icon-Export .path2:before {\n  content: \"\\eb8b\";\n  margin-left: -1em;\n  \n  opacity: 0.3;\n}\n.icon-Export .path3:before {\n  content: \"\\eb8c\";\n  margin-left: -1em;\n  \n}\n.icon-File .path1:before {\n  content: \"\\eb8d\";\n  \n  opacity: 0.3;\n}\n.icon-File .path2:before {\n  content: \"\\eb8e\";\n  margin-left: -1em;\n  \n}\n.icon-File .path3:before {\n  content: \"\\eb8f\";\n  margin-left: -1em;\n  \n}\n.icon-File-cloud .path1:before {\n  content: \"\\eb90\";\n  \n  opacity: 0.3;\n}\n.icon-File-cloud .path2:before {\n  content: \"\\eb91\";\n  margin-left: -1em;\n  \n}\n.icon-File-done .path1:before {\n  content: \"\\eb92\";\n  \n  opacity: 0.3;\n}\n.icon-File-done .path2:before {\n  content: \"\\eb93\";\n  margin-left: -1em;\n  \n}\n.icon-File-minus .path1:before {\n  content: \"\\eb94\";\n  \n  opacity: 0.3;\n}\n.icon-File-minus .path2:before {\n  content: \"\\eb95\";\n  margin-left: -1em;\n  \n}\n.icon-File-plus .path1:before {\n  content: \"\\eb96\";\n  \n  opacity: 0.3;\n}\n.icon-File-plus .path2:before {\n  content: \"\\eb97\";\n  margin-left: -1em;\n  \n}\n.icon-Folder:before {\n  content: \"\\eb98\";\n}\n.icon-Folder-check .path1:before {\n  content: \"\\eb99\";\n  \n  opacity: 0.3;\n}\n.icon-Folder-check .path2:before {\n  content: \"\\eb9a\";\n  margin-left: -1em;\n  \n}\n.icon-Folder-cloud .path1:before {\n  content: \"\\eb9b\";\n  \n  opacity: 0.3;\n}\n.icon-Folder-cloud .path2:before {\n  content: \"\\eb9c\";\n  margin-left: -1em;\n  \n}\n.icon-Folder-error .path1:before {\n  content: \"\\eb9d\";\n  \n}\n.icon-Folder-error .path2:before {\n  content: \"\\eb9e\";\n  margin-left: -1em;\n  \n  opacity: 0.3;\n}\n.icon-Folder-heart:before {\n  content: \"\\eb9f\";\n}\n.icon-Folder-minus .path1:before {\n  content: \"\\eba0\";\n  \n  opacity: 0.3;\n}\n.icon-Folder-minus .path2:before {\n  content: \"\\eba1\";\n  margin-left: -1em;\n  \n}\n.icon-Folder-plus .path1:before {\n  content: \"\\eba2\";\n  \n  opacity: 0.3;\n}\n.icon-Folder-plus .path2:before {\n  content: \"\\eba3\";\n  margin-left: -1em;\n  \n}\n.icon-Folder-solid:before {\n  content: \"\\eba4\";\n}\n.icon-Folder-star:before {\n  content: \"\\eba5\";\n}\n.icon-Folder-thunder:before {\n  content: \"\\eba6\";\n}\n.icon-Group-folders .path1:before {\n  content: \"\\eba7\";\n  \n  opacity: 0.3;\n}\n.icon-Group-folders .path2:before {\n  content: \"\\eba8\";\n  margin-left: -1em;\n  \n}\n.icon-Import .path1:before {\n  content: \"\\eba9\";\n  \n  opacity: 0.3;\n}\n.icon-Import .path2:before {\n  content: \"\\ebaa\";\n  margin-left: -1em;\n  \n  opacity: 0.3;\n}\n.icon-Import .path3:before {\n  content: \"\\ebab\";\n  margin-left: -1em;\n  \n}\n.icon-Locked-folder .path1:before {\n  content: \"\\ebac\";\n  \n  opacity: 0.3;\n}\n.icon-Locked-folder .path2:before {\n  content: \"\\ebad\";\n  margin-left: -1em;\n  \n}\n.icon-Media .path1:before {\n  content: \"\\ebae\";\n  \n  opacity: 0.3;\n}\n.icon-Media .path2:before {\n  content: \"\\ebaf\";\n  margin-left: -1em;\n  \n}\n.icon-Media-folder .path1:before {\n  content: \"\\ebb0\";\n  \n  opacity: 0.3;\n}\n.icon-Media-folder .path2:before {\n  content: \"\\ebb1\";\n  margin-left: -1em;\n  \n}\n.icon-Music .path1:before {\n  content: \"\\ebb2\";\n  \n  opacity: 0.3;\n}\n.icon-Music .path2:before {\n  content: \"\\ebb3\";\n  margin-left: -1em;\n  \n}\n.icon-Pictures .path1:before {\n  content: \"\\ebb4\";\n  \n  opacity: 0.3;\n}\n.icon-Pictures .path2:before {\n  content: \"\\ebb5\";\n  margin-left: -1em;\n  \n  opacity: 0.3;\n}\n.icon-Pictures .path3:before {\n  content: \"\\ebb6\";\n  margin-left: -1em;\n  \n}\n.icon-Pictures .path4:before {\n  content: \"\\ebb7\";\n  margin-left: -1em;\n  \n  opacity: 0.3;\n}\n.icon-Pictures1:before {\n  content: \"\\ebb8\";\n}\n.icon-221:before {\n  content: \"\\ebb8\";\n}\n.icon-Protected-file .path1:before {\n  content: \"\\ebb9\";\n  \n  opacity: 0.3;\n}\n.icon-Protected-file .path2:before {\n  content: \"\\ebba\";\n  margin-left: -1em;\n  \n}\n.icon-Selected-file .path1:before {\n  content: \"\\ebbb\";\n  \n  opacity: 0.3;\n}\n.icon-Selected-file .path2:before {\n  content: \"\\ebbc\";\n  margin-left: -1em;\n  \n}\n.icon-Share1 .path1:before {\n  content: \"\\ebbd\";\n  \n}\n.icon-Share1 .path2:before {\n  content: \"\\ebbe\";\n  margin-left: -1em;\n  \n  opacity: 0.3;\n}\n.icon-Share1 .path3:before {\n  content: \"\\ebbf\";\n  margin-left: -1em;\n  \n  opacity: 0.3;\n}\n.icon-Share1 .path4:before {\n  content: \"\\ebc0\";\n  margin-left: -1em;\n  \n  opacity: 0.3;\n}\n.icon-Upload .path1:before {\n  content: \"\\ebc1\";\n  \n  opacity: 0.3;\n}\n.icon-Upload .path2:before {\n  content: \"\\ebc2\";\n  margin-left: -1em;\n  \n  opacity: 0.3;\n}\n.icon-Upload .path3:before {\n  content: \"\\ebc3\";\n  margin-left: -1em;\n  \n}\n.icon-Uploaded-file .path1:before {\n  content: \"\\ebc4\";\n  \n  opacity: 0.3;\n}\n.icon-Uploaded-file .path2:before {\n  content: \"\\ebc5\";\n  margin-left: -1em;\n  \n}\n.icon-Upload-folder .path1:before {\n  content: \"\\ebc6\";\n  \n  opacity: 0.3;\n}\n.icon-Upload-folder .path2:before {\n  content: \"\\ebc7\";\n  margin-left: -1em;\n  \n}\n.icon-User-folder:before {\n  content: \"\\ebc8\";\n}\n.icon-Air-conditioning .path1:before {\n  content: \"\\ebc9\";\n  \n}\n.icon-Air-conditioning .path2:before {\n  content: \"\\ebca\";\n  margin-left: -1em;\n  \n  opacity: 0.3;\n}\n.icon-air-dryer .path1:before {\n  content: \"\\ebcb\";\n  \n  opacity: 0.3;\n}\n.icon-air-dryer .path2:before {\n  content: \"\\ebcc\";\n  margin-left: -1em;\n  \n}\n.icon-Blender .path1:before {\n  content: \"\\ebcd\";\n  \n}\n.icon-Blender .path2:before {\n  content: \"\\ebce\";\n  margin-left: -1em;\n  \n  opacity: 0.3;\n}\n.icon-Fan:before {\n  content: \"\\ebcf\";\n}\n.icon-Fridge:before {\n  content: \"\\ebd0\";\n}\n.icon-Gas-stove .path1:before {\n  content: \"\\ebd1\";\n  \n}\n.icon-Gas-stove .path2:before {\n  content: \"\\ebd2\";\n  margin-left: -1em;\n  \n  opacity: 0.3;\n}\n.icon-Highvoltage:before {\n  content: \"\\ebd3\";\n}\n.icon-Iron .path1:before {\n  content: \"\\ebd4\";\n  \n  opacity: 0.3;\n}\n.icon-Iron .path2:before {\n  content: \"\\ebd5\";\n  margin-left: -1em;\n  \n}\n.icon-Kettle .path1:before {\n  content: \"\\ebd6\";\n  \n}\n.icon-Kettle .path2:before {\n  content: \"\\ebd7\";\n  margin-left: -1em;\n  \n  opacity: 0.3;\n}\n.icon-Mixer .path1:before {\n  content: \"\\ebd8\";\n  \n}\n.icon-Mixer .path2:before {\n  content: \"\\ebd9\";\n  margin-left: -1em;\n  \n  opacity: 0.3;\n}\n.icon-Outlet .path1:before {\n  content: \"\\ebda\";\n  \n  opacity: 0.3;\n}\n.icon-Outlet .path2:before {\n  content: \"\\ebdb\";\n  margin-left: -1em;\n  \n}\n.icon-Range-hood .path1:before {\n  content: \"\\ebdc\";\n  \n}\n.icon-Range-hood .path2:before {\n  content: \"\\ebdd\";\n  margin-left: -1em;\n  \n  opacity: 0.3;\n}\n.icon-Shutdown .path1:before {\n  content: \"\\ebde\";\n  \n}\n.icon-Shutdown .path2:before {\n  content: \"\\ebdf\";\n  margin-left: -1em;\n  \n  opacity: 0.3;\n}\n.icon-Socket-eu:before {\n  content: \"\\ebe0\";\n}\n.icon-Socket-us:before {\n  content: \"\\ebe1\";\n}\n.icon-Washer .path1:before {\n  content: \"\\ebe2\";\n  \n}\n.icon-Washer .path2:before {\n  content: \"\\ebe3\";\n  margin-left: -1em;\n  \n  opacity: 0.3;\n}\n.icon-Airpods .path1:before {\n  content: \"\\ebe4\";\n  \n  opacity: 0.3;\n}\n.icon-Airpods .path2:before {\n  content: \"\\ebe5\";\n  margin-left: -1em;\n  \n  opacity: 0.3;\n}\n.icon-Airpods .path3:before {\n  content: \"\\ebe6\";\n  margin-left: -1em;\n  \n}\n.icon-Airpods .path4:before {\n  content: \"\\ebe7\";\n  margin-left: -1em;\n  \n}\n.icon-Android .path1:before {\n  content: \"\\ebe8\";\n  \n}\n.icon-Android .path2:before {\n  content: \"\\ebe9\";\n  margin-left: -1em;\n  \n  opacity: 0.3;\n}\n.icon-Apple-Watch .path1:before {\n  content: \"\\ebea\";\n  \n  opacity: 0.3;\n}\n.icon-Apple-Watch .path2:before {\n  content: \"\\ebeb\";\n  margin-left: -1em;\n  \n}\n.icon-Battery-charging .path1:before {\n  content: \"\\ebec\";\n  \n}\n.icon-Battery-charging .path2:before {\n  content: \"\\ebed\";\n  margin-left: -1em;\n  \n  opacity: 0.3;\n}\n.icon-Battery-charging .path3:before {\n  content: \"\\ebee\";\n  margin-left: -1em;\n  \n  opacity: 0.3;\n}\n.icon-Battery-empty .path1:before {\n  content: \"\\ebef\";\n  \n}\n.icon-Battery-empty .path2:before {\n  content: \"\\ebf0\";\n  margin-left: -1em;\n  \n  opacity: 0.3;\n}\n.icon-Battery-full .path1:before {\n  content: \"\\ebf1\";\n  \n}\n.icon-Battery-full .path2:before {\n  content: \"\\ebf2\";\n  margin-left: -1em;\n  \n  opacity: 0.3;\n}\n.icon-Battery-half .path1:before {\n  content: \"\\ebf3\";\n  \n}\n.icon-Battery-half .path2:before {\n  content: \"\\ebf4\";\n  margin-left: -1em;\n  \n  opacity: 0.3;\n}\n.icon-Bluetooth .path1:before {\n  content: \"\\ebf5\";\n  \n  opacity: 0.3;\n}\n.icon-Bluetooth .path2:before {\n  content: \"\\ebf6\";\n  margin-left: -1em;\n  \n}\n.icon-Camera .path1:before {\n  content: \"\\ebf7\";\n  \n}\n.icon-Camera .path2:before {\n  content: \"\\ebf8\";\n  margin-left: -1em;\n  \n  opacity: 0.3;\n}\n.icon-Camera .path3:before {\n  content: \"\\ebf9\";\n  margin-left: -1em;\n  \n  opacity: 0.3;\n}\n.icon-Cardboard-vr .path1:before {\n  content: \"\\ebfa\";\n  \n  opacity: 0.3;\n}\n.icon-Cardboard-vr .path2:before {\n  content: \"\\ebfb\";\n  margin-left: -1em;\n  \n}\n.icon-Cassete .path1:before {\n  content: \"\\ebfc\";\n  \n  opacity: 0.3;\n}\n.icon-Cassete .path2:before {\n  content: \"\\ebfd\";\n  margin-left: -1em;\n  \n}\n.icon-Cassete .path3:before {\n  content: \"\\ebfe\";\n  margin-left: -1em;\n  \n}\n.icon-CPU .path1:before {\n  content: \"\\ebff\";\n  \n  opacity: 0.3;\n}\n.icon-CPU .path2:before {\n  content: \"\\ec00\";\n  margin-left: -1em;\n  \n  opacity: 0.3;\n}\n.icon-CPU .path3:before {\n  content: \"\\ec01\";\n  margin-left: -1em;\n  \n}\n.icon-CPU .path4:before {\n  content: \"\\ec02\";\n  margin-left: -1em;\n  \n}\n.icon-CPU .path5:before {\n  content: \"\\ec03\";\n  margin-left: -1em;\n  \n}\n.icon-CPU .path6:before {\n  content: \"\\ec04\";\n  margin-left: -1em;\n  \n}\n.icon-CPU .path7:before {\n  content: \"\\ec05\";\n  margin-left: -1em;\n  \n}\n.icon-CPU .path8:before {\n  content: \"\\ec06\";\n  margin-left: -1em;\n  \n}\n.icon-CPU1:before {\n  content: \"\\ec07\";\n}\n.icon-222:before {\n  content: \"\\ec07\";\n}\n.icon-Diagnostics .path1:before {\n  content: \"\\ec08\";\n  \n  opacity: 0.3;\n}\n.icon-Diagnostics .path2:before {\n  content: \"\\ec09\";\n  margin-left: -1em;\n  \n}\n.icon-Diagnostics .path3:before {\n  content: \"\\ec0a\";\n  margin-left: -1em;\n  \n  opacity: 0.3;\n}\n.icon-Display .path1:before {\n  content: \"\\ec0b\";\n  \n  opacity: 0.3;\n}\n.icon-Display .path2:before {\n  content: \"\\ec0c\";\n  margin-left: -1em;\n  \n}\n.icon-Display1 .path1:before {\n  content: \"\\ec0d\";\n  \n  opacity: 0.3;\n}\n.icon-Display1 .path2:before {\n  content: \"\\ec0e\";\n  margin-left: -1em;\n  \n  opacity: 0.3;\n}\n.icon-Display1 .path3:before {\n  content: \"\\ec0f\";\n  margin-left: -1em;\n  \n}\n.icon-Display2 .path1:before {\n  content: \"\\ec10\";\n  \n  opacity: 0.3;\n}\n.icon-Display2 .path2:before {\n  content: \"\\ec11\";\n  margin-left: -1em;\n  \n  opacity: 0.3;\n}\n.icon-Display2 .path3:before {\n  content: \"\\ec12\";\n  margin-left: -1em;\n  \n}\n.icon-Gameboy .path1:before {\n  content: \"\\ec13\";\n  \n  opacity: 0.3;\n}\n.icon-Gameboy .path2:before {\n  content: \"\\ec14\";\n  margin-left: -1em;\n  \n}\n.icon-Gamepad .path1:before {\n  content: \"\\ec15\";\n  \n  opacity: 0.3;\n}\n.icon-Gamepad .path2:before {\n  content: \"\\ec16\";\n  margin-left: -1em;\n  \n}\n.icon-Gamepad1 .path1:before {\n  content: \"\\ec17\";\n  \n  opacity: 0.3;\n}\n.icon-Gamepad1 .path2:before {\n  content: \"\\ec18\";\n  margin-left: -1em;\n  \n}\n.icon-Generator .path1:before {\n  content: \"\\ec19\";\n  \n  opacity: 0.3;\n}\n.icon-Generator .path2:before {\n  content: \"\\ec1a\";\n  margin-left: -1em;\n  \n}\n.icon-Generator .path3:before {\n  content: \"\\ec1b\";\n  margin-left: -1em;\n  \n}\n.icon-Generator .path4:before {\n  content: \"\\ec1c\";\n  margin-left: -1em;\n  \n}\n.icon-Hard-drive .path1:before {\n  content: \"\\ec1d\";\n  \n}\n.icon-Hard-drive .path2:before {\n  content: \"\\ec1e\";\n  margin-left: -1em;\n  \n  opacity: 0.3;\n}\n.icon-Headphones .path1:before {\n  content: \"\\ec1f\";\n  \n  opacity: 0.3;\n}\n.icon-Headphones .path2:before {\n  content: \"\\ec20\";\n  margin-left: -1em;\n  \n}\n.icon-Homepod .path1:before {\n  content: \"\\ec21\";\n  \n  opacity: 0.3;\n}\n.icon-Homepod .path2:before {\n  content: \"\\ec22\";\n  margin-left: -1em;\n  \n}\n.icon-iMac .path1:before {\n  content: \"\\ec23\";\n  \n}\n.icon-iMac .path2:before {\n  content: \"\\ec24\";\n  margin-left: -1em;\n  \n  opacity: 0.3;\n}\n.icon-iMac .path3:before {\n  content: \"\\ec25\";\n  margin-left: -1em;\n  \n  opacity: 0.3;\n}\n.icon-iPhone-back:before {\n  content: \"\\ec26\";\n}\n.icon-iPhone-X .path1:before {\n  content: \"\\ec27\";\n  \n  opacity: 0.3;\n}\n.icon-iPhone-X .path2:before {\n  content: \"\\ec28\";\n  margin-left: -1em;\n  \n}\n.icon-iPhone-x-back:before {\n  content: \"\\ec29\";\n}\n.icon-Keyboard .path1:before {\n  content: \"\\ec2a\";\n  \n  opacity: 0.3;\n}\n.icon-Keyboard .path2:before {\n  content: \"\\ec2b\";\n  margin-left: -1em;\n  \n}\n.icon-Laptop .path1:before {\n  content: \"\\ec2c\";\n  \n}\n.icon-Laptop .path2:before {\n  content: \"\\ec2d\";\n  margin-left: -1em;\n  \n  opacity: 0.3;\n}\n.icon-Laptop-macbook .path1:before {\n  content: \"\\ec2e\";\n  \n}\n.icon-Laptop-macbook .path2:before {\n  content: \"\\ec2f\";\n  margin-left: -1em;\n  \n  opacity: 0.3;\n}\n.icon-LTE .path1:before {\n  content: \"\\ec30\";\n  \n  opacity: 0.3;\n}\n.icon-LTE .path2:before {\n  content: \"\\ec31\";\n  margin-left: -1em;\n  \n}\n.icon-LTE1 .path1:before {\n  content: \"\\ec32\";\n  \n  opacity: 0.3;\n}\n.icon-LTE1 .path2:before {\n  content: \"\\ec33\";\n  margin-left: -1em;\n  \n}\n.icon-Mic .path1:before {\n  content: \"\\ec34\";\n  \n}\n.icon-Mic .path2:before {\n  content: \"\\ec35\";\n  margin-left: -1em;\n  \n  opacity: 0.3;\n}\n.icon-Midi .path1:before {\n  content: \"\\ec36\";\n  \n  opacity: 0.3;\n}\n.icon-Midi .path2:before {\n  content: \"\\ec37\";\n  margin-left: -1em;\n  \n  opacity: 0.3;\n}\n.icon-Midi .path3:before {\n  content: \"\\ec38\";\n  margin-left: -1em;\n  \n  opacity: 0.3;\n}\n.icon-Midi .path4:before {\n  content: \"\\ec39\";\n  margin-left: -1em;\n  \n  opacity: 0.3;\n}\n.icon-Midi .path5:before {\n  content: \"\\ec3a\";\n  margin-left: -1em;\n  \n}\n.icon-Midi .path6:before {\n  content: \"\\ec3b\";\n  margin-left: -1em;\n  \n}\n.icon-Midi .path7:before {\n  content: \"\\ec3c\";\n  margin-left: -1em;\n  \n}\n.icon-Mouse .path1:before {\n  content: \"\\ec3d\";\n  \n  opacity: 0.3;\n}\n.icon-Mouse .path2:before {\n  content: \"\\ec3e\";\n  margin-left: -1em;\n  \n}\n.icon-Mouse .path3:before {\n  content: \"\\ec3f\";\n  margin-left: -1em;\n  \n}\n.icon-Phone .path1:before {\n  content: \"\\ec40\";\n  \n}\n.icon-Phone .path2:before {\n  content: \"\\ec41\";\n  margin-left: -1em;\n  \n  opacity: 0.3;\n}\n.icon-Phone .path3:before {\n  content: \"\\ec42\";\n  margin-left: -1em;\n  \n}\n.icon-Printer .path1:before {\n  content: \"\\ec43\";\n  \n}\n.icon-Printer .path2:before {\n  content: \"\\ec44\";\n  margin-left: -1em;\n  \n  opacity: 0.3;\n}\n.icon-Radio .path1:before {\n  content: \"\\ec45\";\n  \n  opacity: 0.3;\n}\n.icon-Radio .path2:before {\n  content: \"\\ec46\";\n  margin-left: -1em;\n  \n}\n.icon-Radio .path3:before {\n  content: \"\\ec47\";\n  margin-left: -1em;\n  \n}\n.icon-Radio .path4:before {\n  content: \"\\ec48\";\n  margin-left: -1em;\n  \n  opacity: 0.3;\n}\n.icon-Radio .path5:before {\n  content: \"\\ec49\";\n  margin-left: -1em;\n  \n  opacity: 0.3;\n}\n.icon-Router .path1:before {\n  content: \"\\ec4a\";\n  \n}\n.icon-Router .path2:before {\n  content: \"\\ec4b\";\n  margin-left: -1em;\n  \n  opacity: 0.3;\n}\n.icon-Router1 .path1:before {\n  content: \"\\ec4c\";\n  \n}\n.icon-Router1 .path2:before {\n  content: \"\\ec4d\";\n  margin-left: -1em;\n  \n  opacity: 0.3;\n}\n.icon-SD-card:before {\n  content: \"\\ec4e\";\n}\n.icon-Server .path1:before {\n  content: \"\\ec4f\";\n  \n  opacity: 0.3;\n}\n.icon-Server .path2:before {\n  content: \"\\ec50\";\n  margin-left: -1em;\n  \n}\n.icon-Server .path3:before {\n  content: \"\\ec51\";\n  margin-left: -1em;\n  \n}\n.icon-Speaker .path1:before {\n  content: \"\\ec52\";\n  \n}\n.icon-Speaker .path2:before {\n  content: \"\\ec53\";\n  margin-left: -1em;\n  \n  opacity: 0.3;\n}\n.icon-Tablet .path1:before {\n  content: \"\\ec54\";\n  \n}\n.icon-Tablet .path2:before {\n  content: \"\\ec55\";\n  margin-left: -1em;\n  \n  opacity: 0.3;\n}\n.icon-TV .path1:before {\n  content: \"\\ec56\";\n  \n}\n.icon-TV .path2:before {\n  content: \"\\ec57\";\n  margin-left: -1em;\n  \n  opacity: 0.3;\n}\n.icon-TV .path3:before {\n  content: \"\\ec58\";\n  margin-left: -1em;\n  \n  opacity: 0.3;\n}\n.icon-TV1 .path1:before {\n  content: \"\\ec59\";\n  \n}\n.icon-TV1 .path2:before {\n  content: \"\\ec5a\";\n  margin-left: -1em;\n  \n  opacity: 0.3;\n}\n.icon-USB .path1:before {\n  content: \"\\ec5b\";\n  \n}\n.icon-USB .path2:before {\n  content: \"\\ec5c\";\n  margin-left: -1em;\n  \n  opacity: 0.3;\n}\n.icon-USB .path3:before {\n  content: \"\\ec5d\";\n  margin-left: -1em;\n  \n  opacity: 0.3;\n}\n.icon-Usb-storage .path1:before {\n  content: \"\\ec5e\";\n  \n}\n.icon-Usb-storage .path2:before {\n  content: \"\\ec5f\";\n  margin-left: -1em;\n  \n  opacity: 0.3;\n}\n.icon-Video-camera .path1:before {\n  content: \"\\ec60\";\n  \n}\n.icon-Video-camera .path2:before {\n  content: \"\\ec61\";\n  margin-left: -1em;\n  \n  opacity: 0.3;\n}\n.icon-Watch .path1:before {\n  content: \"\\ec62\";\n  \n}\n.icon-Watch .path2:before {\n  content: \"\\ec63\";\n  margin-left: -1em;\n  \n  opacity: 0.3;\n}\n.icon-Watch .path3:before {\n  content: \"\\ec64\";\n  margin-left: -1em;\n  \n  opacity: 0.3;\n}\n.icon-Watch .path4:before {\n  content: \"\\ec65\";\n  margin-left: -1em;\n  \n  opacity: 0.3;\n}\n.icon-Watch1 .path1:before {\n  content: \"\\ec66\";\n  \n  opacity: 0.3;\n}\n.icon-Watch1 .path2:before {\n  content: \"\\ec67\";\n  margin-left: -1em;\n  \n  opacity: 0.3;\n}\n.icon-Watch1 .path3:before {\n  content: \"\\ec68\";\n  margin-left: -1em;\n  \n  opacity: 0.3;\n}\n.icon-Watch1 .path4:before {\n  content: \"\\ec69\";\n  margin-left: -1em;\n  \n}\n.icon-Wi-fi .path1:before {\n  content: \"\\ec6a\";\n  \n  opacity: 0.3;\n}\n.icon-Wi-fi .path2:before {\n  content: \"\\ec6b\";\n  margin-left: -1em;\n  \n}\n.icon-Adjust:before {\n  content: \"\\ec6c\";\n}\n.icon-Anchor-center .path1:before {\n  content: \"\\ec6d\";\n  \n}\n.icon-Anchor-center .path2:before {\n  content: \"\\ec6e\";\n  margin-left: -1em;\n  \n  opacity: 0.3;\n}\n.icon-Anchor-center-down .path1:before {\n  content: \"\\ec6f\";\n  \n  opacity: 0.3;\n}\n.icon-Anchor-center-down .path2:before {\n  content: \"\\ec70\";\n  margin-left: -1em;\n  \n}\n.icon-Anchor-center-up .path1:before {\n  content: \"\\ec71\";\n  \n  opacity: 0.3;\n}\n.icon-Anchor-center-up .path2:before {\n  content: \"\\ec72\";\n  margin-left: -1em;\n  \n}\n.icon-Anchor-left .path1:before {\n  content: \"\\ec73\";\n  \n  opacity: 0.3;\n}\n.icon-Anchor-left .path2:before {\n  content: \"\\ec74\";\n  margin-left: -1em;\n  \n}\n.icon-Anchor-left-down .path1:before {\n  content: \"\\ec75\";\n  \n  opacity: 0.3;\n}\n.icon-Anchor-left-down .path2:before {\n  content: \"\\ec76\";\n  margin-left: -1em;\n  \n}\n.icon-Anchor-left-up .path1:before {\n  content: \"\\ec77\";\n  \n  opacity: 0.3;\n}\n.icon-Anchor-left-up .path2:before {\n  content: \"\\ec78\";\n  margin-left: -1em;\n  \n}\n.icon-Anchor-right .path1:before {\n  content: \"\\ec79\";\n  \n  opacity: 0.3;\n}\n.icon-Anchor-right .path2:before {\n  content: \"\\ec7a\";\n  margin-left: -1em;\n  \n}\n.icon-Anchor-right-down .path1:before {\n  content: \"\\ec7b\";\n  \n  opacity: 0.3;\n}\n.icon-Anchor-right-down .path2:before {\n  content: \"\\ec7c\";\n  margin-left: -1em;\n  \n}\n.icon-Anchor-right-up .path1:before {\n  content: \"\\ec7d\";\n  \n  opacity: 0.3;\n}\n.icon-Anchor-right-up .path2:before {\n  content: \"\\ec7e\";\n  margin-left: -1em;\n  \n}\n.icon-Arrows .path1:before {\n  content: \"\\ec7f\";\n  \n  opacity: 0.3;\n}\n.icon-Arrows .path2:before {\n  content: \"\\ec80\";\n  margin-left: -1em;\n  \n}\n.icon-Bezier-curve .path1:before {\n  content: \"\\ec81\";\n  \n  opacity: 0.3;\n}\n.icon-Bezier-curve .path2:before {\n  content: \"\\ec82\";\n  margin-left: -1em;\n  \n}\n.icon-Border:before {\n  content: \"\\ec83\";\n}\n.icon-Brush1 .path1:before {\n  content: \"\\ec84\";\n  \n}\n.icon-Brush1 .path2:before {\n  content: \"\\ec85\";\n  margin-left: -1em;\n  \n  opacity: 0.3;\n}\n.icon-Bucket .path1:before {\n  content: \"\\ec86\";\n  \n}\n.icon-Bucket .path2:before {\n  content: \"\\ec87\";\n  margin-left: -1em;\n  \n  opacity: 0.3;\n}\n.icon-Cap-1 .path1:before {\n  content: \"\\ec88\";\n  \n}\n.icon-Cap-1 .path2:before {\n  content: \"\\ec89\";\n  margin-left: -1em;\n  \n  opacity: 0.3;\n}\n.icon-Cap-2 .path1:before {\n  content: \"\\ec8a\";\n  \n  opacity: 0.3;\n}\n.icon-Cap-2 .path2:before {\n  content: \"\\ec8b\";\n  margin-left: -1em;\n  \n}\n.icon-Cap-3 .path1:before {\n  content: \"\\ec8c\";\n  \n}\n.icon-Cap-3 .path2:before {\n  content: \"\\ec8d\";\n  margin-left: -1em;\n  \n  opacity: 0.3;\n}\n.icon-Circle:before {\n  content: \"\\ec8e\";\n}\n.icon-Color:before {\n  content: \"\\ec8f\";\n}\n.icon-Color-profile .path1:before {\n  content: \"\\ec90\";\n  \n  opacity: 0.3;\n}\n.icon-Color-profile .path2:before {\n  content: \"\\ec91\";\n  margin-left: -1em;\n  \n}\n.icon-Component:before {\n  content: \"\\ec92\";\n}\n.icon-Crop .path1:before {\n  content: \"\\ec93\";\n  \n  opacity: 0.3;\n}\n.icon-Crop .path2:before {\n  content: \"\\ec94\";\n  margin-left: -1em;\n  \n}\n.icon-Difference .path1:before {\n  content: \"\\ec95\";\n  \n}\n.icon-Difference .path2:before {\n  content: \"\\ec96\";\n  margin-left: -1em;\n  \n  opacity: 0.3;\n}\n.icon-Edit .path1:before {\n  content: \"\\ec97\";\n  \n}\n.icon-Edit .path2:before {\n  content: \"\\ec98\";\n  margin-left: -1em;\n  \n  opacity: 0.3;\n}\n.icon-Eraser:before {\n  content: \"\\ec99\";\n}\n.icon-Flatten .path1:before {\n  content: \"\\ec9a\";\n  \n}\n.icon-Flatten .path2:before {\n  content: \"\\ec9b\";\n  margin-left: -1em;\n  \n  opacity: 0.3;\n}\n.icon-Flip-horizontal .path1:before {\n  content: \"\\ec9c\";\n  \n  opacity: 0.3;\n}\n.icon-Flip-horizontal .path2:before {\n  content: \"\\ec9d\";\n  margin-left: -1em;\n  \n}\n.icon-Flip-horizontal .path3:before {\n  content: \"\\ec9e\";\n  margin-left: -1em;\n  \n  opacity: 0.3;\n}\n.icon-Flip-vertical .path1:before {\n  content: \"\\ec9f\";\n  \n  opacity: 0.3;\n}\n.icon-Flip-vertical .path2:before {\n  content: \"\\eca0\";\n  margin-left: -1em;\n  \n}\n.icon-Flip-vertical .path3:before {\n  content: \"\\eca1\";\n  margin-left: -1em;\n  \n  opacity: 0.3;\n}\n.icon-Horizontal .path1:before {\n  content: \"\\eca2\";\n  \n}\n.icon-Horizontal .path2:before {\n  content: \"\\eca3\";\n  margin-left: -1em;\n  \n  opacity: 0.3;\n}\n.icon-Image:before {\n  content: \"\\eca4\";\n}\n.icon-Interselect .path1:before {\n  content: \"\\eca5\";\n  \n  opacity: 0.3;\n}\n.icon-Interselect .path2:before {\n  content: \"\\eca6\";\n  margin-left: -1em;\n  \n}\n.icon-Join-1 .path1:before {\n  content: \"\\eca7\";\n  \n}\n.icon-Join-1 .path2:before {\n  content: \"\\eca8\";\n  margin-left: -1em;\n  \n  opacity: 0.3;\n}\n.icon-Join-2 .path1:before {\n  content: \"\\eca9\";\n  \n}\n.icon-Join-2 .path2:before {\n  content: \"\\ecaa\";\n  margin-left: -1em;\n  \n  opacity: 0.3;\n}\n.icon-Join-3 .path1:before {\n  content: \"\\ecab\";\n  \n  opacity: 0.3;\n}\n.icon-Join-3 .path2:before {\n  content: \"\\ecac\";\n  margin-left: -1em;\n  \n}\n.icon-Layers .path1:before {\n  content: \"\\ecad\";\n  \n}\n.icon-Layers .path2:before {\n  content: \"\\ecae\";\n  margin-left: -1em;\n  \n  opacity: 0.3;\n}\n.icon-Line .path1:before {\n  content: \"\\ecaf\";\n  \n  opacity: 0.3;\n}\n.icon-Line .path2:before {\n  content: \"\\ecb0\";\n  margin-left: -1em;\n  \n}\n.icon-Line .path3:before {\n  content: \"\\ecb1\";\n  margin-left: -1em;\n  \n}\n.icon-Magic .path1:before {\n  content: \"\\ecb2\";\n  \n}\n.icon-Magic .path2:before {\n  content: \"\\ecb3\";\n  margin-left: -1em;\n  \n  opacity: 0.3;\n}\n.icon-Mask .path1:before {\n  content: \"\\ecb4\";\n  \n  opacity: 0.3;\n}\n.icon-Mask .path2:before {\n  content: \"\\ecb5\";\n  margin-left: -1em;\n  \n}\n.icon-Patch .path1:before {\n  content: \"\\ecb6\";\n  \n}\n.icon-Patch .path2:before {\n  content: \"\\ecb7\";\n  margin-left: -1em;\n  \n  opacity: 0.3;\n}\n.icon-Patch .path3:before {\n  content: \"\\ecb8\";\n  margin-left: -1em;\n  \n  opacity: 0.3;\n}\n.icon-Penruller .path1:before {\n  content: \"\\ecb9\";\n  \n  opacity: 0.3;\n}\n.icon-Penruller .path2:before {\n  content: \"\\ecba\";\n  margin-left: -1em;\n  \n}\n.icon-Pencil:before {\n  content: \"\\ecbb\";\n}\n.icon-Pen-tool-vector .path1:before {\n  content: \"\\ecbc\";\n  \n}\n.icon-Pen-tool-vector .path2:before {\n  content: \"\\ecbd\";\n  margin-left: -1em;\n  \n  opacity: 0.3;\n}\n.icon-Picker .path1:before {\n  content: \"\\ecbe\";\n  \n}\n.icon-Picker .path2:before {\n  content: \"\\ecbf\";\n  margin-left: -1em;\n  \n  opacity: 0.3;\n}\n.icon-Pixels .path1:before {\n  content: \"\\ecc0\";\n  \n}\n.icon-Pixels .path2:before {\n  content: \"\\ecc1\";\n  margin-left: -1em;\n  \n}\n.icon-Pixels .path3:before {\n  content: \"\\ecc2\";\n  margin-left: -1em;\n  \n}\n.icon-Pixels .path4:before {\n  content: \"\\ecc3\";\n  margin-left: -1em;\n  \n  opacity: 0.3;\n}\n.icon-Pixels .path5:before {\n  content: \"\\ecc4\";\n  margin-left: -1em;\n  \n}\n.icon-Pixels .path6:before {\n  content: \"\\ecc5\";\n  margin-left: -1em;\n  \n}\n.icon-Polygon:before {\n  content: \"\\ecc6\";\n}\n.icon-Position:before {\n  content: \"\\ecc7\";\n}\n.icon-Rectangle:before {\n  content: \"\\ecc8\";\n}\n.icon-Saturation:before {\n  content: \"\\ecc9\";\n}\n.icon-Select .path1:before {\n  content: \"\\ecca\";\n  \n  opacity: 0.3;\n}\n.icon-Select .path2:before {\n  content: \"\\eccb\";\n  margin-left: -1em;\n  \n}\n.icon-Sketch .path1:before {\n  content: \"\\eccc\";\n  \n  opacity: 0.3;\n}\n.icon-Sketch .path2:before {\n  content: \"\\eccd\";\n  margin-left: -1em;\n  \n}\n.icon-Stamp .path1:before {\n  content: \"\\ecce\";\n  \n}\n.icon-Stamp .path2:before {\n  content: \"\\eccf\";\n  margin-left: -1em;\n  \n  opacity: 0.3;\n}\n.icon-Substract .path1:before {\n  content: \"\\ecd0\";\n  \n}\n.icon-Substract .path2:before {\n  content: \"\\ecd1\";\n  margin-left: -1em;\n  \n  opacity: 0.3;\n}\n.icon-Target .path1:before {\n  content: \"\\ecd2\";\n  \n  opacity: 0.3;\n}\n.icon-Target .path2:before {\n  content: \"\\ecd3\";\n  margin-left: -1em;\n  \n}\n.icon-Triangle:before {\n  content: \"\\ecd4\";\n}\n.icon-Union:before {\n  content: \"\\ecd5\";\n}\n.icon-Vertical .path1:before {\n  content: \"\\ecd6\";\n  \n}\n.icon-Vertical .path2:before {\n  content: \"\\ecd7\";\n  margin-left: -1em;\n  \n  opacity: 0.3;\n}\n.icon-Zoom-minus .path1:before {\n  content: \"\\ecd8\";\n  \n  opacity: 0.3;\n}\n.icon-Zoom-minus .path2:before {\n  content: \"\\ecd9\";\n  margin-left: -1em;\n  \n}\n.icon-Zoom-minus .path3:before {\n  content: \"\\ecda\";\n  margin-left: -1em;\n  \n  opacity: 0.3;\n}\n.icon-Zoom-plus .path1:before {\n  content: \"\\ecdb\";\n  \n  opacity: 0.3;\n}\n.icon-Zoom-plus .path2:before {\n  content: \"\\ecdc\";\n  margin-left: -1em;\n  \n}\n.icon-Zoom-plus .path3:before {\n  content: \"\\ecdd\";\n  margin-left: -1em;\n  \n  opacity: 0.3;\n}\n.icon-Baking-glove .path1:before {\n  content: \"\\ecde\";\n  \n}\n.icon-Baking-glove .path2:before {\n  content: \"\\ecdf\";\n  margin-left: -1em;\n  \n  opacity: 0.3;\n}\n.icon-Bowl .path1:before {\n  content: \"\\ece0\";\n  \n  opacity: 0.3;\n}\n.icon-Bowl .path2:before {\n  content: \"\\ece1\";\n  margin-left: -1em;\n  \n}\n.icon-Chef .path1:before {\n  content: \"\\ece2\";\n  \n  opacity: 0.3;\n}\n.icon-Chef .path2:before {\n  content: \"\\ece3\";\n  margin-left: -1em;\n  \n}\n.icon-Cooking-book .path1:before {\n  content: \"\\ece4\";\n  \n  opacity: 0.0900;\n}\n.icon-Cooking-book .path2:before {\n  content: \"\\ece5\";\n  margin-left: -1em;\n  \n  opacity: 0.3;\n}\n.icon-Cooking-pot .path1:before {\n  content: \"\\ece6\";\n  \n  opacity: 0.3;\n}\n.icon-Cooking-pot .path2:before {\n  content: \"\\ece7\";\n  margin-left: -1em;\n  \n}\n.icon-Cutting-board .path1:before {\n  content: \"\\ece8\";\n  \n  opacity: 0.3;\n}\n.icon-Cutting-board .path2:before {\n  content: \"\\ece9\";\n  margin-left: -1em;\n  \n}\n.icon-Dinner .path1:before {\n  content: \"\\ecea\";\n  \n  opacity: 0.3;\n}\n.icon-Dinner .path2:before {\n  content: \"\\eceb\";\n  margin-left: -1em;\n  \n  opacity: 0.3;\n}\n.icon-Dinner .path3:before {\n  content: \"\\ecec\";\n  margin-left: -1em;\n  \n}\n.icon-Dinner .path4:before {\n  content: \"\\eced\";\n  margin-left: -1em;\n  \n}\n.icon-Dinner .path5:before {\n  content: \"\\ecee\";\n  margin-left: -1em;\n  \n  opacity: 0.3;\n}\n.icon-Dish .path1:before {\n  content: \"\\ecef\";\n  \n}\n.icon-Dish .path2:before {\n  content: \"\\ecf0\";\n  margin-left: -1em;\n  \n  opacity: 0.3;\n}\n.icon-Dishes .path1:before {\n  content: \"\\ecf1\";\n  \n}\n.icon-Dishes .path2:before {\n  content: \"\\ecf2\";\n  margin-left: -1em;\n  \n  opacity: 0.3;\n}\n.icon-Fork .path1:before {\n  content: \"\\ecf3\";\n  \n  opacity: 0.3;\n}\n.icon-Fork .path2:before {\n  content: \"\\ecf4\";\n  margin-left: -1em;\n  \n}\n.icon-Fork-spoon .path1:before {\n  content: \"\\ecf5\";\n  \n}\n.icon-Fork-spoon .path2:before {\n  content: \"\\ecf6\";\n  margin-left: -1em;\n  \n  opacity: 0.3;\n}\n.icon-Fork-spoon .path3:before {\n  content: \"\\ecf7\";\n  margin-left: -1em;\n  \n  opacity: 0.3;\n}\n.icon-Fork-spoon .path4:before {\n  content: \"\\ecf8\";\n  margin-left: -1em;\n  \n}\n.icon-Fork-spoon-knife .path1:before {\n  content: \"\\ecf9\";\n  \n}\n.icon-Fork-spoon-knife .path2:before {\n  content: \"\\ecfa\";\n  margin-left: -1em;\n  \n  opacity: 0.3;\n}\n.icon-Fork-spoon-knife .path3:before {\n  content: \"\\ecfb\";\n  margin-left: -1em;\n  \n  opacity: 0.3;\n}\n.icon-Fork-spoon-knife .path4:before {\n  content: \"\\ecfc\";\n  margin-left: -1em;\n  \n}\n.icon-Fork-spoon-knife .path5:before {\n  content: \"\\ecfd\";\n  margin-left: -1em;\n  \n  opacity: 0.3;\n}\n.icon-Fork-spoon-knife .path6:before {\n  content: \"\\ecfe\";\n  margin-left: -1em;\n  \n}\n.icon-Frying-pan .path1:before {\n  content: \"\\ecff\";\n  \n  opacity: 0.3;\n}\n.icon-Frying-pan .path2:before {\n  content: \"\\ed00\";\n  margin-left: -1em;\n  \n}\n.icon-Grater .path1:before {\n  content: \"\\ed01\";\n  \n  opacity: 0.3;\n}\n.icon-Grater .path2:before {\n  content: \"\\ed02\";\n  margin-left: -1em;\n  \n}\n.icon-Kitchen-scale .path1:before {\n  content: \"\\ed03\";\n  \n}\n.icon-Kitchen-scale .path2:before {\n  content: \"\\ed04\";\n  margin-left: -1em;\n  \n  opacity: 0.3;\n}\n.icon-Knife .path1:before {\n  content: \"\\ed05\";\n  \n  opacity: 0.3;\n}\n.icon-Knife .path2:before {\n  content: \"\\ed06\";\n  margin-left: -1em;\n  \n}\n.icon-Knife1 .path1:before {\n  content: \"\\ed07\";\n  \n  opacity: 0.3;\n}\n.icon-Knife1 .path2:before {\n  content: \"\\ed08\";\n  margin-left: -1em;\n  \n}\n.icon-Knifefork .path1:before {\n  content: \"\\ed09\";\n  \n}\n.icon-Knifefork .path2:before {\n  content: \"\\ed0a\";\n  margin-left: -1em;\n  \n  opacity: 0.3;\n}\n.icon-Knifefork .path3:before {\n  content: \"\\ed0b\";\n  margin-left: -1em;\n  \n  opacity: 0.3;\n}\n.icon-Knifefork .path4:before {\n  content: \"\\ed0c\";\n  margin-left: -1em;\n  \n}\n.icon-Knifefork1 .path1:before {\n  content: \"\\ed0d\";\n  \n}\n.icon-Knifefork1 .path2:before {\n  content: \"\\ed0e\";\n  margin-left: -1em;\n  \n}\n.icon-Knifefork1 .path3:before {\n  content: \"\\ed0f\";\n  margin-left: -1em;\n  \n  opacity: 0.3;\n}\n.icon-Knifefork1 .path4:before {\n  content: \"\\ed10\";\n  margin-left: -1em;\n  \n  opacity: 0.3;\n}\n.icon-Ladle .path1:before {\n  content: \"\\ed11\";\n  \n  opacity: 0.3;\n}\n.icon-Ladle .path2:before {\n  content: \"\\ed12\";\n  margin-left: -1em;\n  \n}\n.icon-Rolling-pin .path1:before {\n  content: \"\\ed13\";\n  \n}\n.icon-Rolling-pin .path2:before {\n  content: \"\\ed14\";\n  margin-left: -1em;\n  \n  opacity: 0.3;\n}\n.icon-Saucepan .path1:before {\n  content: \"\\ed15\";\n  \n}\n.icon-Saucepan .path2:before {\n  content: \"\\ed16\";\n  margin-left: -1em;\n  \n  opacity: 0.3;\n}\n.icon-Shovel .path1:before {\n  content: \"\\ed17\";\n  \n  opacity: 0.3;\n}\n.icon-Shovel .path2:before {\n  content: \"\\ed18\";\n  margin-left: -1em;\n  \n}\n.icon-Sieve .path1:before {\n  content: \"\\ed19\";\n  \n  opacity: 0.3;\n}\n.icon-Sieve .path2:before {\n  content: \"\\ed1a\";\n  margin-left: -1em;\n  \n}\n.icon-Spoon .path1:before {\n  content: \"\\ed1b\";\n  \n  opacity: 0.3;\n}\n.icon-Spoon .path2:before {\n  content: \"\\ed1c\";\n  margin-left: -1em;\n  \n}\n.icon-Spoon .path3:before {\n  content: \"\\ed1d\";\n  margin-left: -1em;\n  color: rgb(255, 255, 255);\n}\n.icon-Active-call .path1:before {\n  content: \"\\ed1e\";\n  \n}\n.icon-Active-call .path2:before {\n  content: \"\\ed1f\";\n  margin-left: -1em;\n  \n  opacity: 0.3;\n}\n.icon-Address-card:before {\n  content: \"\\ed20\";\n}\n.icon-Add-user .path1:before {\n  content: \"\\ed21\";\n  \n  opacity: 0.3;\n}\n.icon-Add-user .path2:before {\n  content: \"\\ed22\";\n  margin-left: -1em;\n  \n}\n.icon-Adress-book .path1:before {\n  content: \"\\ed23\";\n  \n  opacity: 0.3;\n}\n.icon-Adress-book .path2:before {\n  content: \"\\ed24\";\n  margin-left: -1em;\n  \n}\n.icon-Adress-book1 .path1:before {\n  content: \"\\ed25\";\n  \n  opacity: 0.3;\n}\n.icon-Adress-book1 .path2:before {\n  content: \"\\ed26\";\n  margin-left: -1em;\n  \n}\n.icon-Archive:before {\n  content: \"\\ed27\";\n}\n.icon-Call1:before {\n  content: \"\\ed28\";\n}\n.icon-118:before {\n  content: \"\\ed28\";\n}\n.icon-Call:before {\n  content: \"\\ed29\";\n}\n.icon-Chat .path1:before {\n  content: \"\\ed2a\";\n  \n  opacity: 0.3;\n}\n.icon-Chat .path2:before {\n  content: \"\\ed2b\";\n  margin-left: -1em;\n  \n}\n.icon-Chat1 .path1:before {\n  content: \"\\ed2c\";\n  \n  opacity: 0.3;\n}\n.icon-Chat1 .path2:before {\n  content: \"\\ed2d\";\n  margin-left: -1em;\n  \n}\n.icon-Chat2:before {\n  content: \"\\ed2e\";\n}\n.icon-41:before {\n  content: \"\\ed2e\";\n}\n.icon-Chat3:before {\n  content: \"\\ed2f\";\n}\n.icon-51:before {\n  content: \"\\ed2f\";\n}\n.icon-Chat4:before {\n  content: \"\\ed30\";\n}\n.icon-6:before {\n  content: \"\\ed30\";\n}\n.icon-Chat-check .path1:before {\n  content: \"\\ed31\";\n  \n  opacity: 0.3;\n}\n.icon-Chat-check .path2:before {\n  content: \"\\ed32\";\n  margin-left: -1em;\n  \n}\n.icon-Chat-error .path1:before {\n  content: \"\\ed33\";\n  \n}\n.icon-Chat-error .path2:before {\n  content: \"\\ed34\";\n  margin-left: -1em;\n  \n  opacity: 0.3;\n}\n.icon-Chat-locked .path1:before {\n  content: \"\\ed35\";\n  \n  opacity: 0.3;\n}\n.icon-Chat-locked .path2:before {\n  content: \"\\ed36\";\n  margin-left: -1em;\n  \n}\n.icon-Chat-smile .path1:before {\n  content: \"\\ed37\";\n  \n  opacity: 0.3;\n}\n.icon-Chat-smile .path2:before {\n  content: \"\\ed38\";\n  margin-left: -1em;\n  \n}\n.icon-Clipboard-check .path1:before {\n  content: \"\\ed39\";\n  \n  opacity: 0.3;\n}\n.icon-Clipboard-check .path2:before {\n  content: \"\\ed3a\";\n  margin-left: -1em;\n  \n}\n.icon-Clipboard-check .path3:before {\n  content: \"\\ed3b\";\n  margin-left: -1em;\n  \n}\n.icon-Clipboard-list .path1:before {\n  content: \"\\ed3c\";\n  \n  opacity: 0.3;\n}\n.icon-Clipboard-list .path2:before {\n  content: \"\\ed3d\";\n  margin-left: -1em;\n  \n}\n.icon-Clipboard-list .path3:before {\n  content: \"\\ed3e\";\n  margin-left: -1em;\n  \n  opacity: 0.3;\n}\n.icon-Clipboard-list .path4:before {\n  content: \"\\ed3f\";\n  margin-left: -1em;\n  \n  opacity: 0.3;\n}\n.icon-Clipboard-list .path5:before {\n  content: \"\\ed40\";\n  margin-left: -1em;\n  \n  opacity: 0.3;\n}\n.icon-Clipboard-list .path6:before {\n  content: \"\\ed41\";\n  margin-left: -1em;\n  \n  opacity: 0.3;\n}\n.icon-Clipboard-list .path7:before {\n  content: \"\\ed42\";\n  margin-left: -1em;\n  \n  opacity: 0.3;\n}\n.icon-Clipboard-list .path8:before {\n  content: \"\\ed43\";\n  margin-left: -1em;\n  \n  opacity: 0.3;\n}\n.icon-Contact:before {\n  content: \"\\ed44\";\n}\n.icon-110:before {\n  content: \"\\ed44\";\n}\n.icon-Delete-user .path1:before {\n  content: \"\\ed45\";\n  \n  opacity: 0.3;\n}\n.icon-Delete-user .path2:before {\n  content: \"\\ed46\";\n  margin-left: -1em;\n  \n}\n.icon-Dial-numbers .path1:before {\n  content: \"\\ed47\";\n  \n  opacity: 0.3;\n}\n.icon-Dial-numbers .path2:before {\n  content: \"\\ed48\";\n  margin-left: -1em;\n  \n}\n.icon-Dial-numbers .path3:before {\n  content: \"\\ed49\";\n  margin-left: -1em;\n  \n}\n.icon-Dial-numbers .path4:before {\n  content: \"\\ed4a\";\n  margin-left: -1em;\n  \n}\n.icon-Dial-numbers .path5:before {\n  content: \"\\ed4b\";\n  margin-left: -1em;\n  \n}\n.icon-Dial-numbers .path6:before {\n  content: \"\\ed4c\";\n  margin-left: -1em;\n  \n}\n.icon-Dial-numbers .path7:before {\n  content: \"\\ed4d\";\n  margin-left: -1em;\n  \n}\n.icon-Dial-numbers .path8:before {\n  content: \"\\ed4e\";\n  margin-left: -1em;\n  \n}\n.icon-Dial-numbers .path9:before {\n  content: \"\\ed4f\";\n  margin-left: -1em;\n  \n}\n.icon-Flag .path1:before {\n  content: \"\\ed50\";\n  \n}\n.icon-Flag .path2:before {\n  content: \"\\ed51\";\n  margin-left: -1em;\n  \n  opacity: 0.3;\n}\n.icon-Forward1:before {\n  content: \"\\ed52\";\n}\n.icon-Group .path1:before {\n  content: \"\\ed53\";\n  \n  opacity: 0.3;\n}\n.icon-Group .path2:before {\n  content: \"\\ed54\";\n  margin-left: -1em;\n  \n}\n.icon-Group-chat .path1:before {\n  content: \"\\ed55\";\n  \n}\n.icon-Group-chat .path2:before {\n  content: \"\\ed56\";\n  margin-left: -1em;\n  \n  opacity: 0.3;\n}\n.icon-Incoming-box .path1:before {\n  content: \"\\ed57\";\n  \n}\n.icon-Incoming-box .path2:before {\n  content: \"\\ed58\";\n  margin-left: -1em;\n  \n  opacity: 0.3;\n}\n.icon-Incoming-box .path3:before {\n  content: \"\\ed59\";\n  margin-left: -1em;\n  \n}\n.icon-Incoming-call .path1:before {\n  content: \"\\ed5a\";\n  \n  opacity: 0.3;\n}\n.icon-Incoming-call .path2:before {\n  content: \"\\ed5b\";\n  margin-left: -1em;\n  \n}\n.icon-Incoming-mail .path1:before {\n  content: \"\\ed5c\";\n  \n}\n.icon-Incoming-mail .path2:before {\n  content: \"\\ed5d\";\n  margin-left: -1em;\n  \n  opacity: 0.3;\n}\n.icon-Mail:before {\n  content: \"\\ed5e\";\n}\n.icon-Mail-:before {\n  content: \"\\ed5f\";\n}\n.icon-Mail-attachment .path1:before {\n  content: \"\\ed60\";\n  \n  opacity: 0.3;\n}\n.icon-Mail-attachment .path2:before {\n  content: \"\\ed61\";\n  margin-left: -1em;\n  \n}\n.icon-Mail-box .path1:before {\n  content: \"\\ed62\";\n  \n}\n.icon-Mail-box .path2:before {\n  content: \"\\ed63\";\n  margin-left: -1em;\n  \n  opacity: 0.3;\n}\n.icon-Mail-error .path1:before {\n  content: \"\\ed64\";\n  \n}\n.icon-Mail-error .path2:before {\n  content: \"\\ed65\";\n  margin-left: -1em;\n  \n  opacity: 0.3;\n}\n.icon-Mail-heart .path1:before {\n  content: \"\\ed66\";\n  \n  opacity: 0.3;\n}\n.icon-Mail-heart .path2:before {\n  content: \"\\ed67\";\n  margin-left: -1em;\n  \n}\n.icon-Mail-locked .path1:before {\n  content: \"\\ed68\";\n  \n}\n.icon-Mail-locked .path2:before {\n  content: \"\\ed69\";\n  margin-left: -1em;\n  \n  opacity: 0.3;\n}\n.icon-Mail-notification .path1:before {\n  content: \"\\ed6a\";\n  \n}\n.icon-Mail-notification .path2:before {\n  content: \"\\ed6b\";\n  margin-left: -1em;\n  \n  opacity: 0.3;\n}\n.icon-Mail-opened .path1:before {\n  content: \"\\ed6c\";\n  \n  opacity: 0.3;\n}\n.icon-Mail-opened .path2:before {\n  content: \"\\ed6d\";\n  margin-left: -1em;\n  \n}\n.icon-Mail-unocked .path1:before {\n  content: \"\\ed6e\";\n  \n  opacity: 0.3;\n}\n.icon-Mail-unocked .path2:before {\n  content: \"\\ed6f\";\n  margin-left: -1em;\n  \n}\n.icon-Missed-call .path1:before {\n  content: \"\\ed70\";\n  \n  opacity: 0.3;\n}\n.icon-Missed-call .path2:before {\n  content: \"\\ed71\";\n  margin-left: -1em;\n  \n}\n.icon-Outgoing-box .path1:before {\n  content: \"\\ed72\";\n  \n}\n.icon-Outgoing-box .path2:before {\n  content: \"\\ed73\";\n  margin-left: -1em;\n  \n  opacity: 0.3;\n}\n.icon-Outgoing-box .path3:before {\n  content: \"\\ed74\";\n  margin-left: -1em;\n  \n}\n.icon-Outgoing-call .path1:before {\n  content: \"\\ed75\";\n  \n  opacity: 0.3;\n}\n.icon-Outgoing-call .path2:before {\n  content: \"\\ed76\";\n  margin-left: -1em;\n  \n}\n.icon-Outgoing-mail .path1:before {\n  content: \"\\ed77\";\n  \n}\n.icon-Outgoing-mail .path2:before {\n  content: \"\\ed78\";\n  margin-left: -1em;\n  \n  opacity: 0.3;\n}\n.icon-Readed-mail .path1:before {\n  content: \"\\ed79\";\n  \n  opacity: 0.3;\n}\n.icon-Readed-mail .path2:before {\n  content: \"\\ed7a\";\n  margin-left: -1em;\n  \n}\n.icon-Reply:before {\n  content: \"\\ed7b\";\n}\n.icon-Reply-all .path1:before {\n  content: \"\\ed7c\";\n  \n  opacity: 0.3;\n}\n.icon-Reply-all .path2:before {\n  content: \"\\ed7d\";\n  margin-left: -1em;\n  \n}\n.icon-Right:before {\n  content: \"\\ed7e\";\n}\n.icon-RSS .path1:before {\n  content: \"\\ed7f\";\n  \n}\n.icon-RSS .path2:before {\n  content: \"\\ed80\";\n  margin-left: -1em;\n  \n  opacity: 0.3;\n}\n.icon-RSS .path3:before {\n  content: \"\\ed81\";\n  margin-left: -1em;\n  \n  opacity: 0.3;\n}\n.icon-Safe-chat .path1:before {\n  content: \"\\ed82\";\n  \n  opacity: 0.3;\n}\n.icon-Safe-chat .path2:before {\n  content: \"\\ed83\";\n  margin-left: -1em;\n  \n}\n.icon-Send:before {\n  content: \"\\ed84\";\n}\n.icon-Sending-mail .path1:before {\n  content: \"\\ed85\";\n  \n  opacity: 0.3;\n}\n.icon-Sending-mail .path2:before {\n  content: \"\\ed86\";\n  margin-left: -1em;\n  \n}\n.icon-Sending .path1:before {\n  content: \"\\ed87\";\n  \n}\n.icon-Sending .path2:before {\n  content: \"\\ed88\";\n  margin-left: -1em;\n  \n  opacity: 0.3;\n}\n.icon-Share .path1:before {\n  content: \"\\ed89\";\n  \n  opacity: 0.3;\n}\n.icon-Share .path2:before {\n  content: \"\\ed8a\";\n  margin-left: -1em;\n  \n}\n.icon-Shield-thunder:before {\n  content: \"\\ed8b\";\n}\n.icon-Shield-user:before {\n  content: \"\\ed8c\";\n}\n.icon-Snoozed-mail .path1:before {\n  content: \"\\ed8d\";\n  \n}\n.icon-Snoozed-mail .path2:before {\n  content: \"\\ed8e\";\n  margin-left: -1em;\n  \n  opacity: 0.3;\n}\n.icon-Spam:before {\n  content: \"\\ed8f\";\n}\n.icon-Thumbtack .path1:before {\n  content: \"\\ed90\";\n  \n}\n.icon-Thumbtack .path2:before {\n  content: \"\\ed91\";\n  margin-left: -1em;\n  \n  opacity: 0.3;\n}\n.icon-Urgent-mail .path1:before {\n  content: \"\\ed92\";\n  \n  opacity: 0.3;\n}\n.icon-Urgent-mail .path2:before {\n  content: \"\\ed93\";\n  margin-left: -1em;\n  \n}\n.icon-Write .path1:before {\n  content: \"\\ed94\";\n  \n}\n.icon-Write .path2:before {\n  content: \"\\ed95\";\n  margin-left: -1em;\n  \n  opacity: 0.3;\n}\n.icon-Backspace .path1:before {\n  content: \"\\ed96\";\n  \n  opacity: 0.3;\n}\n.icon-Backspace .path2:before {\n  content: \"\\ed97\";\n  margin-left: -1em;\n  \n}\n.icon-CMD:before {\n  content: \"\\ed98\";\n}\n.icon-Code1 .path1:before {\n  content: \"\\ed99\";\n  \n}\n.icon-Code1 .path2:before {\n  content: \"\\ed9a\";\n  margin-left: -1em;\n  \n  opacity: 0.3;\n}\n.icon-Commit .path1:before {\n  content: \"\\ed9b\";\n  \n  opacity: 0.3;\n}\n.icon-Commit .path2:before {\n  content: \"\\ed9c\";\n  margin-left: -1em;\n  \n}\n.icon-Compiling .path1:before {\n  content: \"\\ed9d\";\n  \n  opacity: 0.3;\n}\n.icon-Compiling .path2:before {\n  content: \"\\ed9e\";\n  margin-left: -1em;\n  \n}\n.icon-Control:before {\n  content: \"\\ed9f\";\n}\n.icon-Done-circle .path1:before {\n  content: \"\\eda0\";\n  \n  opacity: 0.3;\n}\n.icon-Done-circle .path2:before {\n  content: \"\\eda1\";\n  margin-left: -1em;\n  \n}\n.icon-Error-circle .path1:before {\n  content: \"\\eda2\";\n  \n  opacity: 0.3;\n}\n.icon-Error-circle .path2:before {\n  content: \"\\eda3\";\n  margin-left: -1em;\n  \n}\n.icon-Git2 .path1:before {\n  content: \"\\eda4\";\n  \n  opacity: 0.3;\n}\n.icon-Git2 .path2:before {\n  content: \"\\eda5\";\n  margin-left: -1em;\n  \n}\n.icon-Git2 .path3:before {\n  content: \"\\eda6\";\n  margin-left: -1em;\n  \n}\n.icon-Git3 .path1:before {\n  content: \"\\eda7\";\n  \n  opacity: 0.3;\n}\n.icon-Git3 .path2:before {\n  content: \"\\eda8\";\n  margin-left: -1em;\n  \n}\n.icon-Git3 .path3:before {\n  content: \"\\eda9\";\n  margin-left: -1em;\n  \n  opacity: 0.3;\n}\n.icon-Git3 .path4:before {\n  content: \"\\edaa\";\n  margin-left: -1em;\n  \n}\n.icon-Git3 .path5:before {\n  content: \"\\edab\";\n  margin-left: -1em;\n  \n}\n.icon-Git3 .path6:before {\n  content: \"\\edac\";\n  margin-left: -1em;\n  \n}\n.icon-Git .path1:before {\n  content: \"\\edad\";\n  \n  opacity: 0.3;\n}\n.icon-Git .path2:before {\n  content: \"\\edae\";\n  margin-left: -1em;\n  \n}\n.icon-Git .path3:before {\n  content: \"\\edaf\";\n  margin-left: -1em;\n  \n}\n.icon-Git .path4:before {\n  content: \"\\edb0\";\n  margin-left: -1em;\n  \n}\n.icon-Git1 .path1:before {\n  content: \"\\edb1\";\n  \n}\n.icon-Git1 .path2:before {\n  content: \"\\edb2\";\n  margin-left: -1em;\n  \n  opacity: 0.3;\n}\n.icon-Git1 .path3:before {\n  content: \"\\edb3\";\n  margin-left: -1em;\n  \n}\n.icon-Git1 .path4:before {\n  content: \"\\edb4\";\n  margin-left: -1em;\n  \n}\n.icon-Github .path1:before {\n  content: \"\\edb5\";\n  \n}\n.icon-Github .path2:before {\n  content: \"\\edb6\";\n  margin-left: -1em;\n  \n  opacity: 0.3;\n}\n.icon-Info-circle .path1:before {\n  content: \"\\edb7\";\n  \n  opacity: 0.3;\n}\n.icon-Info-circle .path2:before {\n  content: \"\\edb8\";\n  margin-left: -1em;\n  \n}\n.icon-Info-circle .path3:before {\n  content: \"\\edb9\";\n  margin-left: -1em;\n  \n}\n.icon-Left-circle .path1:before {\n  content: \"\\edba\";\n  \n  opacity: 0.3;\n}\n.icon-Left-circle .path2:before {\n  content: \"\\edbb\";\n  margin-left: -1em;\n  \n}\n.icon-Loading:before {\n  content: \"\\edbc\";\n}\n.icon-Lock-circle .path1:before {\n  content: \"\\edbd\";\n  \n  opacity: 0.3;\n}\n.icon-Lock-circle .path2:before {\n  content: \"\\edbe\";\n  margin-left: -1em;\n  \n}\n.icon-Lock-overturning .path1:before {\n  content: \"\\edbf\";\n  \n  opacity: 0.3;\n}\n.icon-Lock-overturning .path2:before {\n  content: \"\\edc0\";\n  margin-left: -1em;\n  \n}\n.icon-Minus .path1:before {\n  content: \"\\edc1\";\n  \n  opacity: 0.3;\n}\n.icon-Minus .path2:before {\n  content: \"\\edc2\";\n  margin-left: -1em;\n  \n}\n.icon-Option .path1:before {\n  content: \"\\edc3\";\n  \n  opacity: 0.3;\n}\n.icon-Option .path2:before {\n  content: \"\\edc4\";\n  margin-left: -1em;\n  \n}\n.icon-Plus .path1:before {\n  content: \"\\edc5\";\n  \n  opacity: 0.3;\n}\n.icon-Plus .path2:before {\n  content: \"\\edc6\";\n  margin-left: -1em;\n  \n}\n.icon-Puzzle:before {\n  content: \"\\edc7\";\n}\n.icon-Question-circle .path1:before {\n  content: \"\\edc8\";\n  \n  opacity: 0.3;\n}\n.icon-Question-circle .path2:before {\n  content: \"\\edc9\";\n  margin-left: -1em;\n  \n}\n.icon-Right-circle .path1:before {\n  content: \"\\edca\";\n  \n  opacity: 0.3;\n}\n.icon-Right-circle .path2:before {\n  content: \"\\edcb\";\n  margin-left: -1em;\n  \n}\n.icon-Settings1 .path1:before {\n  content: \"\\edcc\";\n  \n  opacity: 0.3;\n}\n.icon-Settings1 .path2:before {\n  content: \"\\edcd\";\n  margin-left: -1em;\n  \n}\n.icon-Shift:before {\n  content: \"\\edce\";\n}\n.icon-Spy .path1:before {\n  content: \"\\edcf\";\n  \n}\n.icon-Spy .path2:before {\n  content: \"\\edd0\";\n  margin-left: -1em;\n  \n  opacity: 0.3;\n}\n.icon-Stop:before {\n  content: \"\\edd1\";\n}\n.icon-Terminal .path1:before {\n  content: \"\\edd2\";\n  \n}\n.icon-Terminal .path2:before {\n  content: \"\\edd3\";\n  margin-left: -1em;\n  \n  opacity: 0.3;\n}\n.icon-Thunder-circle .path1:before {\n  content: \"\\edd4\";\n  \n  opacity: 0.3;\n}\n.icon-Thunder-circle .path2:before {\n  content: \"\\edd5\";\n  margin-left: -1em;\n  \n}\n.icon-Time-schedule .path1:before {\n  content: \"\\edd6\";\n  \n}\n.icon-Time-schedule .path2:before {\n  content: \"\\edd7\";\n  margin-left: -1em;\n  \n  opacity: 0.3;\n}\n.icon-Warning-1-circle .path1:before {\n  content: \"\\edd8\";\n  \n  opacity: 0.3;\n}\n.icon-Warning-1-circle .path2:before {\n  content: \"\\edd9\";\n  margin-left: -1em;\n  \n}\n.icon-Warning-1-circle .path3:before {\n  content: \"\\edda\";\n  margin-left: -1em;\n  \n}\n.icon-Warning-2 .path1:before {\n  content: \"\\eddb\";\n  \n  opacity: 0.3;\n}\n.icon-Warning-2 .path2:before {\n  content: \"\\eddc\";\n  margin-left: -1em;\n  \n}\n.icon-Warning-2 .path3:before {\n  content: \"\\eddd\";\n  margin-left: -1em;\n  \n}\n.icon-Brassiere:before {\n  content: \"\\edde\";\n}\n.icon-Briefcase .path1:before {\n  content: \"\\eddf\";\n  \n}\n.icon-Briefcase .path2:before {\n  content: \"\\ede0\";\n  margin-left: -1em;\n  \n  opacity: 0.3;\n}\n.icon-Cap .path1:before {\n  content: \"\\ede1\";\n  \n  opacity: 0.3;\n}\n.icon-Cap .path2:before {\n  content: \"\\ede2\";\n  margin-left: -1em;\n  \n}\n.icon-Crown .path1:before {\n  content: \"\\ede3\";\n  \n  opacity: 0.3;\n}\n.icon-Crown .path2:before {\n  content: \"\\ede4\";\n  margin-left: -1em;\n  \n}\n.icon-Dress .path1:before {\n  content: \"\\ede5\";\n  \n  opacity: 0.3;\n}\n.icon-Dress .path2:before {\n  content: \"\\ede6\";\n  margin-left: -1em;\n  \n}\n.icon-Hanger:before {\n  content: \"\\ede7\";\n}\n.icon-Hat .path1:before {\n  content: \"\\ede8\";\n  \n}\n.icon-Hat .path2:before {\n  content: \"\\ede9\";\n  margin-left: -1em;\n  \n  opacity: 0.3;\n}\n.icon-Panties:before {\n  content: \"\\edea\";\n}\n.icon-Shirt .path1:before {\n  content: \"\\edeb\";\n  \n  opacity: 0.3;\n}\n.icon-Shirt .path2:before {\n  content: \"\\edec\";\n  margin-left: -1em;\n  \n}\n.icon-Shoes .path1:before {\n  content: \"\\eded\";\n  \n}\n.icon-Shoes .path2:before {\n  content: \"\\edee\";\n  margin-left: -1em;\n  \n  opacity: 0.3;\n}\n.icon-Shorts:before {\n  content: \"\\edef\";\n}\n.icon-Sneakers .path1:before {\n  content: \"\\edf0\";\n  \n  opacity: 0.3;\n}\n.icon-Sneakers .path2:before {\n  content: \"\\edf1\";\n  margin-left: -1em;\n  \n}\n.icon-Socks .path1:before {\n  content: \"\\edf2\";\n  \n  opacity: 0.3;\n}\n.icon-Socks .path2:before {\n  content: \"\\edf3\";\n  margin-left: -1em;\n  \n}\n.icon-Sun-glasses .path1:before {\n  content: \"\\edf4\";\n  \n  opacity: 0.3;\n}\n.icon-Sun-glasses .path2:before {\n  content: \"\\edf5\";\n  margin-left: -1em;\n  \n}\n.icon-Tie .path1:before {\n  content: \"\\edf6\";\n  \n}\n.icon-Tie .path2:before {\n  content: \"\\edf7\";\n  margin-left: -1em;\n  \n  opacity: 0.3;\n}\n.icon-T-Shirt:before {\n  content: \"\\edf8\";\n}\n.icon-Celcium .path1:before {\n  content: \"\\edf9\";\n  \n}\n.icon-Celcium .path2:before {\n  content: \"\\edfa\";\n  margin-left: -1em;\n  \n  opacity: 0.3;\n}\n.icon-Cloud:before {\n  content: \"\\edfb\";\n}\n.icon-18:before {\n  content: \"\\edfb\";\n}\n.icon-Cloud1 .path1:before {\n  content: \"\\edfc\";\n  \n  opacity: 0.3;\n}\n.icon-Cloud1 .path2:before {\n  content: \"\\edfd\";\n  margin-left: -1em;\n  \n}\n.icon-Cloud-fog .path1:before {\n  content: \"\\edfe\";\n  \n}\n.icon-Cloud-fog .path2:before {\n  content: \"\\edff\";\n  margin-left: -1em;\n  \n  opacity: 0.3;\n}\n.icon-Cloud-sun .path1:before {\n  content: \"\\ee00\";\n  \n  opacity: 0.3;\n}\n.icon-Cloud-sun .path2:before {\n  content: \"\\ee01\";\n  margin-left: -1em;\n  \n}\n.icon-Cloud-wind .path1:before {\n  content: \"\\ee02\";\n  \n}\n.icon-Cloud-wind .path2:before {\n  content: \"\\ee03\";\n  margin-left: -1em;\n  \n  opacity: 0.3;\n}\n.icon-Cloud-wind .path3:before {\n  content: \"\\ee04\";\n  margin-left: -1em;\n  \n  opacity: 0.3;\n}\n.icon-Cloudy .path1:before {\n  content: \"\\ee05\";\n  \n  opacity: 0.3;\n}\n.icon-Cloudy .path2:before {\n  content: \"\\ee06\";\n  margin-left: -1em;\n  \n}\n.icon-Cloudy-night .path1:before {\n  content: \"\\ee07\";\n  \n  opacity: 0.3;\n}\n.icon-Cloudy-night .path2:before {\n  content: \"\\ee08\";\n  margin-left: -1em;\n  \n}\n.icon-Day-rain .path1:before {\n  content: \"\\ee09\";\n  \n  opacity: 0.3;\n}\n.icon-Day-rain .path2:before {\n  content: \"\\ee0a\";\n  margin-left: -1em;\n  \n}\n.icon-Fahrenheit .path1:before {\n  content: \"\\ee0b\";\n  \n}\n.icon-Fahrenheit .path2:before {\n  content: \"\\ee0c\";\n  margin-left: -1em;\n  \n  opacity: 0.3;\n}\n.icon-Fog:before {\n  content: \"\\ee0d\";\n}\n.icon-Moon:before {\n  content: \"\\ee0e\";\n}\n.icon-Night-fog .path1:before {\n  content: \"\\ee0f\";\n  \n}\n.icon-Night-fog .path2:before {\n  content: \"\\ee10\";\n  margin-left: -1em;\n  \n  opacity: 0.3;\n}\n.icon-Night-rain .path1:before {\n  content: \"\\ee11\";\n  \n  opacity: 0.3;\n}\n.icon-Night-rain .path2:before {\n  content: \"\\ee12\";\n  margin-left: -1em;\n  \n}\n.icon-Rain .path1:before {\n  content: \"\\ee13\";\n  \n}\n.icon-Rain .path2:before {\n  content: \"\\ee14\";\n  margin-left: -1em;\n  \n  opacity: 0.3;\n}\n.icon-Rain1 .path1:before {\n  content: \"\\ee15\";\n  \n}\n.icon-Rain1 .path2:before {\n  content: \"\\ee16\";\n  margin-left: -1em;\n  \n  opacity: 0.3;\n}\n.icon-Rain2 .path1:before {\n  content: \"\\ee17\";\n  \n  opacity: 0.3;\n}\n.icon-Rain2 .path2:before {\n  content: \"\\ee18\";\n  margin-left: -1em;\n  \n}\n.icon-Rainbow .path1:before {\n  content: \"\\ee19\";\n  \n  opacity: 0.3;\n}\n.icon-Rainbow .path2:before {\n  content: \"\\ee1a\";\n  margin-left: -1em;\n  \n}\n.icon-Snow .path1:before {\n  content: \"\\ee1b\";\n  \n}\n.icon-Snow .path2:before {\n  content: \"\\ee1c\";\n  margin-left: -1em;\n  \n  opacity: 0.3;\n}\n.icon-Snow1 .path1:before {\n  content: \"\\ee1d\";\n  \n}\n.icon-Snow1 .path2:before {\n  content: \"\\ee1e\";\n  margin-left: -1em;\n  \n  opacity: 0.3;\n}\n.icon-Snow2 .path1:before {\n  content: \"\\ee1f\";\n  \n  opacity: 0.3;\n}\n.icon-Snow2 .path2:before {\n  content: \"\\ee20\";\n  margin-left: -1em;\n  \n}\n.icon-Snow3:before {\n  content: \"\\ee21\";\n}\n.icon-Storm .path1:before {\n  content: \"\\ee22\";\n  \n}\n.icon-Storm .path2:before {\n  content: \"\\ee23\";\n  margin-left: -1em;\n  \n  opacity: 0.3;\n}\n.icon-Sun .path1:before {\n  content: \"\\ee24\";\n  \n}\n.icon-Sun .path2:before {\n  content: \"\\ee25\";\n  margin-left: -1em;\n  \n  opacity: 0.3;\n}\n.icon-Sun-fog .path1:before {\n  content: \"\\ee26\";\n  \n}\n.icon-Sun-fog .path2:before {\n  content: \"\\ee27\";\n  margin-left: -1em;\n  \n  opacity: 0.3;\n}\n.icon-Suset .path1:before {\n  content: \"\\ee28\";\n  \n}\n.icon-Suset .path2:before {\n  content: \"\\ee29\";\n  margin-left: -1em;\n  \n  opacity: 0.3;\n}\n.icon-Suset1 .path1:before {\n  content: \"\\ee2a\";\n  \n}\n.icon-Suset1 .path2:before {\n  content: \"\\ee2b\";\n  margin-left: -1em;\n  \n  opacity: 0.3;\n}\n.icon-Temperature-empty:before {\n  content: \"\\ee2c\";\n}\n.icon-Temperature-full:before {\n  content: \"\\ee2d\";\n}\n.icon-Temperature-half:before {\n  content: \"\\ee2e\";\n}\n.icon-Thunder .path1:before {\n  content: \"\\ee2f\";\n  \n  opacity: 0.3;\n}\n.icon-Thunder .path2:before {\n  content: \"\\ee30\";\n  margin-left: -1em;\n  \n}\n.icon-Thunder-night .path1:before {\n  content: \"\\ee31\";\n  \n  opacity: 0.3;\n}\n.icon-Thunder-night .path2:before {\n  content: \"\\ee32\";\n  margin-left: -1em;\n  \n}\n.icon-Umbrella .path1:before {\n  content: \"\\ee33\";\n  \n}\n.icon-Umbrella .path2:before {\n  content: \"\\ee34\";\n  margin-left: -1em;\n  \n  opacity: 0.3;\n}\n.icon-Wind .path1:before {\n  content: \"\\ee35\";\n  \n}\n.icon-Wind .path2:before {\n  content: \"\\ee36\";\n  margin-left: -1em;  \n  opacity: 0.3;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
